// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/fonts/Quicksand-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Assets/fonts/Quicksand-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Assets/fonts/Quicksand-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../Assets/fonts/Quicksand-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Assets/fonts/Quicksand-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Assets/fonts/Outfit-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../Assets/fonts/Outfit-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../Assets/fonts/Outfit-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../Assets/fonts/Outfit-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../Assets/fonts/circular-bold.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../Assets/fonts/Circular-Std-Regular-Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../Assets/fonts/Jost-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../Assets/LoginScreen/LoginBanner1.1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../Assets/LoginScreen/LoginBanner2.1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../Assets/LoginScreen/LoginBanner3.1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../Assets/OrderScreen/HomeIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../Assets/OrderScreen/ReorderIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../Assets/OrderScreen/FavouriteIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../Assets/MyInformation/Infobackground.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../Assets/OrderScreen/OrderBackground.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../Assets/Payment/checked.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../Assets/Payment/coupon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../Assets/Payment/dropdown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font: normal !important;
  /* -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none; */
}

*,
::after,
::before {
  box-sizing: border-box;
}

.qvrow {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.qvrow > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col-qv-6 {
  flex: 0 0 auto;
  width: 50%;
}

/* remove this for focus border in input border: 2px solid #0A64F9 !important; */

p {
  margin: 0;
  padding: 0;
  margin-bottom: 0px!important;
}

input:hover,
input:focus,
Input:hover,
Input:focus {
  background-color: none !important;
  background: none;
}

@font-face {
  font-family: QuicksandLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: QuicksandLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: QuicksandBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: QuicksandMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: QuicksandRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: QuicksandSemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: QuicksandLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: OutfitSemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: OutfitMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

@font-face {
  font-family: OutfitBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

@font-face {
  font-family: OutfitRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
@font-face {
  font-family: circular-bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
@font-face {
  font-family: Circular-Std-Regular-Book;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
/* 
@font-face {
  font-family: QuicksandBold;
  src: url(https://fonts.googleapis.com/css2?family=Quicksand:wght@700&display=swap);
}

@font-face {
  font-family: QuicksandMedium;
  src: url(https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap);
}

@font-face {
  font-family: QuicksandRegular;
  src: url(https://fonts.googleapis.com/css2?family=Quicksand&display=swap);
}

@font-face {
  font-family: QuicksandSemiBold;
  src: url(https://fonts.googleapis.com/css2?family=Quicksand:wght@600&display=swap);
} */

@font-face {
  font-family: Jost;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

/* main authentication component */
.main-authentication-component {
  /* display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; */
  /* padding: 15px; */
}

.wrapper {
  width: 55%;
  /* margin-left: auto; */
  border-radius: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  justify-self: stretch;
  height: 95vh;
  animation: slider 10s infinite;
}

.my-overflow-hanlde-for-authentication {
  /* padding: 20px 60px 20px 0; */
  height: 95vh;
  justify-content: flex-start !important;
  overflow-y: auto;
  scroll-behavior: smooth;
  overflow-x: hidden;
}

@media (max-width: 1024px) {
  .my-overflow-hanlde-for-authentication {
    overflow-y: unset;
    scroll-behavior: smooth;
    overflow-x: unset;
  }
}

/* width */
.my-overflow-hanlde-for-authentication::-webkit-scrollbar {
  width: 3px;
}

/* Track */
.my-overflow-hanlde-for-authentication::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  cursor: pointer;
}

/* Handle */
.my-overflow-hanlde-for-authentication::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
.my-overflow-hanlde-for-authentication::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

@keyframes slider {
  0% {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    background-size: cover;
    background-position: center;
  }

  30% {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-size: cover;
    background-position: center;
  }

  60% {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-size: cover;
    background-position: center;
  }

  100% {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    background-size: cover;
    background-position: center;
  }
}

/*Customer Login*/
@media screen and (max-width: 900px) {
  .my-overflow-hanlde-for-authentication {
    /* overflow-x: hidden; */
    padding: 20px 40px 20px 0;
  }
}

@media screen and (max-width: 750px) {
  .login-customer-form {
    margin-right: 20px;
  }
}

@media screen and (max-width: 678px) {
  .wrapper {
    display: none;
  }

  .my-overflow-hanlde-for-authentication {
    /* overflow: auto; */
    padding: 0px;
    height: auto;
  }
}

@media screen and (max-width: 600px) {
  .wrapper {
    display: none;
  }

  .quickvee-logo-authentication {
    /* width: 150px !important; */
  }

  .back-auth-icons {
    top: 7px !important;
    left: 1% !important;
  }
}

.quickvee-logo-authentication {
  width: 160px;
  margin: 0 0 30px 0;
}

.css-18djxyj-MuiPaper-root-MuiAlert-root {
  padding: 6px 10px !important;
}

.login-customer-form {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.input-error {
  /* display: inherit; */
  /* right: 0; */
  margin: 3px !important;
  padding: 0px !important;
  /* float: left !important; */
  /* justify-self: right; */
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 11px !important;
  color: #fa0000 !important;
}

.login-customer-form > h1 {
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 19px;
  color: #222222 !important;
}

.login-customer-form .sub-heading-from {
  font-family: QuicksandMedium, 'Quicksand' !important;
  font-size: 14px;
  color: #232323 !important;
  margin: 10px 0 25px 0;
}

.sub-heading-from {
  width: 300px;
}

.password-input-field {
  display: flex;
  max-width: 100%;
  width: 300px;
  font-size: 12px !important;
  background: #ffffff;
  font-family: QuicksandMedium, 'Quicksand' !important;
  /* background: #FFFFFF !important;
  border: 1px solid #D3D3D3 !important;
  border-radius: 6px !important; */
}

.password-input-field:focus-within {
  border: 2px solid #0a64f9 !important;
}

.customer-login-input {
  max-width: 100%;
  width: 300px;
  font-size: 12px !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
  /* background: #FFFFFF !important;
  border: 1px solid #D3D3D3 !important;
  border-radius: 6px !important; */
}

.customer-login-input .css-1njz7x1,
.password-input-field .css-1njz7x1,
.payment-billing-input .css-1njz7x1 {
  font-size: 13px !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
  color: #595959 !important;
}

.customer-login-input .css-dvhgws,
.password-input-field .css-dvhgws,
.payment-billing-input .css-dvhgws {
  background: #ffffff !important;
  /* border: 1px solid #d3d3d3 !important; */
  border-radius: 6px !important;
}

.css-s2lqj8,
.css-s2lqj8.Mui-focused {
  font-size: 13px !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
}

.modal-form-single-input .css-s2lqj8,
.modal-form-single-input .css-ftr4jk {
  font-size: 13px !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  color: #000000;
}

.modal-form-single-item .css-17gq4vl.MuiSelect-select {
  font-size: 13px !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  color: #000000 !important;
}

.modal-form-single-item .css-17gq4vl:focus {
  background-color: #fff !important;
}

.modal-form-single-item .css-1thjcug:hover {
  background-color: #fff !important;
}

.css-1thjcug:hover {
  background-color: #fff !important;
}

.css-fi4tqy {
  padding: 14px 12px 4px !important;
  font: unset !important;
  font-size: 15px !important;
  font-family: QuicksandSemiBold !important;
}

.modal-form-single-input .css-fi4tqy {
  padding: 18px 12px 4px !important;
  font: unset !important;
  font-size: 15px !important;
  height: 1.98rem;
  font-family: QuicksandSemiBold !important;
}
.css-2bxn45 {
  padding: 22px 12px 8px !important;
}
.customer-login-input > div .css-dvhgws:hover,
.customer-login-input .css-dvhgws.Mui-focused,
.password-input-field > div .css-dvhgws:hover,
.password-input-field .css-dvhgws.Mui-focused {
  background: #ffffff !important;
}

.password-input-field
  .css-dvhgws:hover:not(
    .Mui-disabled,
    .password-input-field .Mui-error
  )::before,
.password-input-field .css-dvhgws:hover:not(.Mui-disabled, .Mui-error)::before,
.customer-login-input
  .css-dvhgws:hover:not(
    .Mui-disabled,
    .customer-login-input .Mui-error
  )::before,
.customer-login-input .css-dvhgws:hover:not(.Mui-disabled, .Mui-error)::before {
  border-bottom: none !important;
}

.customer-login-input .css-dvhgws::before,
.password-input-field .css-dvhgws::before,
.payment-billing-input .css-dvhgws::before {
  border-bottom: none !important;
}

.css-dvhgws::after {
  border-bottom: none !important;
}

/* .customer-login-error-input{
  border: 1px solid #F55353 !important;
} */

.customer-login-input:focus-within,
.password-input-field:focus-within {
  border: 2px solid #0a64f9 !important;
  border-radius: 6px !important;
}

.modal-form-single-input .css-1thjcug.Mui-focused {
  background-color: #fff !important;
}

.modal-form-single-input .css-1thjcug {
  background-color: #fff !important;
}

.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root:hover {
  border-color: #911b1b !important;
}

.css-17mgbju::before,
.css-1thjcug::before,
.css-17mgbju::after,
.css-1thjcug::after {
  border: none !important;
}

.css-1ff8729-MuiInputBase-root-MuiFilledInput-root {
  background: none !important;
  top: 8px !important;
  font-size: 14px !important;
}

.css-1ff8729-MuiInputBase-root-MuiFilledInput-root:before {
  border: none !important;
}

.css-1ff8729-MuiInputBase-root-MuiFilledInput-root:after {
  border: none !important;
}

.css-1mog9k0-MuiFormLabel-root-MuiInputLabel-root {
  font-size: 13px !important;
  color: #595959 !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
}

.css-11qvwfa-MuiFormLabel-root-MuiInputLabel-root {
  font-size: 14px !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
}

.css-11qvwfa-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {
  font-size: 14px !important;
  color: #595959 !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
}

.css-c5v1qu-MuiInputBase-input-MuiFilledInput-input:focus,
.css-c5v1qu-MuiInputBase-input-MuiFilledInput-input {
  padding-top: 13px !important;
  padding-bottom: 10px !important;
  font-family: QuicksandSemibold, 'Quicksand' !important;
}

.css-yf8vq0-MuiSelect-nativeInput {
  font-family: QuicksandSemibold, 'Quicksand' !important;
}

.css-6hp17o-MuiList-root-MuiMenu-list > li {
  /* color: #0A64F9 !important; */
  font-size: 12px;
  font-family: QuicksandSemibold, 'Quicksand' !important;
}

.css-1gctnaj-MuiInputBase-input-MuiFilledInput-input {
  font-family: QuicksandSemibold, 'Quicksand' !important;
}

.input-outer-div {
  position: relative;

  display: flex;
  flex-direction: column;
  margin: 9px 0;
}

.css-1pysi21-MuiFormLabel-root-MuiInputLabel-root {
  font-size: 14px !important;
  color: #595959 !important;
}

.error-on-submit {
  align-self: flex-start !important;
  text-transform: capitalize;
  font-family: QuicksandRegular, 'Quicksand' !important;
  font-size: 11px !important;
  color: #fa0000 !important;
}

.css-1e6y48t-MuiButtonBase-root-MuiButton-root.Mui-focusVisible {
  background-color: #fff !important;
}

.form-submit-error-message {
  position: relative;
  right: 0px;
  bottom: -15px;
  animation: slideTopError 0.8s;
}

.css-1pxa9xg-MuiAlert-message {
  text-transform: capitalize !important;
  font-family: QuicksandSemibold !important;
}

@keyframes slideTopError {
  0% {
    opacity: 0;
    right: 0px;
    bottom: -35px;
  }

  100% {
    opacity: 1;
    right: 0px;
    bottom: -8px;
  }
}

.error-close-icon {
  color: #000 !important;
  background-color: #fff !important;
}

.customer-login-input::placeholder {
  color: #595959 !important;
}

/* .password-input-field {
  display: flex;
  max-width: 100%;
  width: 300px;
  font-size: 10px !important;
  background: #FFFFFF;
  border-radius: 6px !important;
  font-family: QuicksandMedium !important;
  border: 2px solid #D3D3D3;
  border-radius: 6px;
} */
.unvisible-input {
  display: none !important;
}

.customer-banner-authentication {
  display: flex;
  align-items: 'center' !important;
  justify-content: space-around !important;
  flex-direction: row !important;
  flex-wrap: nowrap;
  vertical-align: middle !important;
  margin: 3vh 3vw;
}

.password-input-text,
.password-input-text:hover {
  outline-style: none;
  border-style: none;
  border: none;
  color: #595959 !important;
  font-size: 14px;
}

.css-c5v1qu-MuiInputBase-input-MuiFilledInput-input {
  color: #000000 !important;
  font: normal !important;
  letter-spacing: normal !important;
}

.forgot-password {
  align-self: end !important;
  font-size: 14px !important;
  text-decoration: underline !important;
  color: #0a64f9 !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
}

.customer-btn {
  width: 100%;
  width: 300px;
  margin: 20px 0 !important;
  background-color: #0a64f9 !important;
  text-transform: capitalize !important;
  font-size: 16px !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  height: 44px;
}

.sign-in-section-head {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #222222;
  font-size: 14px;
  font-family: QuicksandRegular, 'Quicksand' !important;
}

.sign-in-section-head > p {
  color: #222222;
  font-size: 13px;
  font-family: QuicksandRegular, 'Quicksand' !important;
}

.css-1pysi21-MuiFormLabel-root-MuiInputLabel-root,
.css-yjsfm1 > span {
  font-size: 13px !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
  color: #595959 !important;
}

.sign-in-section-head > span > hr {
  margin: 0 15px;
  rotate: 90deg;
  height: 15px;
  color: #707070;
}

.customer-login-with-google {
  display: flex;
  width: 100%;
  width: 300px;
  margin: 20px 0 !important;
  color: #222222 !important;
  text-transform: capitalize !important;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px !important;
  background: #ffffff !important;
  border: 2px solid #d3d3d3;
  border-radius: 6px;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
}

.customer-login-with-google > img {
  position: absolute !important;
  right: 0 !important;
  margin-right: 15px;
}

.login-customer-reduirection {
  font-family: QuicksandMedium, 'Quicksand' !important;
  letter-spacing: 0px;
  color: #595959;
  font-size: 13px;
  margin: 5px 0 !important;
}

.login-customer-reduirection > .login-customer-reduirection-link {
  font-family: QuicksandBold, 'Quicksand' !important;
  color: #222222 !important;
  font-weight: 800 !important;
  margin: 0 2px;
  font-size: 13px;
  text-decoration: none !important;
}

.back-auth-icons {
  position: absolute;
  top: 25px;
  left: 5%;
  background: none !important;
  color: black;
}

.login-customer-reduirection > .login-customer-reduirection-link:hover {
  text-decoration: none !important;
}

/*end Customer Login*/

/* start Customer Register */

.register-inputs-div {
  display: flex;
  justify-content: space-between;
  width: 300px;
}

.c-register {
  width: 145px;
}

/* end customer registration */

/* start order history */
/* start top bar */

.main-order-top-bar {
  padding: 10px 3px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  position: sticky !important;
  top: 0 !important;
  background: #ffffff;
  border-bottom: 1px solid #ebebeb;
  z-index: 99;
}
@media (min-width: 768px) {
  .main-order-top-bar {
    padding: 10px 20px 10px 0px !important;
  }
}
.quickvee-logo-order-top-bar {
  width: 148px;
  height: 40px;
  margin-right: 0px;
}

.order-top-bar-search {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #f6f7f8;
  border-radius: 6px;
  /* padding: 2px 10px; */
  padding-left: 3%;
  padding-right: 3%;
  width: 35vw;
}

.online-o-page-profile-drop-btn {
  margin: 0px 0px 0px 8px;
}

@media (max-width: 768px) {
  .online-o-page-profile-drop-btn {
    display: none !important;
  }
}
.my-profile-drop-btn {
  margin: 0px 11px 0 8px;
}

.my-profile-drop-btn img {
  width: 20px;
}

.top-bar-button {
  flex-grow: 1;
  color: #232323 !important;
  font-family: QuicksandBold, 'Quicksand' !important;
  text-transform: capitalize !important;
}

.order-top-bar-search > .order-top-bar-search-input {
  background: #f6f7f8;
  padding: 3px 10px;
  width: 100% !important;
}

.order-top-bar-search > .order-top-bar-search-input,
.order-top-bar-search > .order-top-bar-search-input:focus,
.order-top-bar-search > .order-top-bar-search-input:active,
.order-top-bar-search > .order-top-bar-search-input:focus-within,
.order-top-bar-search > .order-top-bar-search-input:focus-visible {
  border: none;
  border-color: none !important;
}

.order-top-bar-search > .order-top-bar-search-input::placeholder {
  font-family: QuicksandRegular, 'Quicksand' !important;
  font-size: 15px;
  color: #a8a8a8;
}

.css-q0jhri-MuiInputBase-root-MuiInput-root {
  font-family: QuicksandSemibold, 'Quicksand' !important;
}

input[type='search']::-webkit-search-cancel-button {
  -webkit-appearance: none;
  cursor: pointer;
  height: 20px;
  width: 20px;
  border-radius: 50em;
  background: url(https://pro.fontawesome.com/releases/v5.10.0/svgs/solid/times-circle.svg)
    no-repeat 50% 50%;
  background-size: contain;
  opacity: 0;
  pointer-events: none;
}

input[type='search']:focus::-webkit-search-cancel-button {
  opacity: 0.3;
  pointer-events: all;
}

.order-top-bar-search-icon {
  rotate: 90deg;
  margin-right: 5px;
}

.order-top-bar-search-input::after,
.order-top-bar-search-input::before {
  border: none !important;
}

/* end top bar */

/* start side bar */

.order-side-bar-component {
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 250px;
  overflow: hidden;
  height: 100%;
  border-right: 1px solid #ebebeb;
  position: fixed;
  background-color: #fff;
  /* padding: 20px 0 0 0; */
  transition: all 0.3s ease-in-out;
  left: 0;
}

@media (min-width: 768px) {
  .order-side-bar-component {
    width: 250px !important;
    transition: width 0.3s ease-in-out;
    /* Adjust width for smaller screens */
  }
}

@media (max-width: 767px) {
  .order-history-main-component {
    margin-left: 0px !important;
  }

  .order-history-main-component > .order-history-top-component > h1 {
    font-size: 18px !important;
  }

  .basic-modal {
    width: 90%;
  }
}

.order-side-bar-component > .order-side-bar-link,
.order-side-bar-component > div .order-side-bar-link-div {
  text-decoration: none !important;
}

.order-side-bar-component > .order-side-bar-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0px 10px 0px 20px;
  padding: 11px 10px;
  color: #2e2e2e;
}

.order-side-bar-component > .order-side-bar-link:hover {
  color: #6e81e2;
  background: #f1f6ff;
  border-radius: 5px;
}

.order-side-bar-component > .order-side-bar-link > .link-home {
  background: #2e2e2e;
  width: 20px;
  height: 200%;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat 0px;
  transition: all 0.2s ease-in;
}

.order-side-bar-component > .order-side-bar-link:hover > .link-home {
  background: #6e81e2;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat 0px;
}

.order-side-bar-component > .order-side-bar-link > .link-reorder {
  background: #2e2e2e;
  width: 20px;
  height: 200%;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat 0px;
  transition: all 0.2s ease-in;
}

.order-side-bar-component > .order-side-bar-link:hover > .link-reorder {
  background: #6e81e2;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat 0px;
}

.order-side-bar-component > .order-side-bar-link > .link-wishlist {
  background: #2e2e2e;
  width: 20px;
  height: 200%;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat 0px;
  transition: all 0.2s ease-in;
}

.order-side-bar-component > .order-side-bar-link:hover > .link-wishlist {
  background: #6e81e2;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat 0px;
}

.order-side-bar-component > .order-side-bar-link > span {
  color: #2e2e2e;
  margin-left: 10px;
  font-family: QuicksandSemibold, 'Quicksand' !important;
  font-size: 14px;
  padding: 0 10px;
}

.order-side-bar-component > .order-side-bar-link:hover > span {
  color: #6e81e2;
}

.order-side-bar-component > div .order-side-bar-link-div {
  display: flex;
  align-items: center;
  color: #2e2e2e !important;
  font-family: QuicksandSemibold !important;
  padding: 10px 0px !important;
  border-left: 3px solid #ffffff;
  padding-left: 20px !important;
  font-size: 15px;
}

.order-side-bar-component > div {
  display: flex;
  /* margin-top: 20px; */
  flex-direction: column;
  width: 100% !important;
  transition: all 2s ease-in-out;
}

.order-side-bar-component > div .order-side-bar-link-div {
  transition: all 0.3s ease-in-out;
}

/* .order-side-bar-component > div .order-side-bar-link-div:hover{
  background: #F5F5F5;
  border-left: 3px solid #222222;
  color: #232323;
  font-family: QuicksandBold !important;
} */

.order-side-bar-component > div .orderhistoryclass,
.order-side-bar-component > div .accountinfoclass,
.order-side-bar-component > div .homeclass,
.order-side-bar-component > div .LoyaltyPointsZone {
  background: #f5f5f5;
  border-left: 3px solid #222222;
  color: #232323;
  font-family: QuicksandBold, 'Quicksand' !important;
}

/* end side bar */

/* start main order page */
.side-bar-and-order-section {
  display: flex;
  background: #ffffff;
}

.order-history-main-component {
  width: 100%;
  padding: 20px 20px 40px 20px;
  margin-left: 250px;
  min-height: calc(100vh - 137px) !important;
  /* height: 85vh; */
}

.order-history-main-component > .order-history-top-component {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.order-history-main-component > .order-history-top-component > h1 {
  font-size: 24px;
  /* margin-left: 10px; */
  color: #212121;
  font-family: QuicksandBold, 'Quicksand' !important;
}

.order-history-main-component
  > .order-history-top-component
  > .order-history-button-grp {
  background: #efefef;
  border-radius: 5px;

  padding: 6px 6px;
}

.order-history-main-component
  > .order-history-top-component
  > .order-history-button-grp
  > Button {
  background: #efefef;
  color: #928c8c;
  text-transform: capitalize;
  font-size: 14px;
  font-family: QuicksandMedium, 'Quicksand' !important;
  transition: all 0.3s ease-in-out;
  padding: 6px 15px !important;
}

@media (max-width: 496px) {
  .order-history-main-component
    > .order-history-top-component
    > .order-history-button-grp
    > Button {
    font-size: 10px;
  }

  .order-history-main-component > .order-history-top-component {
    width: 100%;
  }
}

.order-history-main-component
  > .order-history-top-component
  > .order-history-button-grp
  > Button.openorders,
.order-history-main-component
  > .order-history-top-component
  > .order-history-button-grp
  > Button.closeorders {
  color: #ffffff;
  background: #222222 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 12px #00000042;
}

.order-history-bottom-component {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 10px 0;
}

.no-open-and-close-order {
  width: 100%;
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.no-open-and-close-order img {
  width: 80px;
  margin-bottom: 20px;
}

.no-open-and-close-order h1 {
  font-family: QuicksandSemiBold !important;
  font-size: 19px;
  color: #232323;
}

.no-open-and-close-order p {
  font-family: QuicksandSemiBold !important;
  font-size: 13px;
  color: #878787;
  margin-bottom: 15px;
}

.no-open-and-close-order .start-shopping-on-order {
  color: #0a64f9;
  width: 200px;
  border: 2px solid #0a64f9;
  background: #fff;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
  text-transform: capitalize !important;
  background: #ffffff;
  border-radius: 5px;
}

.start-shopping-on-order:hover {
  background: #fff !important;
}

.start-shopping-on-order a {
  text-decoration: none;
  color: #0a64f9;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
}

/* end main order page*/

/*  start order Account info */

.account-info-main-component {
  padding: 20px 40px;
  margin-left: 250px;
  width: 60%;
}

@media screen and (max-width: 1200px) {
  .account-info-main-component {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .account-info-main-component {
    /* margin-left: 2; */
    margin: 0 auto;
    padding: 15px;
    /* display: flex; */
    flex-wrap: wrap;
    max-width: 100%;
  }
}

.account-info-main-component > .account-info-welcome-header {
  display: flex;
  align-items: flex-end;
  padding: 30px;
  justify-content: space-between;
  background: var(--unnamed-color-0a64f9) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-707070);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid #707070;
  border-radius: 5px;
}

.account-info-main-component > .account-info-welcome-header > h1 {
  color: #ffffff;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 25px;
}

.account-info-main-component > .account-info-welcome-header > p {
  color: #ffffff;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 15px;
}

.account-info-subheading {
  color: #707070;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 10px;
  margin: 15px 0;
}

.account-info-subheading > p {
  color: #707070;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 12px;
}

.account-info {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  padding: 15px 20px;
  margin: 20px 0;
}

.account-info > .account-info-top-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.account-info > .account-info-top-section > span {
  text-transform: capitalize;
  color: #212121;
  font-size: 16px;
  font-family: QuicksandBold, 'Quicksand' !important;
}

.account-info-bottom-section {
  width: 100%;
}
.account-info > .account-info-bottom-section > div {
  /* display: flex; */
  align-items: top;
  padding: 10px 10px 10px 0;
  /* margin: 10px 10px 10px 0; */
  /* margin-left: 5px; */
  margin-bottom: 5px;
  /* justify-content: flex-start; */
}

@media (min-width: 1200px) {
  .css-1lj5egr-MuiGrid-root {
    max-width: 32.33% !important;
  }
}

@media (min-width: 900px) {
  .css-1lj5egr-MuiGrid-root {
    max-width: 32.33% !important;
  }
}

.account-info > .account-info-bottom-section > .account-info-single {
  display: flex;
  /* align-items: center; */
  padding: 10px 10px 10px 0px;
  border-bottom: 1px solid #e1e1e1;
}

@media (max-width: 480px) {
  .span-before-driving-licence-image {
    display: none;
  }
  .account-info-single {
    justify-content: center;
  }
}

.account-info > .account-info-bottom-section > div > span:first-child {
  color: #707070;
  font-size: 13px;
  font-family: QuicksandSemibold, 'Quicksand' !important;
  width: 30%;
}

.account-info > .account-info-bottom-section > div > .driving-licence-image {
  width: 299px;
  border-radius: 5px;
}

.account-info > .account-info-bottom-section > div > span:nth-child(2) {
  color: #232323;
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 13px;
  justify-self: flex-end;
  width: 70%;
  text-transform: capitalize !important;
}

.card-info-important {
  color: #707070;
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 13px;
}

.basic-modal {
  position: absolute;
  top: 50% !important;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  /* width: 100%; */
  box-shadow: 1px 1px 6px black;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 8px;
  padding: 10px 0;
  max-height: 94vh;
  overflow: hidden;
}

.for-scroll {
  overflow-y: scroll !important;
}

.basic-modal > #modal-modal-title {
  padding: 5px 15px 11px 15px;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  border-bottom: 1px solid #d3d3d3;
}

.basic-modal > #modal-modal-title > span {
  color: #212121;
  text-transform: capitalize;
  font-size: 20px;
  font-family: QuicksandBold, 'Quicksand' !important;
}

@media (max-width: 767px) {
  .basic-modal > #modal-modal-title > span {
    font-size: 18px;
  }
}

.basic-modal > #modal-modal-title > .modal-close-icon {
  cursor: pointer;
}

.basic-modal > #modal-modal-title > .modal-close-button {
  display: inline-flex;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: #1d2939;
  cursor: pointer;
}

.basic-modal > #modal-modal-title > .modal-close-button:hover {
  background: #f2f4f7;
}

.basic-modal > #modal-modal-title > .modal-close-button:focus-visible {
  outline: 3px solid rgba(10, 100, 249, 0.25);
  outline-offset: 2px;
}

.basic-modal > #modal-modal-title > .modal-close-button img {
  width: 22px;
  height: 22px;
}

.basic-modal > .modal-forms {
  padding: 15px;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;
  width: 100%;
}

.modal-forms .css-13sljp9 {
  width: 100%;
}

.basic-modal .modal-forms > .css-1nrlq1o-MuiFormControl-root {
  width: 100%;
  margin-bottom: 15px;
}

.modal-form-single-item {
  display: flex !important;
  flex-direction: column !important;
  margin: 0px 0px 10px !important;
  width: 100% !important;
}

.password-margin-bottom {
  margin-bottom: 15px !important;
}

.modal-form-single-item .css-14x1nlk,
.modal-form-single-item .css-14x1nlk {
  color: #595959 !important;
  font-family: QuicksandMedium, Quicksand !important;
  font-size: 13px !important;
}

.modal-form-single-item .css-1rgmeur {
  color: #595959 !important;
  font-family: QuicksandSemiBold !important;
  font-size: 14px !important;
}

.modal-form-single-input label {
  color: #595959 !important;
  font-family: QuicksandSemiBold !important;
  font-size: 14px !important;
}

.modal-form-single-input {
  width: 100%;
  font-size: 12px !important;
  background: #ffffff;
  font-family: QuicksandMedium, 'Quicksand' !important;
  background: #ffffff !important;
  border: 1px solid #d3d3d3 !important;
  border-radius: 6px !important;
}

.modal-form-single-input .css-dvhgws {
  background: #ffffff !important;
  /* border: 1px solid #D3D3D3 !important; */
  border-radius: 6px !important;
}

.modal-form-single-input .css-dvhgws:hover,
.modal-form-single-input .css-dvhgws.Mui-focused {
  background: #ffffff !important;
}

.modal-form-single-input
  .css-dvhgws:hover:not(
    .Mui-disabled,
    .modal-form-single-input .Mui-error
  )::before,
.modal-form-single-input
  .css-dvhgws:hover:not(.Mui-disabled, .Mui-error)::before {
  border-bottom: none !important;
}

.modal-form-single-input .css-dvhgws::before {
  border-bottom: none !important;
}

.modal-form-single-input .css-1njz7x1 {
  font-size: 13px !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
  color: #595959 !important;
}

.modal-form-single-input:focus-within {
  border: 1px solid #000000 !important;
}

.modal-form-single-input::placeholder {
  color: #595959 !important;
}

.modal-main-button {
  color: #0a64f9 !important;
  text-transform: capitalize !important;
  font-size: 14px !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
}
.css-1e6y48t-MuiButtonBase-root-MuiButton-root {
  min-width: unset !important;
}
.basic-modal > .modal-forms > .modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 14px 0 0 0;
}

.basic-modal > .modal-forms > .modal-footer > .modal-cancle-btn {
  background: #ffffff !important;
  border: 1px solid #232323 !important;
  border-radius: 6px !important;
  color: #232323 !important;
  text-transform: capitalize !important;
  font-family: QuicksandBold, 'Quicksand' !important;
  width: 48%;
  height: 44px;
}

.basic-modal > .modal-forms > .modal-footer > .modal-save-btn {
  background: #0a64f9;
  border: 2px solid #0a64f9 !important;
  border-radius: 6px;
  color: #ffffff;
  text-transform: capitalize !important;
  font-family: QuicksandBold, 'Quicksand' !important;
  width: 48%;
  height: 44px;
}

/* Scoped fixes for checkout/account address add/edit modal */
.address-modal {
  display: flex;
  flex-direction: column;
  max-height: min(94vh, 760px);
}

.address-modal > #modal-modal-title {
  flex-shrink: 0;
}

.address-modal > .address-modal-form {
  flex: 1 1;
  overflow-y: auto;
  padding: 15px 15px 18px;
}

.address-modal-form .address-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 10px;
  row-gap: 10px;
}

.address-modal-form .address-field-group {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.address-modal-form .address-field-full {
  grid-column: 1 / -1;
}

.address-modal-form .address-state-zip-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.address-modal-form .address-form-label {
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 14px;
  line-height: 1.25;
  color: #232323;
  margin-bottom: 4px;
}

.address-modal .input-error,
.address-modal .MuiFormHelperText-root {
  position: static !important;
  display: block !important;
  min-height: 15px;
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
  white-space: normal !important;
  word-break: break-word;
  line-height: 1.2;
  margin-top: 4px !important;
  margin-left: 0 !important;
  color: #fa0000 !important;
}

.address-modal .address-field-error {
  position: static !important;
  display: block !important;
  min-height: 0;
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
  white-space: normal !important;
  word-break: break-word;
  line-height: 1.2;
  margin-top: 3px !important;
  margin-left: 0 !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 12px !important;
  color: #fa0000 !important;
}

.address-modal .address-field-error:empty {
  display: none !important;
  margin-top: 0 !important;
}

.address-modal-form .address-submit-error-row {
  margin-top: 4px;
  margin-bottom: 8px;
}

.address-modal-form .row > [class*='col'] {
  margin-bottom: 12px !important;
}

@media (max-width: 768px) {
  .address-modal-form .row > [class*='col'] {
    margin-bottom: 12px !important;
  }
}

.address-modal .error-on-submit {
  display: block;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 11px;
  color: #fa0000;
  line-height: 1.25;
}

.address-modal .modal-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #fff;
  padding-top: 10px;
  margin-top: 10px !important;
}

@media (max-width: 768px) {
  .address-modal {
    width: 95%;
    max-height: 92vh;
    border-radius: 12px;
  }

  .address-modal > .address-modal-form {
    padding: 12px 12px 16px;
  }

  .address-modal-form .address-form-grid {
    grid-template-columns: 1fr;
    row-gap: 10px;
  }

  .address-modal-form .address-state-zip-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .address-modal .modal-footer > .modal-cancle-btn,
  .address-modal .modal-footer > .modal-save-btn {
    height: 48px;
    font-size: 18px;
    line-height: 1;
  }
}

.account-info > .account-info-top-section > .account-password-top-section {
  display: flex;
  align-items: center;
}

.account-info
  > .account-info-top-section
  > .account-password-top-section
  > span {
  text-transform: capitalize;
  color: #212121;
  font-size: 16px;
  font-family: QuicksandBold, 'Quicksand' !important;
}

.account-info > .account-info-top-section > div > p {
  text-transform: capitalize;
  color: #707070 !important;
  font-size: 12px;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  /* margin-left: 86px !important; */
}

.account-info-bottom-section .single-delivery-address {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  /* width: 31%; */
  padding: 10px !important;
}

.account-info-bottom-section
  .single-delivery-address
  > .single-delivery-address-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.account-info-bottom-section
  .single-delivery-address
  > .single-delivery-address-content {
  width: 100%;
  margin: 10px 0;
  text-transform: capitalize;
}

.account-info-bottom-section
  .single-delivery-address
  > .single-delivery-address-footer {
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: flex-end; */
}

.account-info-bottom-section
  .single-delivery-address
  > .single-delivery-address-footer
  > .btn-remove-delivery-address
  > .delete-address-icon {
  width: 15px;
  height: 15px;
  margin: 5px;
}

.account-info-bottom-section
  .single-delivery-address
  > .single-delivery-address-footer
  > * {
  text-transform: capitalize !important;
  color: #222222 !important;
}

.my-custom-class-for-file-input::-webkit-file-upload-button,
.file-input-not-display::-webkit-file-upload-button {
  visibility: hidden !important;
}

.custom-file-upload-input {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  padding: 2px 15px 2px 15px;
  color: #fff;
  width: 100%;
}

/* .my-custom-class-for-file-input {
  color: #232323;
  font-family: QuicksandBold, 'Quicksand' !important;
  border-bottom: none;
  width: 50%;
} */

/* .my-custom-class-for-file-input::placeholder {
  color: red !important;
} */
.image-input-quickvee > .my-file-custom-input-for-image {
  color: #232323;
  font-size: 13px;
  font-family: QuicksandBold, 'Quicksand' !important;
  padding: 13px 13px 13px 0;
  /* cursor: pointer !important; */
  cursor: default;
  overflow: hidden;
  width: 70%;
}

/* .file-input-not-display::after{
  content: "Upload ID Card";
  color: #FFFFFF;
  font-family: QuicksandMedium !important;
  font-size: 14px ;
  background: #232323 0% 0% no-repeat padding-box;
border-radius: 3px;
padding: 7px 20px;
position: absolute;
right: 9px;
top: 10px;
cursor: pointer;
}  */

.button-update-id-card,
.button-update-id-card:hover {
  color: #0a64f9 !important;
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 14px !important;
  /* margin-right: 7px !important; */
  background-color: #fff !important;
  cursor: pointer;
  text-transform: capitalize !important;
}

.button-update-id-card img {
  margin-left: 5px !important;
}

.image-input-quickvee {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.account-info-bottom-section
  .single-delivery-address
  > .single-delivery-address-footer
  > .default-address {
  color: #0a64f9 !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  background: #d2e3ff !important;
  border-radius: 4px !important;
  font-size: 10px !important;
}

.account-info-bottom-section
  .single-delivery-address
  > .single-delivery-address-footer
  > .set-default-address {
  color: #0a64f9 !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  background: none !important;
  border-radius: 4px !important;
  font-size: 10px !important;
}

.btn-remove-delivery-address {
  margin: 0px !important;
  padding: 0px !important;
}

.remove-delivery-address {
  font-weight: 600;
  font-family: QuicksandRegular !important;
  line-height: 15px;
  color: #222222;
  font-size: 12px !important;
  border-bottom: 1px solid #222222;
  border-radius: unset !important;
}

.single-delivery-address .single-delivery-address-content > .receiver-name,
.receiver-address {
  color: #232323 !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 13px;
  margin: 3px 0;
}

.single-delivery-address
  > .single-delivery-address-content
  > .receiver-zipcode {
  color: #212121 !important;
  font-family: QuicksandRegular !important;
  font-size: 13px;
  text-transform: capitalize;
}

.delivery-address-update-form {
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 15px;
}

.delivery-address-update-form > div {
  width: 100%;
}

.delivery-address-update-form > div:first-child {
  margin: 0px 10px 0px 0px;
}

.delivery-city-state-update-inputs {
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  width: 55%;
}

.delivery-city-state-update-inputs label {
  color: #595959 !important;
  font-family: QuicksandSemiBold !important;
  font-size: 14px !important;
}

.delivery-city-state-update-inputs > div:first-child {
  margin: 0px 10px 0px 0px !important;
  width: 100% !important;
}

.delivery-address-update-form .css-1gtlbg0 {
  padding: 2px 0px 2px 0px !important;
}

.the-state-input-in-delivery::before {
  content: 'âŒ„';
  font-size: 24px !important;
  position: absolute;
  right: 9px;
  top: 2px;
  color: #595959;
}

.modal-form-single-item .css-17gq4vl {
  padding: 22px 10px 7px 10px !important;
}

.the-state-input-in-delivery:focus-within::before {
  content: '';
  font-size: 0px !important;
}

.css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root:before {
  border: none !important;
}

.css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root::after {
  border: none !important;
}

.css-e4w4as-MuiFormLabel-root-MuiInputLabel-root {
  font-size: 12px !important;
  font-family: QuicksandMedium !important;
  top: -4px !important;
}

.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {
  padding: 20px 10px 3px 9px !important;
  font-size: 13px;
  font: normal !important;
  color: #000000;
  font-family: QuicksandSemibold !important;
}

.css-o943dk-MuiFormLabel-root-MuiInputLabel-root {
  font-size: 14px !important;
  font-family: QuicksandSemiBold !important;
  top: -3px !important;
}

.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input:focus {
  /* padding: 24px 10px 0px 9px !important;
  font-size: 13px; */
  background: none;
}

.edit-delivery-address-button {
  padding: 0 !important;
  margin: 0 !important;
  color: #000 !important;
  width: 100% !important;
  min-width: 30px !important;
}

.css-zs07ro-MuiInputBase-root-MuiFilledInput-root {
  background: none !important;
  font-size: 14px !important;
  padding-top: 7px !important;
}

.css-zs07ro-MuiInputBase-root-MuiFilledInput-root:after {
  border: none !important;
}

.css-zs07ro-MuiInputBase-root-MuiFilledInput-root::before {
  border: none !important;
}

.css-1gctnaj-MuiInputBase-input-MuiFilledInput-input {
  padding: 20px 10px 6px 9px !important;
  font-family: QuicksandSemiBold !important;
  font-size: 13px !important;
}

.css-1869usk-MuiFormControl-root {
  min-width: 110px !important;
}

.css-1xhypcz-MuiStack-root {
  /* padding-top: 0px !important;
  overflow: unset !important; */
}

.css-1n8xjfr-MuiFormControl-root {
  margin: 3px !important;
}

.css-o943dk-MuiFormLabel-root-MuiInputLabel-root.Mui-error {
  color: #595959 !important;
}

.crop-image-modal-button {
  margin: 10px 0 !important;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  justify-content: center;
  width: 100%;
}

.reactEasyCrop_Container {
  position: relative !important;
  height: 200px !important;
  width: 317px !important;
}

.my-image-crop-modal-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.crop-image-modal-button > .image-motion-button {
  background: #0a64f9 !important;
  text-transform: capitalize !important;
  color: #fff !important;
  margin: 0px 8px 0px 8px;
  padding: 5px 11px;
  border-radius: 4px;
  font-family: QuicksandMedium !important;
}

/*  end order Account info */

/* single order start */

.single-open-order-div {
  display: flex;
  flex-direction: column;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  background-size: contain;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
  margin-bottom: 20px;
  transition: all 0.3s ease-in;
}

.single-open-order-div:hover {
  box-shadow: 0px 6px 18px #0000001c;
}

.infinite-scroll-component__outerdiv {
  width: 100%;
}

/* .infinite-scroll-component> div {
  margin: 10px;
} */
.demo-simple-select-filled-label {
  line-height: 14px !important;
}
.onload-spinner-order {
  display: inline-block;
  border: 12px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #6e6e6e;
  width: 80px;
  height: 80px;
  align-self: center;
  justify-self: center !important;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.infinite-scroll-component {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
}

.infinite-scroll-component span {
  /* width: 49%; */
  cursor: pointer;
}

.single-open-order-div > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.single-open-order-div > .single-open-order-delivery-status {
  padding-bottom: 10px;
  border-bottom: 1px dashed #e1e1e1;
  margin-bottom: 3px;
}

.single-open-order-div > .single-open-order-delivery-status > .delivery-button,
.single-open-order-div
  > .single-open-order-delivery-status
  > .picked-up-button {
  padding: 6px !important;
  text-transform: capitalize;
  font-size: 12px;
  font-family: QuicksandBold, 'Quicksand' !important;
  border-radius: 3px;
}

.single-open-order-div
  > .single-open-order-delivery-status
  > .delivery-button
  > img,
.single-open-order-div
  > .single-open-order-delivery-status
  > .picked-up-button
  > img {
  padding: 0 4px 0 0;
}

.single-open-order-div
  > .single-open-order-delivery-status
  > .picked-up-button {
  background: #ffdcc1;
  color: #db5f00;
}

.single-open-order-div > .single-open-order-delivery-status > .delivery-button {
  background: #e2edff;
  color: #0055ff;
}

.single-open-order-div > .single-open-order-delivery-status > .delivery-button {
  color: #0055ff;
  background: #e2edff;
  border-radius: 3px;
}

.single-open-order-div > .single-open-order-content {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  margin: 10px 0;
}

.single-open-order-div > .single-open-order-content > .single-order-date-time {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.single-open-order-div > .single-open-order-content > .single-order-id > span {
  color: #888888;
  font-size: 11px;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
}

.single-open-order-div > .single-open-order-content > .single-order-id > p {
  color: #030303;
  text-transform: uppercase;
  font-size: 13px;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
}

.single-open-order-div > .single-open-order-amount {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .accepted-button,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .packing-button,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .ready-button,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .shipped-button,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .delivered-button,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .cancle-button,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .refund-button {
  font-size: 12px;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  text-transform: capitalize;
  border-radius: 3px;
  color: #fff;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .accepted-button
  > img,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .packing-button
  > img,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .ready-button
  > img,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .shipped-button
  > img,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .delivered-button
  > img,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .cancle-button
  > img,
.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .refund-button
  > img {
  padding: 0 4px 0 0;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .accepted-button {
  background: #10c558;
  padding: 6px !important;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .packing-button {
  background: #ffb303;
  padding: 6px !important;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .ready-button {
  background: #c520f5;
  padding: 6px !important;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .shipped-button {
  background: #03cbff;
  padding: 6px !important;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .delivered-button {
  background: #0a64f9;
  padding: 6px !important;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .cancle-button {
  background: #f55353;
  padding: 6px !important;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-button
  > .refund-button {
  background: #7a7a7a;
  padding: 6px !important;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-status
  > .payment-am-status {
  display: flex;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-status
  > .payment-am-status
  > .payment-paid {
  color: #26be7e;
  font-size: 14px;
  font-family: QuicksandBold, 'Quicksand' !important;
  margin-right: 10px;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-status
  > .payment-am-status
  > .payment-cod-pending {
  color: #f55353;
  font-size: 14px;
  font-family: QuicksandBold, 'Quicksand' !important;
  margin-right: -5px;
  width: 100px;
}

.single-open-order-div
  > .single-open-order-amount
  > .single-open-order-payment-status
  > .payment-am-status
  > p {
  color: #1a1a1a;
  font-size: 14px;
  font-family: QuicksandBold, 'Quicksand' !important;
}

/* single order end */

/* end order history */

/* My information */
.my-information-main-component {
  padding: 40px 0;
  margin-left: 320px;
  width: 70%;
  display: flex !important;
  /* align-items: center ; */
  justify-content: center;
  flex-direction: column;
}

.menu-icon-div {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.topBar-xMark {
  margin-left: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width: 769px) {
  .menu-icon-div-inner,
  .topBar-xMark {
    display: none;
  }
}

.menu-icon {
  width: 30px !important;
  height: 2px !important;
  background-color: black !important;

  margin: 6px !important;
}

.my-information-main-component > .my-information-middle-glass-box-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid #ffffff;
  background: #0a64f933;
  border-radius: 4px;
  opacity: 1;
  box-shadow: #0a64f98c 0px 0px 80px 0px;
  padding: 5px !important;
  height: 164px;
}

.my-information-main-component
  > .my-information-middle-glass-box-div
  > .my-info-single-glass {
  background: #ecf3ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  width: 255px;
  height: 144px;
  margin: 1px;
  text-transform: capitalize;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
}

.my-information-main-component
  > .my-information-middle-glass-box-div
  > .my-info-single-glass
  > .my-info-image {
  border: 2px solid #ffffff;
  border-radius: 9px;
  padding: 5px;
  margin-bottom: 15px;
  box-shadow: #000000 0px 0px 3px 0px;
  color: #8c8c8c;
  background: #e2edff;
}

.my-information-main-component
  > .my-information-middle-glass-box-div
  > .my-info-single-glass
  > p {
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 16px;
  color: #686868;
}

.my-information-main-component
  > .my-information-middle-glass-box-div
  > .my-info-single-active-glass {
  background: radial-gradient(
    farthest-side at 6% 14%,
    #6ea5ff 0%,
    #0a64f9 100%
  );
  border-radius: 4px;
  color: #ffffff;
  width: 300px;
  height: 182px;
  margin-bottom: 40px;
}

.my-information-main-component
  > .my-information-middle-glass-box-div
  > .my-info-single-active-glass
  > .my-info-image {
  border: 2px solid #ffffff;
  border-radius: 9px;
  box-shadow: #ffffff 0px 0px 3px 0px;
  color: #fff;
  padding: 7px 9px;
  background: #0a64f9;
  margin-bottom: 20px;
}

.my-information-main-component
  > .my-information-middle-glass-box-div
  > .my-info-single-active-glass
  > p {
  color: #fff;
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 18px;
}

.my-information-bottom-glass-box-div {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin: 40px 0;
  display: none;
  padding: 5px;
}

.my-information-bottom-glass-box-div > .my-information-bottom-glass-content {
  display: flex;
  flex-direction: column;
  width: 80%;
}

.my-information-bottom-glass-box-div
  > .my-information-bottom-glass-content
  > span {
  color: #707070;
  font-size: 12px;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  width: 70% !important;
}

.my-information-bottom-glass-box-div
  > .my-information-bottom-glass-content
  > .customer-data-and-information {
  margin-top: 20px;
}

.my-information-bottom-glass-box-div
  > .my-information-bottom-glass-content
  > .customer-data-and-information
  > .my-information-single {
  display: flex;
  margin: 10px 0;
}

.my-information-bottom-glass-content
  > .customer-data-and-information
  > .my-information-single
  > span {
  color: #232323;
  font-size: 14px;
  font-family: QuicksandBold, 'Quicksand' !important;
  display: flex;
  flex-wrap: wrap;
}

.my-information-bottom-glass-content
  > .customer-data-and-information
  > .my-information-single
  > span:first-child {
  width: 30%;
  color: #707070;
  font-size: 14px;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
}

.my-information-main-component > .my-info-single-active-glass {
  display: flex;
}

.customer-delivery-address-section {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 60px;
}

.customer-delivery-address-section > .customer-single-delivery-address {
  border: 2px solid #0a64f9;
  border-radius: 6px;
  width: 48%;
  padding: 5px;
  margin: 5px;
}

.customer-delivery-address-section
  > .customer-single-delivery-address
  > .customer-single-delivery-address-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.customer-delivery-address-section
  > .customer-single-delivery-address
  > .customer-single-delivery-address-middle {
  display: flex;
  flex-direction: column;
  margin: 10px 0 5px 0;
}

.customer-delivery-address-section
  > .customer-single-delivery-address
  > .customer-single-delivery-address-middle
  > p {
  color: #232323 !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  font-size: 13px;
  margin: 0 !important;
}

.customer-delivery-address-section
  > .customer-single-delivery-address
  > .customer-single-delivery-address-bottom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.customer-data-and-information-delivery {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -100px;
}

.customer-delivery-address-section
  > .customer-single-delivery-address
  > .customer-single-delivery-address-bottom
  > .btn-remove-delivery-address {
  margin: 0px !important;
  padding: 0px !important;
}

.customer-delivery-address-section
  > .customer-single-delivery-address
  > .customer-single-delivery-address-bottom
  > .btn-remove-delivery-address
  > .remove-delivery-address {
  color: #222222;
  font-size: 13px !important;
  border-bottom: 1px solid #222222;
  border-radius: unset !important;
  text-transform: capitalize;
  font-family: QuicksandRegular !important;
}

.customer-delivery-address-section
  > .customer-single-delivery-address
  > .customer-single-delivery-address-bottom
  > .default-address {
  color: #0a64f9 !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  background: #d2e3ff !important;
  border-radius: 4px !important;
  font-size: 13px !important;
  text-transform: capitalize;
}

.customer-delivery-address-section
  > .customer-single-delivery-address
  > .customer-single-delivery-address-bottom
  > .set-default-address {
  color: #0a64f9 !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  background: none !important;
  border-radius: 4px !important;
  font-size: 13px !important;
  text-transform: capitalize;
}

.modal-form-single-input .css-1thjcug {
  background-color: #fff;
}

/* end my information */

/* start cart and payment*/

.main-cart-top-bar {
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: #ffffff;
  border-bottom: 1px solid #ebebeb;
  z-index: 5;
}

.quickvee-logo-cart-top-bar {
  width: 148px;
  height: 44px;
  margin-right: 100px;
}

.top-cart-bar-button {
  color: #232323 !important;
  font-family: QuicksandBold, 'Quicksand' !important;
  text-transform: capitalize !important;
}

.top-cart-bar-button:hover {
  background: none !important;
}

.search-location-button:hover {
  background: none !important;
}

.quickvee-payement-stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #f9f9f9 !important;
  padding: 20px;
}

.quickvee-payement-stepper > span {
  color: #878787 !important;
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 18px !important;
  margin: 0 10px;
  cursor: not-allowed;
}

.quickvee-payement-stepper > p {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0px;
  transition: all 0.3s ease-in-out;
}

.quickvee-payement-stepper > .active-payment-component {
  color: #0a64f9 !important;
  cursor: pointer;
}

.quickvee-payement-stepper > .active-payment-stepper-status {
  width: 10px;
  height: 10px;
  background-color: #0a64f9;
  border-radius: 50%;
  margin: 0px;
}

@media (max-width: 480px) {
  .active-payment-stepper-status {
    width: 5px !important;
    height: 5px !important;
  }
}
.quickvee-payement-stepper > .active-payment-stepper-range {
  color: #0a64f9 !important;
  background-color: #0062ff !important;
  height: 3px;
}

.quickvee-payement-stepper > hr {
  width: 10%;
  margin: 0px;
  height: 2px;
  background-color: #c4c4c4 !important;
  border: none;
  transition: background-color 0.3s ease-out;
}

.quickvee-payment-component-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 50px;
  flex-wrap: wrap;
}

.payment-stepper-cart {
  width: 75%;
  display: flex;
  justify-content: center;
  /* min-height: calc(100vh - 200px); */
}

.payment-stepper-cart > .payment-stepper-wishlist-item {
  width: 65%;
  border-right: 1px solid #e8e8e8;
  padding: 0 20px;
  /* min-height: calc(100vh - 200px); */
}

.payment-stepper-cart
  > .payment-stepper-wishlist-item
  > .payment-stepper-wishlist-item-topper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin: 0px -15px; */
}

.payment-cart-remove-from-cart-wishlist-modal {
  display: flex;
}

.payment-stepper-cart
  > .payment-stepper-wishlist-item
  > .payment-stepper-wishlist-item-topper
  > .selected-count {
  color: #232323;
  font-size: 20px;
  font-family: QuicksandBold !important;
}

.q-payment-selected-wishlist {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.q-payment-selected-wishlist span {
  color: #595959;
  font-size: 14px;
  /* font-family: QuicksandBold !important; */
  border-right: 1px solid #414141;
  border-left: 1px solid #414141;
  padding: 0 20px 0 10px;
  cursor: pointer;
}

.q-payment-selected-wishlist img {
  cursor: pointer;
}

.payment-stepper-cart
  > .payment-stepper-wishlist-item
  > .payment-stepper-wishlist-item-topper
  > .selected-wishlist
  > .selected-delete-all {
  color: red;
  margin-left: 20px;
}

.payment-stepper-cart > .payment-stepper-checkout-item {
  width: 40%;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  padding-bottom: 15px;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-item-top {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #232323;
  font-size: 20px;
  font-family: QuicksandBold !important;
  margin-bottom: 15px;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content {
  display: flex;
  flex-direction: column;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > div {
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  padding: 5px 0;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > div
  > span {
  color: #595959;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > div
  > p {
  padding: 0 !important;
  margin: 0 !important;
  color: #595959;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > div
  > p
  img {
  margin-right: 5px;
  cursor: pointer;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > .quickvee-checkout-final-amount
  > span,
.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > .quickvee-checkout-final-amount
  > p {
  color: #222222;
  font-size: 20px;
  font-family: QuicksandBold !important;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > .quickvee-checkout-final-amount {
  margin: 15px 0px 10px 0px;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > .payment-checkout-with-login {
  background: #000000;
  border: 2px solid #000000;
  border-radius: 6px;
  color: #fff;
  text-transform: capitalize;
  font-size: 13.72px;
  margin-bottom: 15px;
  font-family: QuicksandBold !important;
  height: 44px;
}

.payment-checkout-with-login-save-and-proceed {
  border: 2px solid #000000 !important;
  border-radius: 6px !important;
  color: #000000 !important;
  text-transform: capitalize !important;
  font-size: 16px !important;
  font-family: QuicksandBold !important;
  margin: 15px 0 !important;
  height: 44px;
}
.payment-checkout-with-login-pay-button {
  border: 2px solid #000000 !important;
  border-radius: 6px !important;
  color: #000000 !important;
  text-transform: capitalize !important;
  font-size: 16px !important;
  font-family: QuicksandBold !important;
  margin: 15px 0 !important;
  height: 44px;
}
.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > .payment-checkout-as-guest {
  border: 2px solid #000000;
  border-radius: 6px;
  color: #000000;
  text-transform: capitalize;
  font-size: 16px;
  font-family: QuicksandBold !important;
  margin: 15px 0;
  height: 44px;
}

.payment-stepper-cart
  > .payment-stepper-checkout-item
  > .payment-stepper-checkout-content
  > .payment-checkout-as-guest:hover {
  background-color: #fff !important;
}

.payment-stepper-cart
  > .payment-stepper-wishlist-item
  > .payment-all-cart-items {
  margin: 20px 0px;
  overflow-y: auto;
  max-height: 72vh;
  width: 100%;
  overflow-x: hidden;
  /* padding: 0 20px 0 0; */
}

.payment-all-cart-items.overflowed {
  padding-right: 20px;
}

.payment-all-cart-items:not(.overflowed) {
  padding-right: 0;
}

.payment-stepper-cart
  > .payment-stepper-wishlist-item
  > .payment-all-cart-items::-webkit-scrollbar {
  width: 3px;
  position: relative;
  right: 10px;
}

/* Track */
.payment-stepper-cart
  > .payment-stepper-wishlist-item
  > .payment-all-cart-items::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  cursor: pointer;
}

/* Handle */
.payment-stepper-cart
  > .payment-stepper-wishlist-item
  > .payment-all-cart-items::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
.payment-stepper-cart
  > .payment-stepper-wishlist-item
  > .payment-all-cart-items::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

.payment-all-cart-add-more-products {
  border-radius: 6px;
  float: right;
  color: #000000;
  font-family: QuicksandBold !important;
  text-transform: capitalize;
  padding: 5px 15px 5px 0px;
  font-size: 16px;
  display: flex;
  align-items: center;
  /* width: 75%; */
}

.payment-page-wishlist-cart-items {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  padding: 10px 16px;
  margin: 0 0 15px 0;
  width: 100%;
  justify-content: space-between;
}

.payment-page-wishlist-cart-items > .payment-page-wishlist-item-image {
  width: 15%;
}

.payment-page-wishlist-cart-items > .payment-page-wishlist-item-content {
  width: 80%;
}

.payment-page-wishlist-cart-items > div {
  display: flex;
  align-items: flex-start;
}

.payment-page-wishlist-cart-items > .payment-page-wishlist-item-image > div {
  position: relative;
  right: 0px;
  padding: 10px;
  border: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-page-wishlist-cart-items
  > .payment-page-wishlist-item-image
  > div
  > img {
  width: 66px;
}

.payment-page-wishlist-cart-items
  > .payment-page-wishlist-item-image
  > .checkbox {
  position: relative;
  top: -2px;
  right: -2px;
  cursor: pointer;
  opacity: 0;
  z-index: 2;
  width: 15px;
}

.payment-page-wishlist-cart-items
  > .payment-page-wishlist-item-image
  > .checkbox-checkmark {
  position: relative;
  top: -5px;
  right: 15px;
  padding: 10px 10px 10px 10px;
  background-color: rgb(226, 226, 226);
  border-radius: 2px;
  z-index: 1;
}

.payment-page-wishlist-cart-items
  > .payment-page-wishlist-item-image
  > .checkbox:checked
  ~ .checkbox-checkmark {
  /* background-color: #14AE2D; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.payment-page-wishlist-item-content {
  display: flex;
  flex-direction: column;
}

.payment-modal-outer-div .css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  max-width: 500px !important;
}

.payment-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px 25px;
}

.payment-modal.out-of-stock-products {
  padding: 20px 50px;
}

@media (max-width: 768px) {
  .payment-modal.out-of-stock-products {
    padding: 20px 25px;
  }
}

.payment-modal .payment-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.payment-modal .payment-modal-content img {
  margin-bottom: 15px;
  width: 80px;
  height: auto;
}

.payment-modal .payment-modal-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 40px;
}

.payment-modal .payment-modal-button button {
  width: 48%;
  padding: 10px;
  font-size: 15px;
  font-family: QuicksandBold, 'Quicksand' !important;
  background-color: #fff;
  outline: none;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.payment-modal .payment-modal-button button:first-child {
  border: 1px solid #232323;
}

.payment-modal .payment-modal-content span {
  text-align: center;
  color: #212121;
  font-family: QuicksandBold, 'Quicksand' !important;
  font-size: 18px;
  padding: 0 10px;
}

.payment-page-wishlist-item-content > .top-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
}

.payment-page-wishlist-item-content > .top-content > p {
  color: #212121;
  font-size: 16px;
  font-family: QuicksandBold !important;
  margin-right: 45px;
}

.payment-page-wishlist-item-content > .middle-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  width: 70%;
}

.payment-page-wishlist-item-content
  > .middle-content
  > .increment-decremnt-button {
  display: flex;
  align-items: center;
}

.payment-page-wishlist-item-content
  > .middle-content
  > .increment-decremnt-button
  > button {
  border: none;
  background: #0a64f9;
  border-radius: 4px;
  color: #fff;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.payment-page-wishlist-item-content
  > .middle-content
  > .increment-decremnt-button
  > button:disabled {
  background: #80aef7;
}

.payment-page-wishlist-item-content
  > .middle-content
  > .increment-decremnt-button
  > span {
  margin: 0px 50%;
  font-family: QuicksandSemiBold !important;
  color: #000000;
  width: 13%;
  font-size: 19px;
  text-align: center;
}

.payment-page-wishlist-item-content
  > .middle-content
  > .amount-calculation
  > span {
  color: #2e2e2e;
  font-size: 18px;
  font-family: QuicksandBold !important;
  margin: 0px 10px;
}

.payment-page-wishlist-item-content
  > .middle-content
  > .amount-calculation
  > del {
  font-size: 14px;
  color: #989898;
  font-family: QuicksandMedium !important;
}

.payment-page-wishlist-item-content > .bottom-dropdowns-for-categories {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}

.payment-page-wishlist-item-content > .bottom-dropdowns-for-categories {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
}

.payment-page-wishlist-item-content > .bottom-dropdowns-for-categories > div {
  width: 45%;
  margin: 0 10px 0 0;
}

.payment-stepper-cart > .payment-stepper-customer-detail-section {
  display: flex;
  flex-direction: column;
  width: 65%;
  border-right: 1px solid #d3d3d3;
  padding: 0 20px;
}

.payment-billing-customer-form {
  display: flex;
  flex-direction: column;
  margin: 0px 0px 20px 0px;
  margin-left: auto;
}

.payment-billing-customer-form > h1 {
  color: #212121;
  text-transform: capitalize;
  font-size: 20px;
  font-family: QuicksandBold !important;
}

.payment-billing-customer-form p {
  color: #222222;
  font-size: 12px;
  /* margin-bottom: 15px  !important; */
  font-family: QuicksandMedium !important;
}
.id-verigfication-description {
  margin-bottom: 15px !important;
}
.payment-billing-inputs-div {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.payment-billing-input-outer-div {
  display: flex;
  flex-direction: column;
  margin: 5px 0;
  /* align-items: center; */
  width: 48.5%;
}

.payment-billing-input-outer-div-for-all {
  display: flex;
  flex-direction: column;
  margin: 5px 0;
  /* align-items: center; */
  width: 100%;
}

/* .payment-billing-input-outer-div:nth-child(2){
  align-items: flex-end;
} */
.payment-billing-input {
  max-width: 100%;
  font-size: 12px !important;
  background: #ffffff;
  font-family: QuicksandMedium, 'Quicksand' !important;
  background: #ffffff !important;
  border: 1px solid #d3d3d3 !important;
  border-radius: 6px !important;
}

.payment-billing-input .css-s2lqj8 {
  color: #595959 !important;
  font-family: QuicksandSemiBold !important;
  font-size: 14px !important;
}

.payment-billing-input:focus-within {
  border: 1px solid #595959 !important;
}

.payment-billing-input::placeholder {
  color: #595959 !important;
}

.c-payment-billing {
  width: 100% !important;
}

.payment-billing-city-state-update-inputs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.css-o943dk-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {
  color: #595959 !important;
}

.payment-billing-city-state-update-inputs > div:first-child {
  margin: 0px 15px 0px 0px !important;
  width: 48%;
}

.payment-billing-city-state-update-inputs > div:first-child .css-14x1nlk {
  color: #595959 !important;
  font-family: QuicksandMedium, Quicksand !important;
  font-size: 13px !important;
  top: -5px;
}

.payment-billing-modal-form-single-item {
  display: flex;
  flex-direction: column;
  margin: 0;
  width: 50%;
}

.payment-billing-modal-form-single-item .css-1rgmeur {
  color: #595959 !important;
  font-size: 14px !important;
  font-family: QuicksandSemiBold !important;
  top: -3px !important;
}

.payment-billing-modal-form-single-item .css-14x1nlk {
  color: #595959 !important;
  font-size: 14px !important;
  font-family: QuicksandSemiBold !important;
  top: -3px !important;
}

.payment-billing-modal-form-single-item .css-17gq4vl.css-17gq4vl.css-17gq4vl {
  color: #000000 !important;
  font-size: 14px !important;
  font-family: QuicksandSemiBold !important;
  padding: 17px 10px 2px 10px;
}

.billing-info-delivery-address-update-form {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  /* margin: 5px 0 15px 0; */
  width: 100%;
  /* margin-bottom: 15px !important; */
}

.billing-info-delivery-address-update-form .billing-date-time {
  width: 100% !important;
}

.billing-info-delivery-address-update-form > div {
  width: 100%;
}

.billing-info-delivery-address-update-form > div:nth-child(1) {
  margin: 0px 10px 15px 0;
}

.billing-info-delivery-address-update-form > div:nth-child(2) {
  margin: 0px 10px;
}

.billing-info-delivery-address-update-form > div:nth-child(3) {
  margin: 0px 0px 0px 5px;
}

.billing-info-delivery-address-update-form .css-13sljp9 {
  width: 100% !important;
  /* padding-top:8px; */
}

.css-1gctnaj-MuiInputBase-input-MuiFilledInput-input {
  padding: 12px 10px 6px 9px !important;
}

.css-zs07ro-MuiInputBase-root-MuiFilledInput-root {
  background: none !important;
  font-size: 14px !important;
  padding-top: 4px !important;
}

.payment-stepper-single-billing-info-detail > .payment-billing-save-button {
  float: right;
  color: #ffffff;
  font-family: QuicksandBold !important;
  background: #0a64f9;
  padding: 5px 60px;
  border-radius: 6px;
  text-transform: capitalize !important;
}
.payment-stepper-single-billing-info-detail {
  padding-top: 24px;
}

.payment-stepper-single-billing-info-detail
  > .payment-billing-save-button:hover {
  float: right;
  color: #ffffff;
  font-family: QuicksandBold !important;
  background: #0a64f9;
  padding: 5px 60px;
  border-radius: 6px;
  text-transform: capitalize !important;
}

.apply-coupon-modal-button {
  margin: 10px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #ffffff;
  border: 1px solid #176cf8;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
}

.apply-coupon-listing-btn {
  display: inline-flex;
  min-height: 44px;
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: #0a64f9;
  font: inherit;
  font-size: 14px !important;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  cursor: pointer;
}

.apply-coupon-listing-btn > span {
  display: inline-flex;
  align-items: center;
  margin: 0;
}

.apply-coupon-listing-btn:focus-visible {
  outline: 3px solid rgba(10, 100, 249, 0.22);
  outline-offset: 2px;
  border-radius: 6px;
}

.apply-coupon-modal-button.coupon-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 6px 15px #0a64f94d;
  border: 1px solid #176cf8;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
}

.apply-coupon-modal-button > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0px;
}

.apply-coupon-modal-button > div > p {
  color: #0a64f9;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
  margin: 0;
  padding: 0;
}

.apply-coupon-modal-button > div > span {
  color: #222222;
  font-size: 12px;
  font-family: QuicksandSemiBold !important;
  margin: 0;
  padding: 0;
}

.basic-modal,
.basic-modal:focus-visible {
  outline: none;
}
.border-bottom-gray {
  width: 100%;
  border-bottom: 1px solid #e6eaf0;
  padding: 10px;
  min-height: 68px;
  .quickvee-logo-authentication {
    margin: 0;
  }
}
.search-bar-heading {
  font-size: 20px;
  padding-left: 16px;
  padding-top: 6px;
}
.show-hide-button {
  -webkit-user-select: none;
  /* Safari */
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
  position: absolute;
  right: 1px;
  top: 23px;
  padding: 12px;
  cursor: pointer !important;
  color: #222222 !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
  font-size: 13px;
}
.show-hide-button-change-password {
  background-color: #fff;
  top: 7px;
}
.show-hide-button.login-password {
  right: 0;
  top: 21px;
}
.modal-forms > .available-coupons-listing {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px 0;
  width: 100%;
  -webkit-user-select: none;
  user-select: none;
  /* opacity: 1; */
}

.coupon-error-on-modal {
  display: flex;
  align-self: flex-start;
  color: red;
  font-size: 16px;
  font-family: 'QuicksandMedium' !important;
  position: relative !important;
  margin-left: 15px !important;
}

.modal-forms
  > .available-coupons-listing
  > .available-coupons-listing-checkbox
  > .available-coupons-checkbox {
  position: relative;
  top: 0px;
  right: -5px;
  cursor: pointer;
  z-index: 1;
  opacity: 0;
}

.modal-forms
  > .available-coupons-listing
  > .available-coupons-listing-checkbox
  > .available-coupons-checkbox-checkmark {
  position: relative;
  /* top: 2px; */
  right: 5px;
  padding: 2px 12px 2px 12px;
  background-color: rgb(226, 226, 226);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border-radius: 2px;
  z-index: 0;
  cursor: pointer;
}

.modal-forms
  > .available-coupons-listing
  > .available-coupons-listing-checkbox
  > .available-coupons-checkbox:checked
  ~ .available-coupons-checkbox-checkmark {
  background-size: cover;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.modal-forms > .available-coupons-listing > .available-coupons-listing-content {
  cursor: pointer;
}

.modal-forms
  > .available-coupons-listing
  > .available-coupons-listing-content
  > span {
  color: #232323;
  font-size: 14px;
  font-family: QuicksandBold !important;
  text-transform: uppercase;
}

.modal-forms
  > .available-coupons-listing
  > .available-coupons-listing-content
  > p {
  color: #000000;
  font-size: 12px;
  font-family: QuicksandRegular !important;
}

#modal-modal-description {
  display: flex;
  justify-content: flex-start !important;
  height: auto;
  max-height: 84vh;
  /* overflow-y: auto; */
}

.css-dmmspl-MuiFormGroup-root {
  display: flex !important;
  flex-direction: row !important;
}

.payment-delivery-section > div .css-1h7anqn {
  flex-direction: row !important;
}

.payment-delivery-section > span {
  color: #212121;
  text-transform: capitalize;
  font-size: 20px;
  font-family: QuicksandBold !important;
}

.payment-delivery-section > .select-delivery-hour-and-date {
  display: flex;
  flex-direction: row !important;
  width: 100%;
  display: none;
  /* align-items: center;
  justify-content: center; */
}

.select-delivery-hour-and-date .choose-time-on-payment {
  width: 100% !important;
}

.select-delivery-hour-and-date .choose-date-on-payment input {
  position: relative;
  left: 3px;
}

.select-delivery-hour-and-date label {
  color: #595959 !important;
  /* font-family: QuicksandSemiBold !important; */
  font-size: 14px !important;
}

.select-delivery-hour-and-date input {
  /* padding: 12px 10px 6px 9px !important; */
  /* font-family: QuicksandSemiBold !important; */
  /* font-size: 13px !important; */
}

.select-delivery-hour-and-date
  .css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {
  position: relative;
  top: 4px;
  left: 3px;
  padding: 17px 10px 9px 9px !important;
}

.select-delivery-hour-and-date.DeliveryNow-active {
  display: flex;
  animation: fadeOut 0.8s !important;
  height: 0px !important;
  display: none !important;
}

.payment-delivery-section > .DeliveryNow-active {
  display: flex;
  animation: fadeOut 0.8s !important;
  height: 0px !important;
  display: none !important;
}

.payment-delivery-section > .DeliveryLater-active {
  display: flex;
  animation: fadeIn 0.9s;
}

.payment-delivery-section > .select-delivery-hour-and-date > div {
  width: 100% !important;
  margin-right: 10px;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    top: -40px;
    height: 0px;
  }

  100% {
    opacity: 1;
    top: 0px;
    height: 85px;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
    top: 0px;
    height: 50px;
  }

  100% {
    opacity: 0;
    top: -40px;
    height: 0px;
    display: none;
  }
}

.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {
  font-size: 13px !important;
  color: #595959 !important;
  font-family: QuicksandMedium, 'Quicksand' !important;
}

.css-ahj2mt-MuiTypography-root {
  color: #222222 !important;
  font-size: 16px !important;
  /* font-family: QuicksandMedium, 'Quicksand' !important; */
}

.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {
  border: none !important;
  /* border-radius: 6px !important; */
  outline: none;
  padding: 0px 12px 0px 0px !important;
}

.payment-stepper-single-billing-info-detail
  > .payment-delivery-address-section {
  display: flex;
  flex-direction: column;
}

.payment-stepper-single-billing-info-detail
  > .payment-delivery-address-section
  > .head-section-of-payment-delivery-address {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.payment-delivery-address-section
  > .head-section-of-payment-delivery-address
  > span {
  color: #212121;
  text-transform: capitalize;
  font-size: 20px;
  font-family: QuicksandBold !important;
}

.payment-delivery-address-section
  > .middle-section-of-payment-delivery-address {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 12px;
}

.payment-delivery-address-section
  > .middle-section-of-payment-delivery-address
  > p {
  color: #222222;
  font-size: 13px;
  font-family: QuicksandMedium !important;
  margin: 0;
  line-height: 1.4;
  margin-bottom: 12px;
}

.delivery-address-helper-text {
  margin-bottom: 14px !important;
}

.payment-delivery-address-section
  > .middle-section-of-payment-delivery-address
  > label
  > span:nth-child(2) {
  color: #222222;
  font-size: 13px !important;
  font-family: QuicksandMedium !important;
  line-height: 1 !important;
  margin-left: -7px;
}

.payment-delivery-address-section
  > .bottom-section-of-payment-delivery-address {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.payment-delivery-address-section .head-section-of-payment-delivery-address .modal-main-button {
  font-size: 17px !important;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
  line-height: 1.35;
  margin-bottom: 6px;
}

.delivery-address-card-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  width: 100%;
}

.delivery-address-grid-item {
  min-width: 0;
  display: flex;
}

.delivery-address-grid-item .payment-delivery-single-delivery-address {
  width: 100%;
}

.delivery-address-card-actions {
  gap: 12px;
  white-space: nowrap;
}

.delivery-address-edit-action .edit-delivery-address-button {
  margin: 0 !important;
}

.payment-delivery-single-delivery-address {
  padding: 10px 15px;
  /* border: 1px solid #d3d3d3; */
  border-radius: 6px;
  /* margin: 12px 0; */
  /* width: 48%; */
}

.payment-delivery-single-delivery-address > div {
  display: flex;
  /* align-items: flex-end; */
  justify-content: space-between;
}

@media (min-width: 576px) and (max-width: 991.98px) {
  .delivery-address-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }
}

@media (min-width: 992px) {
  .delivery-address-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
}

.payment-delivery-single-delivery-address > .bottom-payment-delivery-address p {
  cursor: pointer;
}

.payment-delivery-single-delivery-address
  > .bottom-payment-delivery-address
  > img {
  object-fit: contain;
  width: 15px;
  cursor: pointer;
}

.payment-delivery-single-delivery-address
  > .top-payment-delivery-address
  > img {
  object-fit: contain;
  width: 20px;
}

.payment-delivery-single-delivery-address > .middle-payment-delivery-address {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 10px 0 0 0;
  /* width: 240px; */
}

.payment-delivery-single-delivery-address
  > .middle-payment-delivery-address
  > span {
  color: #232323;
  font-family: QuicksandSemiBold !important;
  font-size: 14px;
}

.payment-delivery-single-delivery-address
  > .middle-payment-delivery-address
  > p {
  color: #212121;
  font-family: QuicksandRegular !important;
  font-size: 14px;
}

.payment-delivery-single-delivery-address
  .bottom-payment-delivery-address
  > Button {
  text-transform: capitalize;
  color: #0a64f9;
  font-family: QuicksandSemiBold !important;
  font-size: 13px;
  border-radius: 4px;
}

.payment-delivery-single-delivery-address
  .bottom-payment-delivery-address
  > span {
  background: #ff57570f;
  border: 0.5px solid #ff5757;
  border-radius: 4px;
  color: #ff5757;
  font-size: 10px;
  /* font-size: clamp(8px, 0.05px + 2.6783vw, 10px) !important; */

  font-family: QuicksandSemiBold !important;
  padding: 0px 10px;
}

.billingaddrss-error-on-payment {
  background: #ff57570f;
  border: 0.5px solid #ff5757;
  border-radius: 4px;
  color: #ff5757;
  font-size: 11px;
  font-family: QuicksandSemiBold !important;
  padding: 6px;
}

.quickvee-tip-selection-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  /* height: 70px; */
  /* margin: 15px 0; */
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  overflow: hidden;
}

@keyframes fadeTipIn {
  0% {
    right: -300px;
    width: 100%;
  }

  100% {
    right: 0;
    width: 100%;
  }
}

.quickvee-tip-custom {
  width: 100%;
  position: relative;
  animation: fadeTipIn 0.6s;
}

.quickvee-tip-percents {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.quickvee-tip-percents span {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff 0 0 no-repeat padding-box;
  border: 2px solid #dedede;
  border-radius: 6px;
  color: #1e1e1e;
  font-family: QuicksandBold !important;
  font-size: 14px;
  padding: 9px 0;
}

.quickvee-tip-percents span:not(:last-child) {
  margin: 0 2% 0 0;
}

.quickvee-tip-percents span p {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.quickvee-tip-percents .custom-tip-with-values {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 12px #0a64f926;
  border: 2px solid #0a64f9;
  border-radius: 6px;
  padding: 9px 0;
  /* padding: 2% 3%; */
}

.payment-add-update-tip {
  /* visibility: hidden; */
  position: absolute;
  right: 3px;
  top: 8px;
  background-color: #fff;
  color: #0a64f9;
  font-size: 14px;
  font-family: QuicksandBold !important;
  outline: none;
  border: none;
  cursor: pointer;
  padding: 10px;
}

#tip-input:not(:placeholder-shown) ~ .payment-add-update-tip {
  visibility: visible !important;
}

.quickvee-tip-percents .selected-tip {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 12px #0a64f926;
  border: 2px solid #0a64f9;
  border-radius: 6px;
}

.payment-delivery-payment-info-section {
  /* height: 400px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.payment-delivery-payment-info-section > span {
  color: #212121;
  text-transform: capitalize;
  font-size: 20px;
  font-family: QuicksandBold !important;
  margin-bottom: 5px;
}

.payment-delivery-payment-info-section > p {
  margin: 10px 0;
  color: #202020;
  font-size: 13px;
  font-family: QuicksandMedium !important;
}

.payment-delivery-payment-info-section > .quickvee-payment-cards-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}

.div-for-payment-header-and-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.quickvee-single-payment-card {
  background-color: #ffff;
  z-index: 2;
}

.payment-delivery-payment-info-section
  > .quickvee-payment-cards-section
  > .quickvee-single-payment-card {
  padding: 10px 15px;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  margin: 2% 0;
  width: 48%;
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.single-payment-icon-edit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.single-payment-detail-select {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.payment-delivery-payment-info-section
  .quickvee-payment-cards-section
  .quickvee-single-payment-card
  .single-payment-detail {
  margin: 5px 0;
}

.css-i4bv87-MuiSvgIcon-root {
  font-size: 20px !important;
}

.quickvee-payment-cards-section
  .quickvee-single-payment-card
  .single-payment-detail
  > span {
  font-size: 14px;
  font-family: QuicksandSemibold !important;
}

.single-payment-detail > p {
  font-size: 12px;
  text-align: start;
  font-family: QuicksandRegular !important;
}

.payment-delivery-payment-info-section
  .quickvee-payment-cards-section
  .quickvee-single-payment-card
  .single-payment-select {
  display: flex;
  flex-direction: row-reverse;
}

.quickvee-payment-cards-section
  .quickvee-single-payment-card
  .single-payment-select
  > * {
  color: #0a64f9;
  font-family: QuicksandSemiBold !important;
  text-transform: capitalize !important;
  font-size: 15px;
  padding: 0;
  margin: 0px;
}

.payment-card-details-add-section {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between !important;
  width: 100%;
}

.payment-card-details-add-section > div {
  width: 49.5% !important;
}

.quickvee-old-card-detail {
  display: none;
}

.quickvee-new-add-card-detail {
  display: none;
  border-bottom: 1px solid #e2e8ed;
  padding-bottom: 16px !important;
  margin-bottom: 10px;
}

.addoldpayment {
  display: flex;
  animation: fadeInPayment 0.6s !important;
}

.removeoldpayment {
  display: flex;
  animation: fadeOutPayment 0.6s !important;
  width: 0px;
  height: 0px;
  opacity: 0;
  z-index: 0;
}

@keyframes fadeInPayment {
  0% {
    opacity: 0;
    height: 0px;
  }

  100% {
    opacity: 1;
    height: 50px;
  }
}

@keyframes fadeOutPayment {
  0% {
    opacity: 1;
    height: 50px;
    width: 100%;
  }

  10% {
    opacity: 0;
  }

  100% {
    opacity: 0;
    height: 0px;
    width: 0px;
  }
}

.addnewpayment {
  display: flex;
  flex-direction: column;
  animation: fadeInPaymentNew 0.6s !important;
}

.removenewpayment {
  display: flex;
  animation: fadeOutPaymentNew 0.6s !important;
  width: 0px;
  height: 0px;
  opacity: 0;
  z-index: 0;
  display: none;
}
@keyframes fadeInPaymentNew {
  0% {
    opacity: 0;
    height: 0px;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
    height: 120px;
  }
}

@media (max-width: 768px) {
  @keyframes fadeInPaymentNew {
    0% {
      opacity: 0;
      height: 0px;
    }

    50% {
      opacity: 0;
    }

    100% {
      opacity: 1;
      height: 200px;
    }
  }
}

@keyframes fadeOutPaymentNew {
  0% {
    opacity: 1;
    height: 80px;
    width: 100%;
  }

  20% {
    opacity: 0;
  }

  100% {
    opacity: 0;
    height: 0px;
    width: 0px;
  }
}

.payment-old-radio-select {
  border-radius: 4px !important;
}

.payment-old-radio-select > span:nth-child(1) {
  display: none;
}

.payment-old-radio-select > span:nth-child(2) {
  color: #0a64f9 !important;
  font-size: 14px !important;
  font-family: QuicksandSemiBold !important;
}

.payment-old-radio-select.selected > span:nth-child(2) {
  padding: 5px 10px;
}

/* .payment-card-details-add-section-single-item {
  margin: 5px 10px 5px 0px;
  } */

/* .payment-card-details-card-num {
  width: 275px !important;
} */

/* .payment-card-details-expiredate>div>div {
  width: 130px !important;
  min-width: auto !important;

} */
.payment-card-details-expiredate
  .css-1xhypcz-MuiStack-root
  > .MuiTextField-root {
  min-width: 134px;
}

/* .payment-card-details-cvv {
  width: 130px !important;

} */

.payment-card-details-add-section-single-item {
  overflow: hidden;
}

.payment-card-detail-single-item-date-cvv {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.payment-card-detail-single-item-date-cvv > div {
  width: 49% !important;
}

.payment-card-details-expiredate .css-1gtlbg0 > .MuiTextField-root {
  min-width: 100px !important;
}

.quickvee-new-payment-card {
  width: 100%;
  margin: 10px 0;
}

.payment-card-detail-save-checkbox > span:nth-child(2) {
  color: #222222 !important;
  font-size: 12px !important;
  font-family: QuicksandMedium !important;
}

.payment-radio-heading span:nth-child(2) {
  cursor: pointer;
  font-size: 16px !important;
  /* font-family: QuicksandBold !important; */
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  appearance: none;
  -moz-appearance: textfield;
}

.the-state-input-in-cart
  > .css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {
  color: #0a64f9 !important;
}

/* end cart and payment */

/* Start Main Home page Search Bar */
.home-top-bar-search {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #f6f7f8;
  border-radius: 6px;
  margin-bottom: 180px;
  width: 100%;
}

.home-top-bar-search > .home-top-bar-search-input {
  background: #f6f7f8;
  padding: 3px 20px;
  width: 100% !important;
}

.home-top-bar-search > .home-top-bar-search-input,
.home-top-bar-search > .home-top-bar-search-input:focus,
.home-top-bar-search > .home-top-bar-search-input:active,
.home-top-bar-search > .home-top-bar-search-input:focus-within,
.home-top-bar-search > .home-top-bar-search-input:focus-visible {
  border: none;
  border-color: none !important;
}

.home-top-bar-search > .home-top-bar-search-input::placeholder {
  font-family: QuicksandRegular, 'Quicksand' !important;
  font-size: 15px;
  color: #a8a8a8;
}

.home-top-bar-search-icon {
  rotate: 0deg;
  margin-right: 12px;
}

.home-top-bar-search-input::after,
.home-top-bar-search-input::before {
  border: none !important;
}

/* End Main Home Page Search Bar */

/* start payment page coupon new ui */
.quickvee-shop-coupon {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.payment-summary-field {
  width: 100%;
  margin-bottom: 5px;
}

.payment-summary-action-row {
  display: flex;
  width: 100%;
  align-items: stretch;
  gap: 10px;
}

.payment-summary-action-row > .MuiFormControl-root {
  flex: 1 1;
  width: auto;
  min-width: 0;
}

.quickvee-shop-coupon .payment-summary-apply-btn {
  position: static;
  flex: 0 0 auto;
  min-width: 112px;
  height: 51px;
  padding: 0 18px;
  border: 1px solid #0a64f9;
  border-radius: 10px;
  background: #0a64f9;
  color: #ffffff;
  font-family: QuicksandBold, 'Quicksand', sans-serif !important;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition:
    background-color 160ms ease,
    border-color 160ms ease,
    box-shadow 160ms ease;
}

.quickvee-shop-coupon .payment-summary-apply-btn:hover {
  border-color: #0854d1;
  background: #0854d1;
}

/* .quickvee-shop-coupon .payment-remove-coupon{
  visibility: hidden;
}
#coupon-input:not(:placeholder-shown) .quickvee-shop-coupon .payment-remove-coupon{
visibility: visible;
} */

.quickvee-shop-coupon .payment-apply-coupon {
  visibility: hidden;
}

#coupon-input:not(:placeholder-shown) ~ .payment-apply-coupon {
  visibility: visible;
}

.quickvee-shop-coupon .payment-summary-remove-btn {
  position: static;
  flex: 0 0 auto;
  min-width: 112px;
  height: 51px;
  padding: 0 18px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fff5f5;
  color: #d92d20;
  font-family: QuicksandBold, 'Quicksand', sans-serif !important;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition:
    background-color 160ms ease,
    border-color 160ms ease,
    box-shadow 160ms ease;
}

.quickvee-shop-coupon .payment-summary-remove-btn:hover {
  border-color: #fda29b;
  background: #fee4e2;
}

.quickvee-shop-coupon .payment-summary-apply-btn:focus-visible,
.quickvee-shop-coupon .payment-summary-remove-btn:focus-visible {
  outline: 3px solid rgba(10, 100, 249, 0.22);
  outline-offset: 2px;
}

.quickvee-shop-coupon-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0px 0px 8px 0px;
}

.quickvee-shop-coupon-header > span:first-child,
.quickvee-shop-coupon-title {
  display: flex;
  align-items: center;
  color: #232323;
  /* font-size: 14px;
  font-family: QuicksandBold !important; */
}

.quickvee-shop-coupon-heading {
  display: flex;
  min-width: 0;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 3px 6px;
}

.quickvee-shop-coupon-title {
  font-family: QuicksandSemiBold, 'Quicksand', sans-serif !important;
}

.quickvee-shop-coupon-balance {
  color: #667085;
  font-size: 14px;
  font-family: QuicksandSemiBold, 'Quicksand', sans-serif !important;
}

@media (max-width: 430px) {
  .payment-summary-action-row {
    flex-direction: column;
    gap: 8px;
  }

  .quickvee-shop-coupon .payment-summary-apply-btn,
  .quickvee-shop-coupon .payment-summary-remove-btn {
    width: 100%;
    min-width: 0;
    height: 48px;
  }

  .quickvee-shop-coupon-balance {
    flex-basis: 100%;
  }
}

.quickvee-shop-coupon .payment-summary-input {
  width: 100%;
  outline: none;
  border: none;
  background: #ffffff;
  padding: 12px 10px;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  color: #000000;
  font-family: QuicksandSemiBold !important;
  font-size: 14px;
}

.quickvee-shop-coupon .payment-summary-input::placeholder {
  font-family: QuicksandSemiBold !important;
  color: #595959;
  font-size: 12px;
}

.quickvee-shop-coupon .payment-summary-input:not(:placeholder-shown) {
  border: 1px solid #000000;
}

.quickvee-shop-coupon .payment-summary-input:focus {
  border: 1px solid #000000;
}

.quickvee-shop-coupon .payment-summary-input-error {
  display: flex;
  align-items: center;
  /* width: 27%; */
  /* justify-content: center; */
  font-size: 11px !important;
  color: #f34747 !important;
  margin: 5px !important;
  align-self: flex-start;
  font-family: 'QuicksandSemiBold', 'Quicksand' !important;
}

.payment-summary-input-tip {
  width: 100%;
  outline: none;
  border: none;
  background: #ffffff;
  padding: 12px 10px;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  color: #000000;
  font-family: QuicksandSemiBold !important;
  font-size: 14px;
}

.payment-summary-input-tip::placeholder {
  font-family: QuicksandSemiBold !important;
  color: #595959;
  font-size: 12px;
}

.payment-summary-input-tip:not(:placeholder-shown) {
  border: 1px solid #000000;
}

.payment-summary-input-tip:focus {
  border: 1px solid #000000;
}

.payment-summary-input-tip-error {
  font-size: 9px !important;
  color: #f34747 !important;
  margin: 5px !important;
  align-self: flex-start;
  font-family: QuicksandRegular, 'Quicksand' !important;
}

.quickvee-shop-coupon-header .tip-cancle-btn {
  color: #f34747;
  font-family: QuicksandBold !important;
  font-size: 14px;
  cursor: pointer;
}

.custom-tip-section .payment-summary-add-tip {
  position: absolute;
  background-color: #fff;
  outline: none;
  border: none;
  color: #0a64f9;
  font-size: 14px;
  font-family: QuicksandBold !important;
  top: 67px;
  right: 9px;
  cursor: pointer;
}

.billing-date-time .css-1thjcug {
  background: #fff !important;
  border: 1px solid #d3d3d3 !important;
  border-radius: 6px !important;
}

.billing-date-time .css-14x1nlk,
.billing-date-time .css-1rgmeur {
  color: #595959 !important;
  font-family: QuicksandSemiBold !important;
  font-size: 14px !important;
}

.billing-date-time .css-ftr4jk {
  color: #000 !important;
  font-family: QuicksandSemiBold !important;
  font-size: 14px !important;
  padding: 22px 0px 6px 12px !important;
  /* font-family: QuicksandBold !important; */
}

.billing-date-time .css-17gq4vl {
  font-family: QuicksandSemiBold !important;
  font-size: 14px !important;
  /* padding: 22px 0px 10px 9px; */
}

.css-1rgmeur {
  font-family: QuicksandMedium, Quicksand !important;
}

.select-varient-cart .css-17gq4vl.MuiSelect-select {
  color: #0a64f9 !important;
}

/* end payment page coupon new ui */

.css-10botns-MuiInputBase-input-MuiFilledInput-input {
  height: 0px !important;
  padding-bottom: 16px !important;
}

/* dropdown loyalty point  */

.loyalty-customSelect {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.loyalty-customSelect {
  border-radius: 8px;
  padding: 8px 40px 8px 15px;
  font-family: QuicksandMedium !important;
  /* margin-right: 8px; */
  background-color: white;
  color: #2e2e2e;
  font-size: 16px;
}

.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper {
  /* max-height: calc(50% - 96px) !important; */
}

#menu-state {
  height: 300px;
}

.custom-select {
  position: relative;
  /* padding: 8px 15px 8px 15px; */
  font-family: QuicksandMedium !important;
  /* margin-right: 8px; */
  background-color: white;
  color: #2e2e2e;
  font-size: 16px;
  /* width: 200px;  */
  /* border: 1px solid #000; */
  /* border-radius: 8px; */
}

.default-option {
  cursor: pointer;
  padding: 5px 0px 5px 5px;
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center; /* Align items vertically */
  /* justify-content: space-between; */
}

.option {
  display: flex;
  align-items: center;
  width: 100% !important;
}

.select-ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 200px;
  position: absolute;
  background-color: #ffffff;
  border: 1px solid #fff;
  border-radius: 5px;
  box-shadow: 0px 6px 15px #0a64f94d;
  border-bottom: 1px solid #e1e1e1;
  margin-top: 5%;
  margin-left: -100px;
}

.select-ul li:not(:last-child) {
  border-bottom: 1px solid #e1e1e1;
}
.select-ul li {
  cursor: pointer;
  padding: 12px;
}

.select-ul li:hover {
  background-color: #f0f0f0;
}
.option .filter {
  width: 100% !important;
}

.lablePickup span {
  /* font-family: 'QuicksandSemiBold' !important; */
}

.payment-error-msg {
  font-family: QuicksandBold !important;
  padding: 0px 25px;
}

.load-more-btn {
  /* padding: 6px 16px; */
  font-weight: 500;
  font-size: 15px;
  border-radius: 4px;
  border: 1px solid #0a64f9;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 110px;
  height: 40px;
}

.load-more-btn span {
  height: 25px !important;
  width: 25px !important;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.text-right {
  text-align: right;
}

.mb-6 {
  margin-bottom: 24px;
}

.shareImageContainer {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin: 1rem;
}
.shareicon {
  min-width: 0;
  min-height: 92px;
  padding: 8px 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: transparent;
}
.shareicon:hover {
  border-color: #d7e5f7;
  background: #f5f9ff;
}
.shareicon:focus-visible {
  outline: 3px solid rgba(10, 100, 249, 0.24);
  outline-offset: 2px;
}
.shareicon img {
  width: 56px;
  height: 56px;
  object-fit: contain;
}
.shareicon span {
  max-width: 100%;
  overflow: hidden;
  color: #1d2939;
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shareicon p,
.copyContainer p {
  font-weight: 500;
  font-size: 13px;
}
.share-modal {
  border: none !important;
}
.copyContainer {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  border-radius: 12px;
  margin: 1rem;
  padding: 10px;
  border: 1px solid #d9d9d9;
  align-items: center;
}
.copyContainer p {
  min-width: 0;
  flex: 1 1;
  margin: 0;
  overflow: hidden;
  color: #000000;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 560px) {
  .shareImageContainer {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }

  .shareicon {
    min-height: 84px;
  }

  .shareicon img {
    width: 52px;
    height: 52px;
  }
}

@media (max-width: 340px) {
  .shareImageContainer {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .copyContainer {
    margin: 12px;
  }
}

/* Custom Scrollbar */
.customScrollbar {
  overflow-y: auto;
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #3e85f8 #eee; /* Firefox */
}

/* Chrome / Safari / Edge */
.customScrollbar::-webkit-scrollbar {
  width: 3px;
}

.customScrollbar::-webkit-scrollbar-track {
  background: #eee;
  border-radius: 10px;
}

.customScrollbar::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
}

.customScrollbar::-webkit-scrollbar-thumb:hover {
  background: #246be0;
}
/* New Landing Page */

.hero-address-input { padding-left: 2.5rem !important; }


.landing-footer {
  ul {
    padding: 0;
  }
  a{color: #AEB6C8}
  a:hover {color: #ffffff; }
}

/* Uber delivery intro modal */
/* body.uber-delivery-modal-open #root {
  filter: blur(5px);
} */

.uber-delivery-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

.uber-delivery-modal {
  background: #ffffff;
  border-radius: 16px;
  /* padding: 32px; */
  max-width: 520px;
  /* width: 90%; */
  box-shadow: 0px 30px 80px rgba(15, 23, 42, 0.3);
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.uber-delivery-modal-close-wrapper {
  display: flex;
  height: 48px;
  padding: 16px 16px 0 0;
  justify-content: flex-end;
  align-items: flex-start;
  align-self: stretch;
}

.uber-delivery-modal-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.uber-delivery-modal-logo-description-content-wrapper {
  display: flex;
  padding: 0 32px;
  flex-direction: column;
  align-items: center;
  gap: 36px;
  align-self: stretch;
}
.uber-delivery-modal-logo-wrapper {
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.uber-delivery-modal-logo {
  height: 46px;
  width: auto;
}

.uber-delivery-modal-close {
  width: 20px;
  height: 20px;
}

.uber-delivery-modal-close img {
  width: 10px;
  height: 10px;
}

.uber-delivery-modal-icon-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.uber-delivery-modal-icon-circle {
  width: 64px;
  height: 64px;
  border-radius: 999px;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uber-delivery-modal-icon-circle img {
  width: 32px;
  height: 32px;
}

.uber-delivery-modal-title {
  display: none;
}

.uber-delivery-modal-description {
  margin: 0 auto 36px;
  max-width: 358px;
  text-align: center;
  color: #101828;
  font-family:
    'Jost',
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 22.4px;
  font-style: normal;
  font-weight: 500;
  line-height: 29.12px; /* 130% */
  letter-spacing: -0.15px;
}

.uber-delivery-modal-description-strong {
  font-weight: 700;
}

.uber-delivery-modal-primary {
  display: flex;
  padding: 12px 134px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 14px;
  background: #000;
  color: #fff;
  text-align: center;
  font-family: Jost;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}

.uber-delivery-modal-primary:hover {
  background: #111111;
}

.uber-delivery-modal-secondary {
  background: transparent;
  border: none;
  margin-top: 16px;
  color: #99a1af;
  font-family:
    'Jost',
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 13.6px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.4px; /* 150% */
  cursor: pointer;
}

.uber-delivery-modal-secondary:hover {
  color: #4b5563;
}

@media (max-width: 767.98px) {
  .uber-delivery-modal {
    width: 90%;
  }

  .uber-delivery-modal-primary {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
  .uber-delivery-modal-button-wrapper{
    width: 100%;
  }
}

@media (max-width: 480px) {
  .uber-delivery-modal {
    padding: 24px 20px 20px;
    border-radius: 12px;
  }

  .uber-delivery-modal-title {
    font-size: 20px;
  }

  .uber-delivery-modal-description {
    font-size: 18px;
    line-height: 24px;
  }
}

.uber-delivery-modal-button-wrapper {
  display: flex;
  padding-bottom: 32px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/App.css"],"names":[],"mappings":"AAMA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB;;sBAEoB;AACtB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,yCAAyC;EACzC,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,6CAA6C;EAC7C,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,gFAAgF;;AAEhF;EACE,SAAS;EACT,UAAU;EACV,4BAA4B;AAC9B;;AAEA;;;;EAIE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,4CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,4CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,4CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,4CAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,4CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,4CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,4CAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;AACA;EACE,0BAA0B;EAC1B,4CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,6CAAuD;AACzD;AACA;;;;;;;;;;;;;;;;;;;GAmBG;;AAEH;EACE,iBAAiB;EACjB,6CAA0C;AAC5C;;AAEA,kCAAkC;AAClC;EACE;;;4BAG0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,oDAA2D;EAC3D,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE;IACE,oDAA2D;IAC3D,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oDAA2D;IAC3D,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oDAA2D;IAC3D,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oDAA2D;IAC3D,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,sDAAsD;EACtD,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,oDAAoD;EACpD;;kCAEgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,oDAAoD;EACpD;;kCAEgC;AAClC;;AAEA;;;EAGE,0BAA0B;EAC1B,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;EAC9B,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;;EAEE,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;;EAEE,0BAA0B;EAC1B,sDAAsD;EACtD,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,iCAAiC;AACnC;AACA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;EAYE,8BAA8B;AAChC;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;GAEG;;AAEH;;EAEE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;;EAEE,4BAA4B;EAC5B,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,qDAAqD;EACrD,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,UAAU;IACV,aAAa;EACf;;EAEA;IACE,UAAU;IACV,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;GAUG;AACH;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,qCAAqC;EACrC,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oCAAoC;EACpC,qCAAqC;EACrC,0BAA0B;EAC1B,sDAAsD;EACtD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qDAAqD;AACvD;;AAEA;;EAEE,0BAA0B;EAC1B,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kDAAkD;EAClD,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qBAAqB;;AAErB,4BAA4B;;AAE5B;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;;AAE9B,wBAAwB;AACxB,kBAAkB;;AAElB;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;AACb;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;;EAKE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB;qBACmB;EACnB,wBAAwB;EACxB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,gBAAgB;;AAEhB,mBAAmB;;AAEnB;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,OAAO;AACT;;AAEA;EACE;IACE,uBAAuB;IACvB,kCAAkC;IAClC,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4DAAgE;EAChE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4DAAgE;AAClE;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4DAAkE;EAClE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4DAAkE;AACpE;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sDAAsD;EACtD,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;GAKG;;AAEH;;;;EAIE,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kDAAkD;AACpD;;AAEA,iBAAiB;;AAEjB,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kDAAkD;AACpD;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;;EAElB,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,oDAAoD;EACpD,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE;;;;IAIE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;;;;;;;EAQE,cAAc;EACd,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA,uBAAuB;;AAEvB,8BAA8B;;AAE9B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mEAAmE;EACnE,6CAA6C;EAC7C,oDAA6D;EAC7D,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sDAAsD;EACtD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sDAAsD;EACtD,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,kDAAkD;EAClD,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,0BAA0B;EAC1B,sDAAsD;AACxD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,qCAAqC;EACrC,kDAAkD;EAClD,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,kDAAkD;EAClD,UAAU;EACV,YAAY;AACd;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,sDAAsD;EACtD,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,sDAAsD;EACtD,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,cAAc;EACd,sDAAsD;EACtD,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,sDAAsD;EACtD,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;;;;EAIE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,WAAW;AACb;;AAEA;;;;;GAKG;;AAEH;;GAEG;AACH;EACE,cAAc;EACd,eAAe;EACf,kDAAkD;EAClD,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;;;;;;;;;IAYI;;AAEJ;;EAEE,yBAAyB;EACzB,kDAAkD;EAClD,0BAA0B;EAC1B,kCAAkC;EAClC,iCAAiC;EACjC,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;;;EAIE,yBAAyB;EACzB,sDAAsD;EACtD,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;;;EAIE,yBAAyB;EACzB,sDAAsD;EACtD,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,sDAAsD;EACtD,eAAe;EACf,aAAa;AACf;;AAEA;;;EAGE,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE;oBACkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;+BAC6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,4BAA4B;;AAE5B,uBAAuB;;AAEvB;EACE,aAAa;EACb,sBAAsB;EACtB,oDAA4D;EAC5D,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;;GAEG;AACH;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAE/B,WAAW;EACX,kCAAkC;AACpC;;AAEA,WAAW;;AAWX;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;;;;EAIE,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;;;;;;;;EAQE,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,eAAe;EACf,sDAAsD;EACtD,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmCE,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;EACf,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;EACf,kDAAkD;EAClD,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;EACf,kDAAkD;AACpD;;AAEA,qBAAqB;;AAErB,sBAAsB;;AAEtB,mBAAmB;AACnB;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kCAAkC;;EAElC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,uBAAuB;EACvB,aAAa;AACf;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;;EAIE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,kDAAkD;EAClD,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE;;;;GAIC;EACD,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;EACX,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,sDAAsD;EACtD,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,kDAAkD;EAClD,aAAa;EACb,eAAe;AACjB;;AAEA;;;;EAIE,UAAU;EACV,cAAc;EACd,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;;;EAIE,yBAAyB;EACzB,sDAAsD;EACtD,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;;;EAIE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;;EAKE,cAAc;EACd,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;;;;EAIE,yBAAyB;EACzB,sDAAsD;EACtD,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;;;EAIE,yBAAyB;EACzB,sDAAsD;EACtD,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uBAAuB;;AAEvB,0BAA0B;;AAE1B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;EAKE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;EAIE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;;;;;EAKE,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;;;EAME,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;;;;;EAUE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,qCAAqC;EACrC,0BAA0B;EAC1B,qCAAqC;EACrC,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,qCAAqC;EACrC,0BAA0B;EAC1B,qCAAqC;EACrC,yBAAyB;EACzB,YAAY;AACd;AACA;;;;EAIE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,YAAY;AACd;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA,UAAU;AACV;;;EAGE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;;;EAGE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;;;EAGE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;EAIE,+BAA+B;EAC/B,0DAAsD;EACtD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,kDAAkD;EAClD,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kDAAkD;EAClD,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,UAAU;AACZ;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;EACf,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;;GAEG;AACH;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,oDAAoD;EACpD,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,0BAA0B;EAC1B,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB;IACE,SAAS;EACX;AACF;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EAEX,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,yBAAyB;EACzB,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,yBAAyB;EAEzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,yCAAyC;EACzC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,0BAA0B;EAC1B,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;;;;;EAKE,sBAAsB;EACtB,0DAAqD;AACvD;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb;4BAC0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,UAAU;IACV,UAAU;IACV,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,aAAa;EACb,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,cAAc;EACd,0BAA0B;EAC1B,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;EACtD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;EACX;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;EACX;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,wCAAwC;EACxC,eAAe;AACjB;;AAEA;;;EAGE,0BAA0B;EAC1B,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,+DAA+D;;EAE/D,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EAEzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;EAC/C,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;EAC/C,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;EAIE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;;;;EAIE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;;;EAIE,cAAc;EACd,yCAAyC;EACzC,qCAAqC;EACrC,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,UAAU;EACV,WAAW;EACX,UAAU;EACV,UAAU;EACV,aAAa;AACf;AACA;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE;MACE,UAAU;MACV,WAAW;IACb;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;MACV,aAAa;IACf;EACF;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;KAEK;;AAEL;;GAEG;;AAEH;;;;GAIG;AACH;;;EAGE,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,yBAAyB;;AAEzB,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;;EAKE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,kCAAkC;;AAElC,qCAAqC;AACrC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,SAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,8DAA8D;EAC9D,eAAe;EACf,cAAc;EACd,eAAe;EACf;;;yBAGuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,8DAA8D;EAC9D,eAAe;EACf,cAAc;EACd,eAAe;EACf;;;yBAGuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd;0CACwC;AAC1C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;;AAEnC;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,4BAA4B;;AAE5B;EACE,0DAAuD;EACvD,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,uCAAuC;EACvC,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,uCAAuC;EACvC,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB,EAAE,2BAA2B;EAChD,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,SAAO;EACP,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;IAChD,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;EACnC,6BAA6B,EAAE,YAAY;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+CAAuC;EAAvC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;AACA,qBAAqB;;AAErB,sBAAsB,+BAA+B,EAAE;;;AAGvD;EACE;IACE,UAAU;EACZ;EACA,EAAE,cAAc;EAChB,SAAS,cAAc,EAAE;AAC3B;;AAEA,8BAA8B;AAC9B;;GAEG;;AAEH;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd;;;;;;cAMY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB,EAAE,SAAS;EAC/B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd;;;;;;cAMY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Quicksand&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@600&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&display=swap');\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font: normal !important;\n  /* -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none; */\n}\n\n*,\n::after,\n::before {\n  box-sizing: border-box;\n}\n\n.qvrow {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n\n.qvrow > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col-qv-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n/* remove this for focus border in input border: 2px solid #0A64F9 !important; */\n\np {\n  margin: 0;\n  padding: 0;\n  margin-bottom: 0px!important;\n}\n\ninput:hover,\ninput:focus,\nInput:hover,\nInput:focus {\n  background-color: none !important;\n  background: none;\n}\n\n@font-face {\n  font-family: QuicksandLight;\n  src: url(../Assets/fonts/Quicksand-Light.ttf);\n}\n\n@font-face {\n  font-family: QuicksandLight;\n  src: url(../Assets/fonts/Quicksand-Light.ttf);\n}\n\n@font-face {\n  font-family: QuicksandBold;\n  src: url(../Assets/fonts/Quicksand-Bold.ttf);\n}\n\n@font-face {\n  font-family: QuicksandMedium;\n  src: url(../Assets/fonts/Quicksand-Medium.ttf);\n}\n\n@font-face {\n  font-family: QuicksandRegular;\n  src: url(../Assets/fonts/Quicksand-Regular.ttf);\n}\n\n@font-face {\n  font-family: QuicksandSemiBold;\n  src: url(../Assets/fonts/Quicksand-SemiBold.ttf);\n}\n\n@font-face {\n  font-family: QuicksandLight;\n  src: url(../Assets/fonts/Quicksand-Light.ttf);\n}\n\n@font-face {\n  font-family: OutfitSemiBold;\n  src: url(../Assets/fonts/Outfit-SemiBold.ttf);\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: OutfitMedium;\n  src: url(../Assets/fonts/Outfit-Medium.ttf);\n}\n\n@font-face {\n  font-family: OutfitBold;\n  src: url(../Assets/fonts/Outfit-Bold.ttf);\n}\n\n@font-face {\n  font-family: OutfitRegular;\n  src: url(../Assets/fonts/Outfit-Regular.ttf);\n}\n@font-face {\n  font-family: circular-bold;\n  src: url(../Assets/fonts/circular-bold.TTF);\n}\n@font-face {\n  font-family: Circular-Std-Regular-Book;\n  src: url(../Assets/fonts/Circular-Std-Regular-Book.ttf);\n}\n/* \n@font-face {\n  font-family: QuicksandBold;\n  src: url(https://fonts.googleapis.com/css2?family=Quicksand:wght@700&display=swap);\n}\n\n@font-face {\n  font-family: QuicksandMedium;\n  src: url(https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap);\n}\n\n@font-face {\n  font-family: QuicksandRegular;\n  src: url(https://fonts.googleapis.com/css2?family=Quicksand&display=swap);\n}\n\n@font-face {\n  font-family: QuicksandSemiBold;\n  src: url(https://fonts.googleapis.com/css2?family=Quicksand:wght@600&display=swap);\n} */\n\n@font-face {\n  font-family: Jost;\n  src: url(../Assets/fonts/Jost-Regular.ttf);\n}\n\n/* main authentication component */\n.main-authentication-component {\n  /* display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center; */\n  /* padding: 15px; */\n}\n\n.wrapper {\n  width: 55%;\n  /* margin-left: auto; */\n  border-radius: 15px;\n  background: url('../Assets/LoginScreen/LoginBanner1.1.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  justify-self: stretch;\n  height: 95vh;\n  animation: slider 10s infinite;\n}\n\n.my-overflow-hanlde-for-authentication {\n  /* padding: 20px 60px 20px 0; */\n  height: 95vh;\n  justify-content: flex-start !important;\n  overflow-y: auto;\n  scroll-behavior: smooth;\n  overflow-x: hidden;\n}\n\n@media (max-width: 1024px) {\n  .my-overflow-hanlde-for-authentication {\n    overflow-y: unset;\n    scroll-behavior: smooth;\n    overflow-x: unset;\n  }\n}\n\n/* width */\n.my-overflow-hanlde-for-authentication::-webkit-scrollbar {\n  width: 3px;\n}\n\n/* Track */\n.my-overflow-hanlde-for-authentication::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n/* Handle */\n.my-overflow-hanlde-for-authentication::-webkit-scrollbar-thumb {\n  background: #3e85f8;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.3s ease-in-out;\n  outline: 1px solid #fff;\n}\n\n/* Handle on hover */\n.my-overflow-hanlde-for-authentication::-webkit-scrollbar-thumb:hover {\n  background: #0a64f9;\n  cursor: pointer !important;\n}\n\n@keyframes slider {\n  0% {\n    background: url('../Assets/LoginScreen/LoginBanner1.1.png');\n    background-size: cover;\n    background-position: center;\n  }\n\n  30% {\n    background: url('../Assets/LoginScreen/LoginBanner2.1.png');\n    background-size: cover;\n    background-position: center;\n  }\n\n  60% {\n    background: url('../Assets/LoginScreen/LoginBanner3.1.png');\n    background-size: cover;\n    background-position: center;\n  }\n\n  100% {\n    background: url('../Assets/LoginScreen/LoginBanner1.1.png');\n    background-size: cover;\n    background-position: center;\n  }\n}\n\n/*Customer Login*/\n@media screen and (max-width: 900px) {\n  .my-overflow-hanlde-for-authentication {\n    /* overflow-x: hidden; */\n    padding: 20px 40px 20px 0;\n  }\n}\n\n@media screen and (max-width: 750px) {\n  .login-customer-form {\n    margin-right: 20px;\n  }\n}\n\n@media screen and (max-width: 678px) {\n  .wrapper {\n    display: none;\n  }\n\n  .my-overflow-hanlde-for-authentication {\n    /* overflow: auto; */\n    padding: 0px;\n    height: auto;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .wrapper {\n    display: none;\n  }\n\n  .quickvee-logo-authentication {\n    /* width: 150px !important; */\n  }\n\n  .back-auth-icons {\n    top: 7px !important;\n    left: 1% !important;\n  }\n}\n\n.quickvee-logo-authentication {\n  width: 160px;\n  margin: 0 0 30px 0;\n}\n\n.css-18djxyj-MuiPaper-root-MuiAlert-root {\n  padding: 6px 10px !important;\n}\n\n.login-customer-form {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.input-error {\n  /* display: inherit; */\n  /* right: 0; */\n  margin: 3px !important;\n  padding: 0px !important;\n  /* float: left !important; */\n  /* justify-self: right; */\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 11px !important;\n  color: #fa0000 !important;\n}\n\n.login-customer-form > h1 {\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 19px;\n  color: #222222 !important;\n}\n\n.login-customer-form .sub-heading-from {\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  font-size: 14px;\n  color: #232323 !important;\n  margin: 10px 0 25px 0;\n}\n\n.sub-heading-from {\n  width: 300px;\n}\n\n.password-input-field {\n  display: flex;\n  max-width: 100%;\n  width: 300px;\n  font-size: 12px !important;\n  background: #ffffff;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  /* background: #FFFFFF !important;\n  border: 1px solid #D3D3D3 !important;\n  border-radius: 6px !important; */\n}\n\n.password-input-field:focus-within {\n  border: 2px solid #0a64f9 !important;\n}\n\n.customer-login-input {\n  max-width: 100%;\n  width: 300px;\n  font-size: 12px !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  /* background: #FFFFFF !important;\n  border: 1px solid #D3D3D3 !important;\n  border-radius: 6px !important; */\n}\n\n.customer-login-input .css-1njz7x1,\n.password-input-field .css-1njz7x1,\n.payment-billing-input .css-1njz7x1 {\n  font-size: 13px !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  color: #595959 !important;\n}\n\n.customer-login-input .css-dvhgws,\n.password-input-field .css-dvhgws,\n.payment-billing-input .css-dvhgws {\n  background: #ffffff !important;\n  /* border: 1px solid #d3d3d3 !important; */\n  border-radius: 6px !important;\n}\n\n.css-s2lqj8,\n.css-s2lqj8.Mui-focused {\n  font-size: 13px !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n}\n\n.modal-form-single-input .css-s2lqj8,\n.modal-form-single-input .css-ftr4jk {\n  font-size: 13px !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  color: #000000;\n}\n\n.modal-form-single-item .css-17gq4vl.MuiSelect-select {\n  font-size: 13px !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  color: #000000 !important;\n}\n\n.modal-form-single-item .css-17gq4vl:focus {\n  background-color: #fff !important;\n}\n\n.modal-form-single-item .css-1thjcug:hover {\n  background-color: #fff !important;\n}\n\n.css-1thjcug:hover {\n  background-color: #fff !important;\n}\n\n.css-fi4tqy {\n  padding: 14px 12px 4px !important;\n  font: unset !important;\n  font-size: 15px !important;\n  font-family: QuicksandSemiBold !important;\n}\n\n.modal-form-single-input .css-fi4tqy {\n  padding: 18px 12px 4px !important;\n  font: unset !important;\n  font-size: 15px !important;\n  height: 1.98rem;\n  font-family: QuicksandSemiBold !important;\n}\n.css-2bxn45 {\n  padding: 22px 12px 8px !important;\n}\n.customer-login-input > div .css-dvhgws:hover,\n.customer-login-input .css-dvhgws.Mui-focused,\n.password-input-field > div .css-dvhgws:hover,\n.password-input-field .css-dvhgws.Mui-focused {\n  background: #ffffff !important;\n}\n\n.password-input-field\n  .css-dvhgws:hover:not(\n    .Mui-disabled,\n    .password-input-field .Mui-error\n  )::before,\n.password-input-field .css-dvhgws:hover:not(.Mui-disabled, .Mui-error)::before,\n.customer-login-input\n  .css-dvhgws:hover:not(\n    .Mui-disabled,\n    .customer-login-input .Mui-error\n  )::before,\n.customer-login-input .css-dvhgws:hover:not(.Mui-disabled, .Mui-error)::before {\n  border-bottom: none !important;\n}\n\n.customer-login-input .css-dvhgws::before,\n.password-input-field .css-dvhgws::before,\n.payment-billing-input .css-dvhgws::before {\n  border-bottom: none !important;\n}\n\n.css-dvhgws::after {\n  border-bottom: none !important;\n}\n\n/* .customer-login-error-input{\n  border: 1px solid #F55353 !important;\n} */\n\n.customer-login-input:focus-within,\n.password-input-field:focus-within {\n  border: 2px solid #0a64f9 !important;\n  border-radius: 6px !important;\n}\n\n.modal-form-single-input .css-1thjcug.Mui-focused {\n  background-color: #fff !important;\n}\n\n.modal-form-single-input .css-1thjcug {\n  background-color: #fff !important;\n}\n\n.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root:hover {\n  border-color: #911b1b !important;\n}\n\n.css-17mgbju::before,\n.css-1thjcug::before,\n.css-17mgbju::after,\n.css-1thjcug::after {\n  border: none !important;\n}\n\n.css-1ff8729-MuiInputBase-root-MuiFilledInput-root {\n  background: none !important;\n  top: 8px !important;\n  font-size: 14px !important;\n}\n\n.css-1ff8729-MuiInputBase-root-MuiFilledInput-root:before {\n  border: none !important;\n}\n\n.css-1ff8729-MuiInputBase-root-MuiFilledInput-root:after {\n  border: none !important;\n}\n\n.css-1mog9k0-MuiFormLabel-root-MuiInputLabel-root {\n  font-size: 13px !important;\n  color: #595959 !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n}\n\n.css-11qvwfa-MuiFormLabel-root-MuiInputLabel-root {\n  font-size: 14px !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n}\n\n.css-11qvwfa-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {\n  font-size: 14px !important;\n  color: #595959 !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n}\n\n.css-c5v1qu-MuiInputBase-input-MuiFilledInput-input:focus,\n.css-c5v1qu-MuiInputBase-input-MuiFilledInput-input {\n  padding-top: 13px !important;\n  padding-bottom: 10px !important;\n  font-family: QuicksandSemibold, 'Quicksand' !important;\n}\n\n.css-yf8vq0-MuiSelect-nativeInput {\n  font-family: QuicksandSemibold, 'Quicksand' !important;\n}\n\n.css-6hp17o-MuiList-root-MuiMenu-list > li {\n  /* color: #0A64F9 !important; */\n  font-size: 12px;\n  font-family: QuicksandSemibold, 'Quicksand' !important;\n}\n\n.css-1gctnaj-MuiInputBase-input-MuiFilledInput-input {\n  font-family: QuicksandSemibold, 'Quicksand' !important;\n}\n\n.input-outer-div {\n  position: relative;\n\n  display: flex;\n  flex-direction: column;\n  margin: 9px 0;\n}\n\n.css-1pysi21-MuiFormLabel-root-MuiInputLabel-root {\n  font-size: 14px !important;\n  color: #595959 !important;\n}\n\n.error-on-submit {\n  align-self: flex-start !important;\n  text-transform: capitalize;\n  font-family: QuicksandRegular, 'Quicksand' !important;\n  font-size: 11px !important;\n  color: #fa0000 !important;\n}\n\n.css-1e6y48t-MuiButtonBase-root-MuiButton-root.Mui-focusVisible {\n  background-color: #fff !important;\n}\n\n.form-submit-error-message {\n  position: relative;\n  right: 0px;\n  bottom: -15px;\n  animation: slideTopError 0.8s;\n}\n\n.css-1pxa9xg-MuiAlert-message {\n  text-transform: capitalize !important;\n  font-family: QuicksandSemibold !important;\n}\n\n@keyframes slideTopError {\n  0% {\n    opacity: 0;\n    right: 0px;\n    bottom: -35px;\n  }\n\n  100% {\n    opacity: 1;\n    right: 0px;\n    bottom: -8px;\n  }\n}\n\n.error-close-icon {\n  color: #000 !important;\n  background-color: #fff !important;\n}\n\n.customer-login-input::placeholder {\n  color: #595959 !important;\n}\n\n/* .password-input-field {\n  display: flex;\n  max-width: 100%;\n  width: 300px;\n  font-size: 10px !important;\n  background: #FFFFFF;\n  border-radius: 6px !important;\n  font-family: QuicksandMedium !important;\n  border: 2px solid #D3D3D3;\n  border-radius: 6px;\n} */\n.unvisible-input {\n  display: none !important;\n}\n\n.customer-banner-authentication {\n  display: flex;\n  align-items: 'center' !important;\n  justify-content: space-around !important;\n  flex-direction: row !important;\n  flex-wrap: nowrap;\n  vertical-align: middle !important;\n  margin: 3vh 3vw;\n}\n\n.password-input-text,\n.password-input-text:hover {\n  outline-style: none;\n  border-style: none;\n  border: none;\n  color: #595959 !important;\n  font-size: 14px;\n}\n\n.css-c5v1qu-MuiInputBase-input-MuiFilledInput-input {\n  color: #000000 !important;\n  font: normal !important;\n  letter-spacing: normal !important;\n}\n\n.forgot-password {\n  align-self: end !important;\n  font-size: 14px !important;\n  text-decoration: underline !important;\n  color: #0a64f9 !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n}\n\n.customer-btn {\n  width: 100%;\n  width: 300px;\n  margin: 20px 0 !important;\n  background-color: #0a64f9 !important;\n  text-transform: capitalize !important;\n  font-size: 16px !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  height: 44px;\n}\n\n.sign-in-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: #222222;\n  font-size: 14px;\n  font-family: QuicksandRegular, 'Quicksand' !important;\n}\n\n.sign-in-section-head > p {\n  color: #222222;\n  font-size: 13px;\n  font-family: QuicksandRegular, 'Quicksand' !important;\n}\n\n.css-1pysi21-MuiFormLabel-root-MuiInputLabel-root,\n.css-yjsfm1 > span {\n  font-size: 13px !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  color: #595959 !important;\n}\n\n.sign-in-section-head > span > hr {\n  margin: 0 15px;\n  rotate: 90deg;\n  height: 15px;\n  color: #707070;\n}\n\n.customer-login-with-google {\n  display: flex;\n  width: 100%;\n  width: 300px;\n  margin: 20px 0 !important;\n  color: #222222 !important;\n  text-transform: capitalize !important;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: 14px !important;\n  background: #ffffff !important;\n  border: 2px solid #d3d3d3;\n  border-radius: 6px;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n}\n\n.customer-login-with-google > img {\n  position: absolute !important;\n  right: 0 !important;\n  margin-right: 15px;\n}\n\n.login-customer-reduirection {\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  letter-spacing: 0px;\n  color: #595959;\n  font-size: 13px;\n  margin: 5px 0 !important;\n}\n\n.login-customer-reduirection > .login-customer-reduirection-link {\n  font-family: QuicksandBold, 'Quicksand' !important;\n  color: #222222 !important;\n  font-weight: 800 !important;\n  margin: 0 2px;\n  font-size: 13px;\n  text-decoration: none !important;\n}\n\n.back-auth-icons {\n  position: absolute;\n  top: 25px;\n  left: 5%;\n  background: none !important;\n  color: black;\n}\n\n.login-customer-reduirection > .login-customer-reduirection-link:hover {\n  text-decoration: none !important;\n}\n\n/*end Customer Login*/\n\n/* start Customer Register */\n\n.register-inputs-div {\n  display: flex;\n  justify-content: space-between;\n  width: 300px;\n}\n\n.c-register {\n  width: 145px;\n}\n\n/* end customer registration */\n\n/* start order history */\n/* start top bar */\n\n.main-order-top-bar {\n  padding: 10px 3px;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky !important;\n  top: 0 !important;\n  background: #ffffff;\n  border-bottom: 1px solid #ebebeb;\n  z-index: 99;\n}\n@media (min-width: 768px) {\n  .main-order-top-bar {\n    padding: 10px 20px 10px 0px !important;\n  }\n}\n.quickvee-logo-order-top-bar {\n  width: 148px;\n  height: 40px;\n  margin-right: 0px;\n}\n\n.order-top-bar-search {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  background: #f6f7f8;\n  border-radius: 6px;\n  /* padding: 2px 10px; */\n  padding-left: 3%;\n  padding-right: 3%;\n  width: 35vw;\n}\n\n.online-o-page-profile-drop-btn {\n  margin: 0px 0px 0px 8px;\n}\n\n@media (max-width: 768px) {\n  .online-o-page-profile-drop-btn {\n    display: none !important;\n  }\n}\n.my-profile-drop-btn {\n  margin: 0px 11px 0 8px;\n}\n\n.my-profile-drop-btn img {\n  width: 20px;\n}\n\n.top-bar-button {\n  flex-grow: 1;\n  color: #232323 !important;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  text-transform: capitalize !important;\n}\n\n.order-top-bar-search > .order-top-bar-search-input {\n  background: #f6f7f8;\n  padding: 3px 10px;\n  width: 100% !important;\n}\n\n.order-top-bar-search > .order-top-bar-search-input,\n.order-top-bar-search > .order-top-bar-search-input:focus,\n.order-top-bar-search > .order-top-bar-search-input:active,\n.order-top-bar-search > .order-top-bar-search-input:focus-within,\n.order-top-bar-search > .order-top-bar-search-input:focus-visible {\n  border: none;\n  border-color: none !important;\n}\n\n.order-top-bar-search > .order-top-bar-search-input::placeholder {\n  font-family: QuicksandRegular, 'Quicksand' !important;\n  font-size: 15px;\n  color: #a8a8a8;\n}\n\n.css-q0jhri-MuiInputBase-root-MuiInput-root {\n  font-family: QuicksandSemibold, 'Quicksand' !important;\n}\n\ninput[type='search']::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n  cursor: pointer;\n  height: 20px;\n  width: 20px;\n  border-radius: 50em;\n  background: url(https://pro.fontawesome.com/releases/v5.10.0/svgs/solid/times-circle.svg)\n    no-repeat 50% 50%;\n  background-size: contain;\n  opacity: 0;\n  pointer-events: none;\n}\n\ninput[type='search']:focus::-webkit-search-cancel-button {\n  opacity: 0.3;\n  pointer-events: all;\n}\n\n.order-top-bar-search-icon {\n  rotate: 90deg;\n  margin-right: 5px;\n}\n\n.order-top-bar-search-input::after,\n.order-top-bar-search-input::before {\n  border: none !important;\n}\n\n/* end top bar */\n\n/* start side bar */\n\n.order-side-bar-component {\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  width: 250px;\n  overflow: hidden;\n  height: 100%;\n  border-right: 1px solid #ebebeb;\n  position: fixed;\n  background-color: #fff;\n  /* padding: 20px 0 0 0; */\n  transition: all 0.3s ease-in-out;\n  left: 0;\n}\n\n@media (min-width: 768px) {\n  .order-side-bar-component {\n    width: 250px !important;\n    transition: width 0.3s ease-in-out;\n    /* Adjust width for smaller screens */\n  }\n}\n\n@media (max-width: 767px) {\n  .order-history-main-component {\n    margin-left: 0px !important;\n  }\n\n  .order-history-main-component > .order-history-top-component > h1 {\n    font-size: 18px !important;\n  }\n\n  .basic-modal {\n    width: 90%;\n  }\n}\n\n.order-side-bar-component > .order-side-bar-link,\n.order-side-bar-component > div .order-side-bar-link-div {\n  text-decoration: none !important;\n}\n\n.order-side-bar-component > .order-side-bar-link {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin: 0px 10px 0px 20px;\n  padding: 11px 10px;\n  color: #2e2e2e;\n}\n\n.order-side-bar-component > .order-side-bar-link:hover {\n  color: #6e81e2;\n  background: #f1f6ff;\n  border-radius: 5px;\n}\n\n.order-side-bar-component > .order-side-bar-link > .link-home {\n  background: #2e2e2e;\n  width: 20px;\n  height: 200%;\n  mask: url('../Assets/OrderScreen/HomeIcon.svg') no-repeat 0px;\n  transition: all 0.2s ease-in;\n}\n\n.order-side-bar-component > .order-side-bar-link:hover > .link-home {\n  background: #6e81e2;\n  mask: url('../Assets/OrderScreen/HomeIcon.svg') no-repeat 0px;\n}\n\n.order-side-bar-component > .order-side-bar-link > .link-reorder {\n  background: #2e2e2e;\n  width: 20px;\n  height: 200%;\n  mask: url('../Assets/OrderScreen/ReorderIcon.svg') no-repeat 0px;\n  transition: all 0.2s ease-in;\n}\n\n.order-side-bar-component > .order-side-bar-link:hover > .link-reorder {\n  background: #6e81e2;\n  mask: url('../Assets/OrderScreen/ReorderIcon.svg') no-repeat 0px;\n}\n\n.order-side-bar-component > .order-side-bar-link > .link-wishlist {\n  background: #2e2e2e;\n  width: 20px;\n  height: 200%;\n  mask: url('../Assets/OrderScreen/FavouriteIcon.svg') no-repeat 0px;\n  transition: all 0.2s ease-in;\n}\n\n.order-side-bar-component > .order-side-bar-link:hover > .link-wishlist {\n  background: #6e81e2;\n  mask: url('../Assets/OrderScreen/FavouriteIcon.svg') no-repeat 0px;\n}\n\n.order-side-bar-component > .order-side-bar-link > span {\n  color: #2e2e2e;\n  margin-left: 10px;\n  font-family: QuicksandSemibold, 'Quicksand' !important;\n  font-size: 14px;\n  padding: 0 10px;\n}\n\n.order-side-bar-component > .order-side-bar-link:hover > span {\n  color: #6e81e2;\n}\n\n.order-side-bar-component > div .order-side-bar-link-div {\n  display: flex;\n  align-items: center;\n  color: #2e2e2e !important;\n  font-family: QuicksandSemibold !important;\n  padding: 10px 0px !important;\n  border-left: 3px solid #ffffff;\n  padding-left: 20px !important;\n  font-size: 15px;\n}\n\n.order-side-bar-component > div {\n  display: flex;\n  /* margin-top: 20px; */\n  flex-direction: column;\n  width: 100% !important;\n  transition: all 2s ease-in-out;\n}\n\n.order-side-bar-component > div .order-side-bar-link-div {\n  transition: all 0.3s ease-in-out;\n}\n\n/* .order-side-bar-component > div .order-side-bar-link-div:hover{\n  background: #F5F5F5;\n  border-left: 3px solid #222222;\n  color: #232323;\n  font-family: QuicksandBold !important;\n} */\n\n.order-side-bar-component > div .orderhistoryclass,\n.order-side-bar-component > div .accountinfoclass,\n.order-side-bar-component > div .homeclass,\n.order-side-bar-component > div .LoyaltyPointsZone {\n  background: #f5f5f5;\n  border-left: 3px solid #222222;\n  color: #232323;\n  font-family: QuicksandBold, 'Quicksand' !important;\n}\n\n/* end side bar */\n\n/* start main order page */\n.side-bar-and-order-section {\n  display: flex;\n  background: #ffffff;\n}\n\n.order-history-main-component {\n  width: 100%;\n  padding: 20px 20px 40px 20px;\n  margin-left: 250px;\n  min-height: calc(100vh - 137px) !important;\n  /* height: 85vh; */\n}\n\n.order-history-main-component > .order-history-top-component {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.order-history-main-component > .order-history-top-component > h1 {\n  font-size: 24px;\n  /* margin-left: 10px; */\n  color: #212121;\n  font-family: QuicksandBold, 'Quicksand' !important;\n}\n\n.order-history-main-component\n  > .order-history-top-component\n  > .order-history-button-grp {\n  background: #efefef;\n  border-radius: 5px;\n\n  padding: 6px 6px;\n}\n\n.order-history-main-component\n  > .order-history-top-component\n  > .order-history-button-grp\n  > Button {\n  background: #efefef;\n  color: #928c8c;\n  text-transform: capitalize;\n  font-size: 14px;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  transition: all 0.3s ease-in-out;\n  padding: 6px 15px !important;\n}\n\n@media (max-width: 496px) {\n  .order-history-main-component\n    > .order-history-top-component\n    > .order-history-button-grp\n    > Button {\n    font-size: 10px;\n  }\n\n  .order-history-main-component > .order-history-top-component {\n    width: 100%;\n  }\n}\n\n.order-history-main-component\n  > .order-history-top-component\n  > .order-history-button-grp\n  > Button.openorders,\n.order-history-main-component\n  > .order-history-top-component\n  > .order-history-button-grp\n  > Button.closeorders {\n  color: #ffffff;\n  background: #222222 0% 0% no-repeat padding-box;\n  box-shadow: 0px 6px 12px #00000042;\n}\n\n.order-history-bottom-component {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin: 10px 0;\n}\n\n.no-open-and-close-order {\n  width: 100%;\n  height: 70vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.no-open-and-close-order img {\n  width: 80px;\n  margin-bottom: 20px;\n}\n\n.no-open-and-close-order h1 {\n  font-family: QuicksandSemiBold !important;\n  font-size: 19px;\n  color: #232323;\n}\n\n.no-open-and-close-order p {\n  font-family: QuicksandSemiBold !important;\n  font-size: 13px;\n  color: #878787;\n  margin-bottom: 15px;\n}\n\n.no-open-and-close-order .start-shopping-on-order {\n  color: #0a64f9;\n  width: 200px;\n  border: 2px solid #0a64f9;\n  background: #fff;\n  font-size: 14px;\n  font-family: QuicksandSemiBold !important;\n  text-transform: capitalize !important;\n  background: #ffffff;\n  border-radius: 5px;\n}\n\n.start-shopping-on-order:hover {\n  background: #fff !important;\n}\n\n.start-shopping-on-order a {\n  text-decoration: none;\n  color: #0a64f9;\n  font-size: 14px;\n  font-family: QuicksandSemiBold !important;\n}\n\n/* end main order page*/\n\n/*  start order Account info */\n\n.account-info-main-component {\n  padding: 20px 40px;\n  margin-left: 250px;\n  width: 60%;\n}\n\n@media screen and (max-width: 1200px) {\n  .account-info-main-component {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .account-info-main-component {\n    /* margin-left: 2; */\n    margin: 0 auto;\n    padding: 15px;\n    /* display: flex; */\n    flex-wrap: wrap;\n    max-width: 100%;\n  }\n}\n\n.account-info-main-component > .account-info-welcome-header {\n  display: flex;\n  align-items: flex-end;\n  padding: 30px;\n  justify-content: space-between;\n  background: var(--unnamed-color-0a64f9) 0% 0% no-repeat padding-box;\n  border: 1px solid var(--unnamed-color-707070);\n  background: url('../Assets/MyInformation/Infobackground.svg');\n  background-repeat: no-repeat;\n  background-size: cover;\n  border: 1px solid #707070;\n  border-radius: 5px;\n}\n\n.account-info-main-component > .account-info-welcome-header > h1 {\n  color: #ffffff;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 25px;\n}\n\n.account-info-main-component > .account-info-welcome-header > p {\n  color: #ffffff;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 15px;\n}\n\n.account-info-subheading {\n  color: #707070;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 10px;\n  margin: 15px 0;\n}\n\n.account-info-subheading > p {\n  color: #707070;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 12px;\n}\n\n.account-info {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  background: #ffffff;\n  border: 1px solid #e1e1e1;\n  border-radius: 4px;\n  padding: 15px 20px;\n  margin: 20px 0;\n}\n\n.account-info > .account-info-top-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.account-info > .account-info-top-section > span {\n  text-transform: capitalize;\n  color: #212121;\n  font-size: 16px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n}\n\n.account-info-bottom-section {\n  width: 100%;\n}\n.account-info > .account-info-bottom-section > div {\n  /* display: flex; */\n  align-items: top;\n  padding: 10px 10px 10px 0;\n  /* margin: 10px 10px 10px 0; */\n  /* margin-left: 5px; */\n  margin-bottom: 5px;\n  /* justify-content: flex-start; */\n}\n\n@media (min-width: 1200px) {\n  .css-1lj5egr-MuiGrid-root {\n    max-width: 32.33% !important;\n  }\n}\n\n@media (min-width: 900px) {\n  .css-1lj5egr-MuiGrid-root {\n    max-width: 32.33% !important;\n  }\n}\n\n.account-info > .account-info-bottom-section > .account-info-single {\n  display: flex;\n  /* align-items: center; */\n  padding: 10px 10px 10px 0px;\n  border-bottom: 1px solid #e1e1e1;\n}\n\n@media (max-width: 480px) {\n  .span-before-driving-licence-image {\n    display: none;\n  }\n  .account-info-single {\n    justify-content: center;\n  }\n}\n\n.account-info > .account-info-bottom-section > div > span:first-child {\n  color: #707070;\n  font-size: 13px;\n  font-family: QuicksandSemibold, 'Quicksand' !important;\n  width: 30%;\n}\n\n.account-info > .account-info-bottom-section > div > .driving-licence-image {\n  width: 299px;\n  border-radius: 5px;\n}\n\n.account-info > .account-info-bottom-section > div > span:nth-child(2) {\n  color: #232323;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 13px;\n  justify-self: flex-end;\n  width: 70%;\n  text-transform: capitalize !important;\n}\n\n.card-info-important {\n  color: #707070;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 13px;\n}\n\n.basic-modal {\n  position: absolute;\n  top: 50% !important;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 500px;\n  /* width: 100%; */\n  box-shadow: 1px 1px 6px black;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border-radius: 8px;\n  padding: 10px 0;\n  max-height: 94vh;\n  overflow: hidden;\n}\n\n.for-scroll {\n  overflow-y: scroll !important;\n}\n\n.basic-modal > #modal-modal-title {\n  padding: 5px 15px 11px 15px;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  border-bottom: 1px solid #d3d3d3;\n}\n\n.basic-modal > #modal-modal-title > span {\n  color: #212121;\n  text-transform: capitalize;\n  font-size: 20px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n}\n\n@media (max-width: 767px) {\n  .basic-modal > #modal-modal-title > span {\n    font-size: 18px;\n  }\n}\n\n.basic-modal > #modal-modal-title > .modal-close-icon {\n  cursor: pointer;\n}\n\n.basic-modal > #modal-modal-title > .modal-close-button {\n  display: inline-flex;\n  flex: 0 0 44px;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  color: #1d2939;\n  cursor: pointer;\n}\n\n.basic-modal > #modal-modal-title > .modal-close-button:hover {\n  background: #f2f4f7;\n}\n\n.basic-modal > #modal-modal-title > .modal-close-button:focus-visible {\n  outline: 3px solid rgba(10, 100, 249, 0.25);\n  outline-offset: 2px;\n}\n\n.basic-modal > #modal-modal-title > .modal-close-button img {\n  width: 22px;\n  height: 22px;\n}\n\n.basic-modal > .modal-forms {\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  /* align-items: center; */\n  justify-content: center;\n  width: 100%;\n}\n\n.modal-forms .css-13sljp9 {\n  width: 100%;\n}\n\n.basic-modal .modal-forms > .css-1nrlq1o-MuiFormControl-root {\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.modal-form-single-item {\n  display: flex !important;\n  flex-direction: column !important;\n  margin: 0px 0px 10px !important;\n  width: 100% !important;\n}\n\n.password-margin-bottom {\n  margin-bottom: 15px !important;\n}\n\n.modal-form-single-item .css-14x1nlk,\n.modal-form-single-item .css-14x1nlk {\n  color: #595959 !important;\n  font-family: QuicksandMedium, Quicksand !important;\n  font-size: 13px !important;\n}\n\n.modal-form-single-item .css-1rgmeur {\n  color: #595959 !important;\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px !important;\n}\n\n.modal-form-single-input label {\n  color: #595959 !important;\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px !important;\n}\n\n.modal-form-single-input {\n  width: 100%;\n  font-size: 12px !important;\n  background: #ffffff;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  background: #ffffff !important;\n  border: 1px solid #d3d3d3 !important;\n  border-radius: 6px !important;\n}\n\n.modal-form-single-input .css-dvhgws {\n  background: #ffffff !important;\n  /* border: 1px solid #D3D3D3 !important; */\n  border-radius: 6px !important;\n}\n\n.modal-form-single-input .css-dvhgws:hover,\n.modal-form-single-input .css-dvhgws.Mui-focused {\n  background: #ffffff !important;\n}\n\n.modal-form-single-input\n  .css-dvhgws:hover:not(\n    .Mui-disabled,\n    .modal-form-single-input .Mui-error\n  )::before,\n.modal-form-single-input\n  .css-dvhgws:hover:not(.Mui-disabled, .Mui-error)::before {\n  border-bottom: none !important;\n}\n\n.modal-form-single-input .css-dvhgws::before {\n  border-bottom: none !important;\n}\n\n.modal-form-single-input .css-1njz7x1 {\n  font-size: 13px !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  color: #595959 !important;\n}\n\n.modal-form-single-input:focus-within {\n  border: 1px solid #000000 !important;\n}\n\n.modal-form-single-input::placeholder {\n  color: #595959 !important;\n}\n\n.modal-main-button {\n  color: #0a64f9 !important;\n  text-transform: capitalize !important;\n  font-size: 14px !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n}\n.css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n  min-width: unset !important;\n}\n.basic-modal > .modal-forms > .modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin: 14px 0 0 0;\n}\n\n.basic-modal > .modal-forms > .modal-footer > .modal-cancle-btn {\n  background: #ffffff !important;\n  border: 1px solid #232323 !important;\n  border-radius: 6px !important;\n  color: #232323 !important;\n  text-transform: capitalize !important;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  width: 48%;\n  height: 44px;\n}\n\n.basic-modal > .modal-forms > .modal-footer > .modal-save-btn {\n  background: #0a64f9;\n  border: 2px solid #0a64f9 !important;\n  border-radius: 6px;\n  color: #ffffff;\n  text-transform: capitalize !important;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  width: 48%;\n  height: 44px;\n}\n\n/* Scoped fixes for checkout/account address add/edit modal */\n.address-modal {\n  display: flex;\n  flex-direction: column;\n  max-height: min(94vh, 760px);\n}\n\n.address-modal > #modal-modal-title {\n  flex-shrink: 0;\n}\n\n.address-modal > .address-modal-form {\n  flex: 1;\n  overflow-y: auto;\n  padding: 15px 15px 18px;\n}\n\n.address-modal-form .address-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 10px;\n  row-gap: 10px;\n}\n\n.address-modal-form .address-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.address-modal-form .address-field-full {\n  grid-column: 1 / -1;\n}\n\n.address-modal-form .address-state-zip-row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.address-modal-form .address-form-label {\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 14px;\n  line-height: 1.25;\n  color: #232323;\n  margin-bottom: 4px;\n}\n\n.address-modal .input-error,\n.address-modal .MuiFormHelperText-root {\n  position: static !important;\n  display: block !important;\n  min-height: 15px;\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n  white-space: normal !important;\n  word-break: break-word;\n  line-height: 1.2;\n  margin-top: 4px !important;\n  margin-left: 0 !important;\n  color: #fa0000 !important;\n}\n\n.address-modal .address-field-error {\n  position: static !important;\n  display: block !important;\n  min-height: 0;\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n  white-space: normal !important;\n  word-break: break-word;\n  line-height: 1.2;\n  margin-top: 3px !important;\n  margin-left: 0 !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 12px !important;\n  color: #fa0000 !important;\n}\n\n.address-modal .address-field-error:empty {\n  display: none !important;\n  margin-top: 0 !important;\n}\n\n.address-modal-form .address-submit-error-row {\n  margin-top: 4px;\n  margin-bottom: 8px;\n}\n\n.address-modal-form .row > [class*='col'] {\n  margin-bottom: 12px !important;\n}\n\n@media (max-width: 768px) {\n  .address-modal-form .row > [class*='col'] {\n    margin-bottom: 12px !important;\n  }\n}\n\n.address-modal .error-on-submit {\n  display: block;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 11px;\n  color: #fa0000;\n  line-height: 1.25;\n}\n\n.address-modal .modal-footer {\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  background: #fff;\n  padding-top: 10px;\n  margin-top: 10px !important;\n}\n\n@media (max-width: 768px) {\n  .address-modal {\n    width: 95%;\n    max-height: 92vh;\n    border-radius: 12px;\n  }\n\n  .address-modal > .address-modal-form {\n    padding: 12px 12px 16px;\n  }\n\n  .address-modal-form .address-form-grid {\n    grid-template-columns: 1fr;\n    row-gap: 10px;\n  }\n\n  .address-modal-form .address-state-zip-row {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .address-modal .modal-footer > .modal-cancle-btn,\n  .address-modal .modal-footer > .modal-save-btn {\n    height: 48px;\n    font-size: 18px;\n    line-height: 1;\n  }\n}\n\n.account-info > .account-info-top-section > .account-password-top-section {\n  display: flex;\n  align-items: center;\n}\n\n.account-info\n  > .account-info-top-section\n  > .account-password-top-section\n  > span {\n  text-transform: capitalize;\n  color: #212121;\n  font-size: 16px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n}\n\n.account-info > .account-info-top-section > div > p {\n  text-transform: capitalize;\n  color: #707070 !important;\n  font-size: 12px;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  /* margin-left: 86px !important; */\n}\n\n.account-info-bottom-section .single-delivery-address {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 6px;\n  /* width: 31%; */\n  padding: 10px !important;\n}\n\n.account-info-bottom-section\n  .single-delivery-address\n  > .single-delivery-address-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.account-info-bottom-section\n  .single-delivery-address\n  > .single-delivery-address-content {\n  width: 100%;\n  margin: 10px 0;\n  text-transform: capitalize;\n}\n\n.account-info-bottom-section\n  .single-delivery-address\n  > .single-delivery-address-footer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  /* justify-content: flex-end; */\n}\n\n.account-info-bottom-section\n  .single-delivery-address\n  > .single-delivery-address-footer\n  > .btn-remove-delivery-address\n  > .delete-address-icon {\n  width: 15px;\n  height: 15px;\n  margin: 5px;\n}\n\n.account-info-bottom-section\n  .single-delivery-address\n  > .single-delivery-address-footer\n  > * {\n  text-transform: capitalize !important;\n  color: #222222 !important;\n}\n\n.my-custom-class-for-file-input::-webkit-file-upload-button,\n.file-input-not-display::-webkit-file-upload-button {\n  visibility: hidden !important;\n}\n\n.custom-file-upload-input {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border: 1px solid #d3d3d3;\n  border-radius: 6px;\n  padding: 2px 15px 2px 15px;\n  color: #fff;\n  width: 100%;\n}\n\n/* .my-custom-class-for-file-input {\n  color: #232323;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  border-bottom: none;\n  width: 50%;\n} */\n\n/* .my-custom-class-for-file-input::placeholder {\n  color: red !important;\n} */\n.image-input-quickvee > .my-file-custom-input-for-image {\n  color: #232323;\n  font-size: 13px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  padding: 13px 13px 13px 0;\n  /* cursor: pointer !important; */\n  cursor: default;\n  overflow: hidden;\n  width: 70%;\n}\n\n/* .file-input-not-display::after{\n  content: \"Upload ID Card\";\n  color: #FFFFFF;\n  font-family: QuicksandMedium !important;\n  font-size: 14px ;\n  background: #232323 0% 0% no-repeat padding-box;\nborder-radius: 3px;\npadding: 7px 20px;\nposition: absolute;\nright: 9px;\ntop: 10px;\ncursor: pointer;\n}  */\n\n.button-update-id-card,\n.button-update-id-card:hover {\n  color: #0a64f9 !important;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 14px !important;\n  /* margin-right: 7px !important; */\n  background-color: #fff !important;\n  cursor: pointer;\n  text-transform: capitalize !important;\n}\n\n.button-update-id-card img {\n  margin-left: 5px !important;\n}\n\n.image-input-quickvee {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.account-info-bottom-section\n  .single-delivery-address\n  > .single-delivery-address-footer\n  > .default-address {\n  color: #0a64f9 !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  background: #d2e3ff !important;\n  border-radius: 4px !important;\n  font-size: 10px !important;\n}\n\n.account-info-bottom-section\n  .single-delivery-address\n  > .single-delivery-address-footer\n  > .set-default-address {\n  color: #0a64f9 !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  background: none !important;\n  border-radius: 4px !important;\n  font-size: 10px !important;\n}\n\n.btn-remove-delivery-address {\n  margin: 0px !important;\n  padding: 0px !important;\n}\n\n.remove-delivery-address {\n  font-weight: 600;\n  font-family: QuicksandRegular !important;\n  line-height: 15px;\n  color: #222222;\n  font-size: 12px !important;\n  border-bottom: 1px solid #222222;\n  border-radius: unset !important;\n}\n\n.single-delivery-address .single-delivery-address-content > .receiver-name,\n.receiver-address {\n  color: #232323 !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 13px;\n  margin: 3px 0;\n}\n\n.single-delivery-address\n  > .single-delivery-address-content\n  > .receiver-zipcode {\n  color: #212121 !important;\n  font-family: QuicksandRegular !important;\n  font-size: 13px;\n  text-transform: capitalize;\n}\n\n.delivery-address-update-form {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-around;\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.delivery-address-update-form > div {\n  width: 100%;\n}\n\n.delivery-address-update-form > div:first-child {\n  margin: 0px 10px 0px 0px;\n}\n\n.delivery-city-state-update-inputs {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-around;\n  width: 55%;\n}\n\n.delivery-city-state-update-inputs label {\n  color: #595959 !important;\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px !important;\n}\n\n.delivery-city-state-update-inputs > div:first-child {\n  margin: 0px 10px 0px 0px !important;\n  width: 100% !important;\n}\n\n.delivery-address-update-form .css-1gtlbg0 {\n  padding: 2px 0px 2px 0px !important;\n}\n\n.the-state-input-in-delivery::before {\n  content: 'âŒ„';\n  font-size: 24px !important;\n  position: absolute;\n  right: 9px;\n  top: 2px;\n  color: #595959;\n}\n\n.modal-form-single-item .css-17gq4vl {\n  padding: 22px 10px 7px 10px !important;\n}\n\n.the-state-input-in-delivery:focus-within::before {\n  content: '';\n  font-size: 0px !important;\n}\n\n.css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root:before {\n  border: none !important;\n}\n\n.css-llrb4p-MuiInputBase-root-MuiFilledInput-root-MuiSelect-root::after {\n  border: none !important;\n}\n\n.css-e4w4as-MuiFormLabel-root-MuiInputLabel-root {\n  font-size: 12px !important;\n  font-family: QuicksandMedium !important;\n  top: -4px !important;\n}\n\n.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {\n  padding: 20px 10px 3px 9px !important;\n  font-size: 13px;\n  font: normal !important;\n  color: #000000;\n  font-family: QuicksandSemibold !important;\n}\n\n.css-o943dk-MuiFormLabel-root-MuiInputLabel-root {\n  font-size: 14px !important;\n  font-family: QuicksandSemiBold !important;\n  top: -3px !important;\n}\n\n.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input:focus {\n  /* padding: 24px 10px 0px 9px !important;\n  font-size: 13px; */\n  background: none;\n}\n\n.edit-delivery-address-button {\n  padding: 0 !important;\n  margin: 0 !important;\n  color: #000 !important;\n  width: 100% !important;\n  min-width: 30px !important;\n}\n\n.css-zs07ro-MuiInputBase-root-MuiFilledInput-root {\n  background: none !important;\n  font-size: 14px !important;\n  padding-top: 7px !important;\n}\n\n.css-zs07ro-MuiInputBase-root-MuiFilledInput-root:after {\n  border: none !important;\n}\n\n.css-zs07ro-MuiInputBase-root-MuiFilledInput-root::before {\n  border: none !important;\n}\n\n.css-1gctnaj-MuiInputBase-input-MuiFilledInput-input {\n  padding: 20px 10px 6px 9px !important;\n  font-family: QuicksandSemiBold !important;\n  font-size: 13px !important;\n}\n\n.css-1869usk-MuiFormControl-root {\n  min-width: 110px !important;\n}\n\n.css-1xhypcz-MuiStack-root {\n  /* padding-top: 0px !important;\n  overflow: unset !important; */\n}\n\n.css-1n8xjfr-MuiFormControl-root {\n  margin: 3px !important;\n}\n\n.css-o943dk-MuiFormLabel-root-MuiInputLabel-root.Mui-error {\n  color: #595959 !important;\n}\n\n.crop-image-modal-button {\n  margin: 10px 0 !important;\n  display: flex;\n  align-items: center;\n  /* justify-content: space-between; */\n  justify-content: center;\n  width: 100%;\n}\n\n.reactEasyCrop_Container {\n  position: relative !important;\n  height: 200px !important;\n  width: 317px !important;\n}\n\n.my-image-crop-modal-div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.crop-image-modal-button > .image-motion-button {\n  background: #0a64f9 !important;\n  text-transform: capitalize !important;\n  color: #fff !important;\n  margin: 0px 8px 0px 8px;\n  padding: 5px 11px;\n  border-radius: 4px;\n  font-family: QuicksandMedium !important;\n}\n\n/*  end order Account info */\n\n/* single order start */\n\n.single-open-order-div {\n  display: flex;\n  flex-direction: column;\n  background: url('../Assets/OrderScreen/OrderBackground.svg');\n  background-repeat: no-repeat;\n  background-size: contain;\n  border: 1px solid #e1e1e1;\n  border-radius: 4px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  width: 100%;\n  margin-bottom: 20px;\n  transition: all 0.3s ease-in;\n}\n\n.single-open-order-div:hover {\n  box-shadow: 0px 6px 18px #0000001c;\n}\n\n.infinite-scroll-component__outerdiv {\n  width: 100%;\n}\n\n/* .infinite-scroll-component> div {\n  margin: 10px;\n} */\n.demo-simple-select-filled-label {\n  line-height: 14px !important;\n}\n.onload-spinner-order {\n  display: inline-block;\n  border: 12px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 16px solid #6e6e6e;\n  width: 80px;\n  height: 80px;\n  align-self: center;\n  justify-self: center !important;\n  -webkit-animation: spin 2s linear infinite;\n  /* Safari */\n  animation: spin 2s linear infinite;\n}\n\n/* Safari */\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.infinite-scroll-component {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.infinite-scroll-component span {\n  /* width: 49%; */\n  cursor: pointer;\n}\n\n.single-open-order-div > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.single-open-order-div > .single-open-order-delivery-status {\n  padding-bottom: 10px;\n  border-bottom: 1px dashed #e1e1e1;\n  margin-bottom: 3px;\n}\n\n.single-open-order-div > .single-open-order-delivery-status > .delivery-button,\n.single-open-order-div\n  > .single-open-order-delivery-status\n  > .picked-up-button {\n  padding: 6px !important;\n  text-transform: capitalize;\n  font-size: 12px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  border-radius: 3px;\n}\n\n.single-open-order-div\n  > .single-open-order-delivery-status\n  > .delivery-button\n  > img,\n.single-open-order-div\n  > .single-open-order-delivery-status\n  > .picked-up-button\n  > img {\n  padding: 0 4px 0 0;\n}\n\n.single-open-order-div\n  > .single-open-order-delivery-status\n  > .picked-up-button {\n  background: #ffdcc1;\n  color: #db5f00;\n}\n\n.single-open-order-div > .single-open-order-delivery-status > .delivery-button {\n  background: #e2edff;\n  color: #0055ff;\n}\n\n.single-open-order-div > .single-open-order-delivery-status > .delivery-button {\n  color: #0055ff;\n  background: #e2edff;\n  border-radius: 3px;\n}\n\n.single-open-order-div > .single-open-order-content {\n  display: flex;\n  align-items: center;\n  /* justify-content: space-between; */\n  margin: 10px 0;\n}\n\n.single-open-order-div > .single-open-order-content > .single-order-date-time {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.single-open-order-div > .single-open-order-content > .single-order-id > span {\n  color: #888888;\n  font-size: 11px;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n}\n\n.single-open-order-div > .single-open-order-content > .single-order-id > p {\n  color: #030303;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n}\n\n.single-open-order-div > .single-open-order-amount {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .accepted-button,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .packing-button,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .ready-button,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .shipped-button,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .delivered-button,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .cancle-button,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .refund-button {\n  font-size: 12px;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  text-transform: capitalize;\n  border-radius: 3px;\n  color: #fff;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .accepted-button\n  > img,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .packing-button\n  > img,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .ready-button\n  > img,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .shipped-button\n  > img,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .delivered-button\n  > img,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .cancle-button\n  > img,\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .refund-button\n  > img {\n  padding: 0 4px 0 0;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .accepted-button {\n  background: #10c558;\n  padding: 6px !important;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .packing-button {\n  background: #ffb303;\n  padding: 6px !important;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .ready-button {\n  background: #c520f5;\n  padding: 6px !important;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .shipped-button {\n  background: #03cbff;\n  padding: 6px !important;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .delivered-button {\n  background: #0a64f9;\n  padding: 6px !important;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .cancle-button {\n  background: #f55353;\n  padding: 6px !important;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-button\n  > .refund-button {\n  background: #7a7a7a;\n  padding: 6px !important;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-status\n  > .payment-am-status {\n  display: flex;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-status\n  > .payment-am-status\n  > .payment-paid {\n  color: #26be7e;\n  font-size: 14px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  margin-right: 10px;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-status\n  > .payment-am-status\n  > .payment-cod-pending {\n  color: #f55353;\n  font-size: 14px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  margin-right: -5px;\n  width: 100px;\n}\n\n.single-open-order-div\n  > .single-open-order-amount\n  > .single-open-order-payment-status\n  > .payment-am-status\n  > p {\n  color: #1a1a1a;\n  font-size: 14px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n}\n\n/* single order end */\n\n/* end order history */\n\n/* My information */\n.my-information-main-component {\n  padding: 40px 0;\n  margin-left: 320px;\n  width: 70%;\n  display: flex !important;\n  /* align-items: center ; */\n  justify-content: center;\n  flex-direction: column;\n}\n\n.menu-icon-div {\n  margin-left: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.topBar-xMark {\n  margin-left: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (min-width: 769px) {\n  .menu-icon-div-inner,\n  .topBar-xMark {\n    display: none;\n  }\n}\n\n.menu-icon {\n  width: 30px !important;\n  height: 2px !important;\n  background-color: black !important;\n\n  margin: 6px !important;\n}\n\n.my-information-main-component > .my-information-middle-glass-box-div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 2px solid #ffffff;\n  background: #0a64f933;\n  border-radius: 4px;\n  opacity: 1;\n  box-shadow: #0a64f98c 0px 0px 80px 0px;\n  padding: 5px !important;\n  height: 164px;\n}\n\n.my-information-main-component\n  > .my-information-middle-glass-box-div\n  > .my-info-single-glass {\n  background: #ecf3ff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 20px;\n  width: 255px;\n  height: 144px;\n  margin: 1px;\n  text-transform: capitalize;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.5s ease-in-out;\n}\n\n.my-information-main-component\n  > .my-information-middle-glass-box-div\n  > .my-info-single-glass\n  > .my-info-image {\n  border: 2px solid #ffffff;\n  border-radius: 9px;\n  padding: 5px;\n  margin-bottom: 15px;\n  box-shadow: #000000 0px 0px 3px 0px;\n  color: #8c8c8c;\n  background: #e2edff;\n}\n\n.my-information-main-component\n  > .my-information-middle-glass-box-div\n  > .my-info-single-glass\n  > p {\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 16px;\n  color: #686868;\n}\n\n.my-information-main-component\n  > .my-information-middle-glass-box-div\n  > .my-info-single-active-glass {\n  background: radial-gradient(\n    farthest-side at 6% 14%,\n    #6ea5ff 0%,\n    #0a64f9 100%\n  );\n  border-radius: 4px;\n  color: #ffffff;\n  width: 300px;\n  height: 182px;\n  margin-bottom: 40px;\n}\n\n.my-information-main-component\n  > .my-information-middle-glass-box-div\n  > .my-info-single-active-glass\n  > .my-info-image {\n  border: 2px solid #ffffff;\n  border-radius: 9px;\n  box-shadow: #ffffff 0px 0px 3px 0px;\n  color: #fff;\n  padding: 7px 9px;\n  background: #0a64f9;\n  margin-bottom: 20px;\n}\n\n.my-information-main-component\n  > .my-information-middle-glass-box-div\n  > .my-info-single-active-glass\n  > p {\n  color: #fff;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 18px;\n}\n\n.my-information-bottom-glass-box-div {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  margin: 40px 0;\n  display: none;\n  padding: 5px;\n}\n\n.my-information-bottom-glass-box-div > .my-information-bottom-glass-content {\n  display: flex;\n  flex-direction: column;\n  width: 80%;\n}\n\n.my-information-bottom-glass-box-div\n  > .my-information-bottom-glass-content\n  > span {\n  color: #707070;\n  font-size: 12px;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  width: 70% !important;\n}\n\n.my-information-bottom-glass-box-div\n  > .my-information-bottom-glass-content\n  > .customer-data-and-information {\n  margin-top: 20px;\n}\n\n.my-information-bottom-glass-box-div\n  > .my-information-bottom-glass-content\n  > .customer-data-and-information\n  > .my-information-single {\n  display: flex;\n  margin: 10px 0;\n}\n\n.my-information-bottom-glass-content\n  > .customer-data-and-information\n  > .my-information-single\n  > span {\n  color: #232323;\n  font-size: 14px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.my-information-bottom-glass-content\n  > .customer-data-and-information\n  > .my-information-single\n  > span:first-child {\n  width: 30%;\n  color: #707070;\n  font-size: 14px;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n}\n\n.my-information-main-component > .my-info-single-active-glass {\n  display: flex;\n}\n\n.customer-delivery-address-section {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-top: 60px;\n}\n\n.customer-delivery-address-section > .customer-single-delivery-address {\n  border: 2px solid #0a64f9;\n  border-radius: 6px;\n  width: 48%;\n  padding: 5px;\n  margin: 5px;\n}\n\n.customer-delivery-address-section\n  > .customer-single-delivery-address\n  > .customer-single-delivery-address-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.customer-delivery-address-section\n  > .customer-single-delivery-address\n  > .customer-single-delivery-address-middle {\n  display: flex;\n  flex-direction: column;\n  margin: 10px 0 5px 0;\n}\n\n.customer-delivery-address-section\n  > .customer-single-delivery-address\n  > .customer-single-delivery-address-middle\n  > p {\n  color: #232323 !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  font-size: 13px;\n  margin: 0 !important;\n}\n\n.customer-delivery-address-section\n  > .customer-single-delivery-address\n  > .customer-single-delivery-address-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.customer-data-and-information-delivery {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: -100px;\n}\n\n.customer-delivery-address-section\n  > .customer-single-delivery-address\n  > .customer-single-delivery-address-bottom\n  > .btn-remove-delivery-address {\n  margin: 0px !important;\n  padding: 0px !important;\n}\n\n.customer-delivery-address-section\n  > .customer-single-delivery-address\n  > .customer-single-delivery-address-bottom\n  > .btn-remove-delivery-address\n  > .remove-delivery-address {\n  color: #222222;\n  font-size: 13px !important;\n  border-bottom: 1px solid #222222;\n  border-radius: unset !important;\n  text-transform: capitalize;\n  font-family: QuicksandRegular !important;\n}\n\n.customer-delivery-address-section\n  > .customer-single-delivery-address\n  > .customer-single-delivery-address-bottom\n  > .default-address {\n  color: #0a64f9 !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  background: #d2e3ff !important;\n  border-radius: 4px !important;\n  font-size: 13px !important;\n  text-transform: capitalize;\n}\n\n.customer-delivery-address-section\n  > .customer-single-delivery-address\n  > .customer-single-delivery-address-bottom\n  > .set-default-address {\n  color: #0a64f9 !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  background: none !important;\n  border-radius: 4px !important;\n  font-size: 13px !important;\n  text-transform: capitalize;\n}\n\n.modal-form-single-input .css-1thjcug {\n  background-color: #fff;\n}\n\n/* end my information */\n\n/* start cart and payment*/\n\n.main-cart-top-bar {\n  padding: 5px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  background: #ffffff;\n  border-bottom: 1px solid #ebebeb;\n  z-index: 5;\n}\n\n.quickvee-logo-cart-top-bar {\n  width: 148px;\n  height: 44px;\n  margin-right: 100px;\n}\n\n.top-cart-bar-button {\n  color: #232323 !important;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  text-transform: capitalize !important;\n}\n\n.top-cart-bar-button:hover {\n  background: none !important;\n}\n\n.search-location-button:hover {\n  background: none !important;\n}\n\n.quickvee-payement-stepper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  background: #f9f9f9 !important;\n  padding: 20px;\n}\n\n.quickvee-payement-stepper > span {\n  color: #878787 !important;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 18px !important;\n  margin: 0 10px;\n  cursor: not-allowed;\n}\n\n.quickvee-payement-stepper > p {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin: 0px;\n  transition: all 0.3s ease-in-out;\n}\n\n.quickvee-payement-stepper > .active-payment-component {\n  color: #0a64f9 !important;\n  cursor: pointer;\n}\n\n.quickvee-payement-stepper > .active-payment-stepper-status {\n  width: 10px;\n  height: 10px;\n  background-color: #0a64f9;\n  border-radius: 50%;\n  margin: 0px;\n}\n\n@media (max-width: 480px) {\n  .active-payment-stepper-status {\n    width: 5px !important;\n    height: 5px !important;\n  }\n}\n.quickvee-payement-stepper > .active-payment-stepper-range {\n  color: #0a64f9 !important;\n  background-color: #0062ff !important;\n  height: 3px;\n}\n\n.quickvee-payement-stepper > hr {\n  width: 10%;\n  margin: 0px;\n  height: 2px;\n  background-color: #c4c4c4 !important;\n  border: none;\n  transition: background-color 0.3s ease-out;\n}\n\n.quickvee-payment-component-content {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px 50px;\n  flex-wrap: wrap;\n}\n\n.payment-stepper-cart {\n  width: 75%;\n  display: flex;\n  justify-content: center;\n  /* min-height: calc(100vh - 200px); */\n}\n\n.payment-stepper-cart > .payment-stepper-wishlist-item {\n  width: 65%;\n  border-right: 1px solid #e8e8e8;\n  padding: 0 20px;\n  /* min-height: calc(100vh - 200px); */\n}\n\n.payment-stepper-cart\n  > .payment-stepper-wishlist-item\n  > .payment-stepper-wishlist-item-topper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* margin: 0px -15px; */\n}\n\n.payment-cart-remove-from-cart-wishlist-modal {\n  display: flex;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-wishlist-item\n  > .payment-stepper-wishlist-item-topper\n  > .selected-count {\n  color: #232323;\n  font-size: 20px;\n  font-family: QuicksandBold !important;\n}\n\n.q-payment-selected-wishlist {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.q-payment-selected-wishlist span {\n  color: #595959;\n  font-size: 14px;\n  /* font-family: QuicksandBold !important; */\n  border-right: 1px solid #414141;\n  border-left: 1px solid #414141;\n  padding: 0 20px 0 10px;\n  cursor: pointer;\n}\n\n.q-payment-selected-wishlist img {\n  cursor: pointer;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-wishlist-item\n  > .payment-stepper-wishlist-item-topper\n  > .selected-wishlist\n  > .selected-delete-all {\n  color: red;\n  margin-left: 20px;\n}\n\n.payment-stepper-cart > .payment-stepper-checkout-item {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n  padding: 0 20px;\n  padding-bottom: 15px;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-item-top {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: #232323;\n  font-size: 20px;\n  font-family: QuicksandBold !important;\n  margin-bottom: 15px;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > div {\n  display: flex;\n  /* align-items: center; */\n  justify-content: space-between;\n  padding: 5px 0;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > div\n  > span {\n  color: #595959;\n  font-size: 14px;\n  font-family: QuicksandSemiBold !important;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > div\n  > p {\n  padding: 0 !important;\n  margin: 0 !important;\n  color: #595959;\n  font-size: 14px;\n  font-family: QuicksandSemiBold !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > div\n  > p\n  img {\n  margin-right: 5px;\n  cursor: pointer;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > .quickvee-checkout-final-amount\n  > span,\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > .quickvee-checkout-final-amount\n  > p {\n  color: #222222;\n  font-size: 20px;\n  font-family: QuicksandBold !important;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > .quickvee-checkout-final-amount {\n  margin: 15px 0px 10px 0px;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > .payment-checkout-with-login {\n  background: #000000;\n  border: 2px solid #000000;\n  border-radius: 6px;\n  color: #fff;\n  text-transform: capitalize;\n  font-size: 13.72px;\n  margin-bottom: 15px;\n  font-family: QuicksandBold !important;\n  height: 44px;\n}\n\n.payment-checkout-with-login-save-and-proceed {\n  border: 2px solid #000000 !important;\n  border-radius: 6px !important;\n  color: #000000 !important;\n  text-transform: capitalize !important;\n  font-size: 16px !important;\n  font-family: QuicksandBold !important;\n  margin: 15px 0 !important;\n  height: 44px;\n}\n.payment-checkout-with-login-pay-button {\n  border: 2px solid #000000 !important;\n  border-radius: 6px !important;\n  color: #000000 !important;\n  text-transform: capitalize !important;\n  font-size: 16px !important;\n  font-family: QuicksandBold !important;\n  margin: 15px 0 !important;\n  height: 44px;\n}\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > .payment-checkout-as-guest {\n  border: 2px solid #000000;\n  border-radius: 6px;\n  color: #000000;\n  text-transform: capitalize;\n  font-size: 16px;\n  font-family: QuicksandBold !important;\n  margin: 15px 0;\n  height: 44px;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-checkout-item\n  > .payment-stepper-checkout-content\n  > .payment-checkout-as-guest:hover {\n  background-color: #fff !important;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-wishlist-item\n  > .payment-all-cart-items {\n  margin: 20px 0px;\n  overflow-y: auto;\n  max-height: 72vh;\n  width: 100%;\n  overflow-x: hidden;\n  /* padding: 0 20px 0 0; */\n}\n\n.payment-all-cart-items.overflowed {\n  padding-right: 20px;\n}\n\n.payment-all-cart-items:not(.overflowed) {\n  padding-right: 0;\n}\n\n.payment-stepper-cart\n  > .payment-stepper-wishlist-item\n  > .payment-all-cart-items::-webkit-scrollbar {\n  width: 3px;\n  position: relative;\n  right: 10px;\n}\n\n/* Track */\n.payment-stepper-cart\n  > .payment-stepper-wishlist-item\n  > .payment-all-cart-items::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n/* Handle */\n.payment-stepper-cart\n  > .payment-stepper-wishlist-item\n  > .payment-all-cart-items::-webkit-scrollbar-thumb {\n  background: #3e85f8;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.3s ease-in-out;\n  outline: 1px solid #fff;\n}\n\n/* Handle on hover */\n.payment-stepper-cart\n  > .payment-stepper-wishlist-item\n  > .payment-all-cart-items::-webkit-scrollbar-thumb:hover {\n  background: #0a64f9;\n  cursor: pointer !important;\n}\n\n.payment-all-cart-add-more-products {\n  border-radius: 6px;\n  float: right;\n  color: #000000;\n  font-family: QuicksandBold !important;\n  text-transform: capitalize;\n  padding: 5px 15px 5px 0px;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  /* width: 75%; */\n}\n\n.payment-page-wishlist-cart-items {\n  background: #ffffff;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  display: flex;\n  align-items: flex-start;\n  padding: 10px 16px;\n  margin: 0 0 15px 0;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.payment-page-wishlist-cart-items > .payment-page-wishlist-item-image {\n  width: 15%;\n}\n\n.payment-page-wishlist-cart-items > .payment-page-wishlist-item-content {\n  width: 80%;\n}\n\n.payment-page-wishlist-cart-items > div {\n  display: flex;\n  align-items: flex-start;\n}\n\n.payment-page-wishlist-cart-items > .payment-page-wishlist-item-image > div {\n  position: relative;\n  right: 0px;\n  padding: 10px;\n  border: 1px solid #e1e1e1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.payment-page-wishlist-cart-items\n  > .payment-page-wishlist-item-image\n  > div\n  > img {\n  width: 66px;\n}\n\n.payment-page-wishlist-cart-items\n  > .payment-page-wishlist-item-image\n  > .checkbox {\n  position: relative;\n  top: -2px;\n  right: -2px;\n  cursor: pointer;\n  opacity: 0;\n  z-index: 2;\n  width: 15px;\n}\n\n.payment-page-wishlist-cart-items\n  > .payment-page-wishlist-item-image\n  > .checkbox-checkmark {\n  position: relative;\n  top: -5px;\n  right: 15px;\n  padding: 10px 10px 10px 10px;\n  background-color: rgb(226, 226, 226);\n  border-radius: 2px;\n  z-index: 1;\n}\n\n.payment-page-wishlist-cart-items\n  > .payment-page-wishlist-item-image\n  > .checkbox:checked\n  ~ .checkbox-checkmark {\n  /* background-color: #14AE2D; */\n  background-image: url('../Assets/Payment/checked.svg');\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n\n.payment-page-wishlist-item-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.payment-modal-outer-div .css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n  max-width: 500px !important;\n}\n\n.payment-modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 20px 25px;\n}\n\n.payment-modal.out-of-stock-products {\n  padding: 20px 50px;\n}\n\n@media (max-width: 768px) {\n  .payment-modal.out-of-stock-products {\n    padding: 20px 25px;\n  }\n}\n\n.payment-modal .payment-modal-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.payment-modal .payment-modal-content img {\n  margin-bottom: 15px;\n  width: 80px;\n  height: auto;\n}\n\n.payment-modal .payment-modal-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 40px;\n}\n\n.payment-modal .payment-modal-button button {\n  width: 48%;\n  padding: 10px;\n  font-size: 15px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  background-color: #fff;\n  outline: none;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n}\n\n.payment-modal .payment-modal-button button:first-child {\n  border: 1px solid #232323;\n}\n\n.payment-modal .payment-modal-content span {\n  text-align: center;\n  color: #212121;\n  font-family: QuicksandBold, 'Quicksand' !important;\n  font-size: 18px;\n  padding: 0 10px;\n}\n\n.payment-page-wishlist-item-content > .top-content {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.payment-page-wishlist-item-content > .top-content > p {\n  color: #212121;\n  font-size: 16px;\n  font-family: QuicksandBold !important;\n  margin-right: 45px;\n}\n\n.payment-page-wishlist-item-content > .middle-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 10px 0;\n  width: 70%;\n}\n\n.payment-page-wishlist-item-content\n  > .middle-content\n  > .increment-decremnt-button {\n  display: flex;\n  align-items: center;\n}\n\n.payment-page-wishlist-item-content\n  > .middle-content\n  > .increment-decremnt-button\n  > button {\n  border: none;\n  background: #0a64f9;\n  border-radius: 4px;\n  color: #fff;\n  padding: 6px 8px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.payment-page-wishlist-item-content\n  > .middle-content\n  > .increment-decremnt-button\n  > button:disabled {\n  background: #80aef7;\n}\n\n.payment-page-wishlist-item-content\n  > .middle-content\n  > .increment-decremnt-button\n  > span {\n  margin: 0px 50%;\n  font-family: QuicksandSemiBold !important;\n  color: #000000;\n  width: 13%;\n  font-size: 19px;\n  text-align: center;\n}\n\n.payment-page-wishlist-item-content\n  > .middle-content\n  > .amount-calculation\n  > span {\n  color: #2e2e2e;\n  font-size: 18px;\n  font-family: QuicksandBold !important;\n  margin: 0px 10px;\n}\n\n.payment-page-wishlist-item-content\n  > .middle-content\n  > .amount-calculation\n  > del {\n  font-size: 14px;\n  color: #989898;\n  font-family: QuicksandMedium !important;\n}\n\n.payment-page-wishlist-item-content > .bottom-dropdowns-for-categories {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.payment-page-wishlist-item-content > .bottom-dropdowns-for-categories {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.payment-page-wishlist-item-content > .bottom-dropdowns-for-categories > div {\n  width: 45%;\n  margin: 0 10px 0 0;\n}\n\n.payment-stepper-cart > .payment-stepper-customer-detail-section {\n  display: flex;\n  flex-direction: column;\n  width: 65%;\n  border-right: 1px solid #d3d3d3;\n  padding: 0 20px;\n}\n\n.payment-billing-customer-form {\n  display: flex;\n  flex-direction: column;\n  margin: 0px 0px 20px 0px;\n  margin-left: auto;\n}\n\n.payment-billing-customer-form > h1 {\n  color: #212121;\n  text-transform: capitalize;\n  font-size: 20px;\n  font-family: QuicksandBold !important;\n}\n\n.payment-billing-customer-form p {\n  color: #222222;\n  font-size: 12px;\n  /* margin-bottom: 15px  !important; */\n  font-family: QuicksandMedium !important;\n}\n.id-verigfication-description {\n  margin-bottom: 15px !important;\n}\n.payment-billing-inputs-div {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n\n.payment-billing-input-outer-div {\n  display: flex;\n  flex-direction: column;\n  margin: 5px 0;\n  /* align-items: center; */\n  width: 48.5%;\n}\n\n.payment-billing-input-outer-div-for-all {\n  display: flex;\n  flex-direction: column;\n  margin: 5px 0;\n  /* align-items: center; */\n  width: 100%;\n}\n\n/* .payment-billing-input-outer-div:nth-child(2){\n  align-items: flex-end;\n} */\n.payment-billing-input {\n  max-width: 100%;\n  font-size: 12px !important;\n  background: #ffffff;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  background: #ffffff !important;\n  border: 1px solid #d3d3d3 !important;\n  border-radius: 6px !important;\n}\n\n.payment-billing-input .css-s2lqj8 {\n  color: #595959 !important;\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px !important;\n}\n\n.payment-billing-input:focus-within {\n  border: 1px solid #595959 !important;\n}\n\n.payment-billing-input::placeholder {\n  color: #595959 !important;\n}\n\n.c-payment-billing {\n  width: 100% !important;\n}\n\n.payment-billing-city-state-update-inputs {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.css-o943dk-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {\n  color: #595959 !important;\n}\n\n.payment-billing-city-state-update-inputs > div:first-child {\n  margin: 0px 15px 0px 0px !important;\n  width: 48%;\n}\n\n.payment-billing-city-state-update-inputs > div:first-child .css-14x1nlk {\n  color: #595959 !important;\n  font-family: QuicksandMedium, Quicksand !important;\n  font-size: 13px !important;\n  top: -5px;\n}\n\n.payment-billing-modal-form-single-item {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  width: 50%;\n}\n\n.payment-billing-modal-form-single-item .css-1rgmeur {\n  color: #595959 !important;\n  font-size: 14px !important;\n  font-family: QuicksandSemiBold !important;\n  top: -3px !important;\n}\n\n.payment-billing-modal-form-single-item .css-14x1nlk {\n  color: #595959 !important;\n  font-size: 14px !important;\n  font-family: QuicksandSemiBold !important;\n  top: -3px !important;\n}\n\n.payment-billing-modal-form-single-item .css-17gq4vl.css-17gq4vl.css-17gq4vl {\n  color: #000000 !important;\n  font-size: 14px !important;\n  font-family: QuicksandSemiBold !important;\n  padding: 17px 10px 2px 10px;\n}\n\n.billing-info-delivery-address-update-form {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  /* margin: 5px 0 15px 0; */\n  width: 100%;\n  /* margin-bottom: 15px !important; */\n}\n\n.billing-info-delivery-address-update-form .billing-date-time {\n  width: 100% !important;\n}\n\n.billing-info-delivery-address-update-form > div {\n  width: 100%;\n}\n\n.billing-info-delivery-address-update-form > div:nth-child(1) {\n  margin: 0px 10px 15px 0;\n}\n\n.billing-info-delivery-address-update-form > div:nth-child(2) {\n  margin: 0px 10px;\n}\n\n.billing-info-delivery-address-update-form > div:nth-child(3) {\n  margin: 0px 0px 0px 5px;\n}\n\n.billing-info-delivery-address-update-form .css-13sljp9 {\n  width: 100% !important;\n  /* padding-top:8px; */\n}\n\n.css-1gctnaj-MuiInputBase-input-MuiFilledInput-input {\n  padding: 12px 10px 6px 9px !important;\n}\n\n.css-zs07ro-MuiInputBase-root-MuiFilledInput-root {\n  background: none !important;\n  font-size: 14px !important;\n  padding-top: 4px !important;\n}\n\n.payment-stepper-single-billing-info-detail > .payment-billing-save-button {\n  float: right;\n  color: #ffffff;\n  font-family: QuicksandBold !important;\n  background: #0a64f9;\n  padding: 5px 60px;\n  border-radius: 6px;\n  text-transform: capitalize !important;\n}\n.payment-stepper-single-billing-info-detail {\n  padding-top: 24px;\n}\n\n.payment-stepper-single-billing-info-detail\n  > .payment-billing-save-button:hover {\n  float: right;\n  color: #ffffff;\n  font-family: QuicksandBold !important;\n  background: #0a64f9;\n  padding: 5px 60px;\n  border-radius: 6px;\n  text-transform: capitalize !important;\n}\n\n.apply-coupon-modal-button {\n  margin: 10px 0 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: #ffffff;\n  border: 1px solid #176cf8;\n  border-radius: 8px;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.apply-coupon-listing-btn {\n  display: inline-flex;\n  min-height: 44px;\n  padding: 4px 0;\n  border: 0;\n  background: transparent;\n  color: #0a64f9;\n  font: inherit;\n  font-size: 14px !important;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n  cursor: pointer;\n}\n\n.apply-coupon-listing-btn > span {\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n}\n\n.apply-coupon-listing-btn:focus-visible {\n  outline: 3px solid rgba(10, 100, 249, 0.22);\n  outline-offset: 2px;\n  border-radius: 6px;\n}\n\n.apply-coupon-modal-button.coupon-selected {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: #ffffff;\n  box-shadow: 0px 6px 15px #0a64f94d;\n  border: 1px solid #176cf8;\n  border-radius: 8px;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.apply-coupon-modal-button > div {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin: 0px;\n}\n\n.apply-coupon-modal-button > div > p {\n  color: #0a64f9;\n  font-size: 14px;\n  font-family: QuicksandSemiBold !important;\n  margin: 0;\n  padding: 0;\n}\n\n.apply-coupon-modal-button > div > span {\n  color: #222222;\n  font-size: 12px;\n  font-family: QuicksandSemiBold !important;\n  margin: 0;\n  padding: 0;\n}\n\n.basic-modal,\n.basic-modal:focus-visible {\n  outline: none;\n}\n.border-bottom-gray {\n  width: 100%;\n  border-bottom: 1px solid #e6eaf0;\n  padding: 10px;\n  min-height: 68px;\n  .quickvee-logo-authentication {\n    margin: 0;\n  }\n}\n.search-bar-heading {\n  font-size: 20px;\n  padding-left: 16px;\n  padding-top: 6px;\n}\n.show-hide-button {\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n  position: absolute;\n  right: 1px;\n  top: 23px;\n  padding: 12px;\n  cursor: pointer !important;\n  color: #222222 !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n  font-size: 13px;\n}\n.show-hide-button-change-password {\n  background-color: #fff;\n  top: 7px;\n}\n.show-hide-button.login-password {\n  right: 0;\n  top: 21px;\n}\n.modal-forms > .available-coupons-listing {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding: 20px 0;\n  width: 100%;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  /* opacity: 1; */\n}\n\n.coupon-error-on-modal {\n  display: flex;\n  align-self: flex-start;\n  color: red;\n  font-size: 16px;\n  font-family: 'QuicksandMedium' !important;\n  position: relative !important;\n  margin-left: 15px !important;\n}\n\n.modal-forms\n  > .available-coupons-listing\n  > .available-coupons-listing-checkbox\n  > .available-coupons-checkbox {\n  position: relative;\n  top: 0px;\n  right: -5px;\n  cursor: pointer;\n  z-index: 1;\n  opacity: 0;\n}\n\n.modal-forms\n  > .available-coupons-listing\n  > .available-coupons-listing-checkbox\n  > .available-coupons-checkbox-checkmark {\n  position: relative;\n  /* top: 2px; */\n  right: 5px;\n  padding: 2px 12px 2px 12px;\n  background-color: rgb(226, 226, 226);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border-radius: 2px;\n  z-index: 0;\n  cursor: pointer;\n}\n\n.modal-forms\n  > .available-coupons-listing\n  > .available-coupons-listing-checkbox\n  > .available-coupons-checkbox:checked\n  ~ .available-coupons-checkbox-checkmark {\n  background-size: cover;\n  background-image: url('../Assets/Payment/coupon.svg');\n}\n\n.modal-forms > .available-coupons-listing > .available-coupons-listing-content {\n  cursor: pointer;\n}\n\n.modal-forms\n  > .available-coupons-listing\n  > .available-coupons-listing-content\n  > span {\n  color: #232323;\n  font-size: 14px;\n  font-family: QuicksandBold !important;\n  text-transform: uppercase;\n}\n\n.modal-forms\n  > .available-coupons-listing\n  > .available-coupons-listing-content\n  > p {\n  color: #000000;\n  font-size: 12px;\n  font-family: QuicksandRegular !important;\n}\n\n#modal-modal-description {\n  display: flex;\n  justify-content: flex-start !important;\n  height: auto;\n  max-height: 84vh;\n  /* overflow-y: auto; */\n}\n\n.css-dmmspl-MuiFormGroup-root {\n  display: flex !important;\n  flex-direction: row !important;\n}\n\n.payment-delivery-section > div .css-1h7anqn {\n  flex-direction: row !important;\n}\n\n.payment-delivery-section > span {\n  color: #212121;\n  text-transform: capitalize;\n  font-size: 20px;\n  font-family: QuicksandBold !important;\n}\n\n.payment-delivery-section > .select-delivery-hour-and-date {\n  display: flex;\n  flex-direction: row !important;\n  width: 100%;\n  display: none;\n  /* align-items: center;\n  justify-content: center; */\n}\n\n.select-delivery-hour-and-date .choose-time-on-payment {\n  width: 100% !important;\n}\n\n.select-delivery-hour-and-date .choose-date-on-payment input {\n  position: relative;\n  left: 3px;\n}\n\n.select-delivery-hour-and-date label {\n  color: #595959 !important;\n  /* font-family: QuicksandSemiBold !important; */\n  font-size: 14px !important;\n}\n\n.select-delivery-hour-and-date input {\n  /* padding: 12px 10px 6px 9px !important; */\n  /* font-family: QuicksandSemiBold !important; */\n  /* font-size: 13px !important; */\n}\n\n.select-delivery-hour-and-date\n  .css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {\n  position: relative;\n  top: 4px;\n  left: 3px;\n  padding: 17px 10px 9px 9px !important;\n}\n\n.select-delivery-hour-and-date.DeliveryNow-active {\n  display: flex;\n  animation: fadeOut 0.8s !important;\n  height: 0px !important;\n  display: none !important;\n}\n\n.payment-delivery-section > .DeliveryNow-active {\n  display: flex;\n  animation: fadeOut 0.8s !important;\n  height: 0px !important;\n  display: none !important;\n}\n\n.payment-delivery-section > .DeliveryLater-active {\n  display: flex;\n  animation: fadeIn 0.9s;\n}\n\n.payment-delivery-section > .select-delivery-hour-and-date > div {\n  width: 100% !important;\n  margin-right: 10px;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    top: -40px;\n    height: 0px;\n  }\n\n  100% {\n    opacity: 1;\n    top: 0px;\n    height: 85px;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n    top: 0px;\n    height: 50px;\n  }\n\n  100% {\n    opacity: 0;\n    top: -40px;\n    height: 0px;\n    display: none;\n  }\n}\n\n.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {\n  font-size: 13px !important;\n  color: #595959 !important;\n  font-family: QuicksandMedium, 'Quicksand' !important;\n}\n\n.css-ahj2mt-MuiTypography-root {\n  color: #222222 !important;\n  font-size: 16px !important;\n  /* font-family: QuicksandMedium, 'Quicksand' !important; */\n}\n\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {\n  border: none !important;\n  /* border-radius: 6px !important; */\n  outline: none;\n  padding: 0px 12px 0px 0px !important;\n}\n\n.payment-stepper-single-billing-info-detail\n  > .payment-delivery-address-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.payment-stepper-single-billing-info-detail\n  > .payment-delivery-address-section\n  > .head-section-of-payment-delivery-address {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.payment-delivery-address-section\n  > .head-section-of-payment-delivery-address\n  > span {\n  color: #212121;\n  text-transform: capitalize;\n  font-size: 20px;\n  font-family: QuicksandBold !important;\n}\n\n.payment-delivery-address-section\n  > .middle-section-of-payment-delivery-address {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-bottom: 12px;\n}\n\n.payment-delivery-address-section\n  > .middle-section-of-payment-delivery-address\n  > p {\n  color: #222222;\n  font-size: 13px;\n  font-family: QuicksandMedium !important;\n  margin: 0;\n  line-height: 1.4;\n  margin-bottom: 12px;\n}\n\n.delivery-address-helper-text {\n  margin-bottom: 14px !important;\n}\n\n.payment-delivery-address-section\n  > .middle-section-of-payment-delivery-address\n  > label\n  > span:nth-child(2) {\n  color: #222222;\n  font-size: 13px !important;\n  font-family: QuicksandMedium !important;\n  line-height: 1 !important;\n  margin-left: -7px;\n}\n\n.payment-delivery-address-section\n  > .bottom-section-of-payment-delivery-address {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.payment-delivery-address-section .head-section-of-payment-delivery-address .modal-main-button {\n  font-size: 17px !important;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n  line-height: 1.35;\n  margin-bottom: 6px;\n}\n\n.delivery-address-card-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  width: 100%;\n}\n\n.delivery-address-grid-item {\n  min-width: 0;\n  display: flex;\n}\n\n.delivery-address-grid-item .payment-delivery-single-delivery-address {\n  width: 100%;\n}\n\n.delivery-address-card-actions {\n  gap: 12px;\n  white-space: nowrap;\n}\n\n.delivery-address-edit-action .edit-delivery-address-button {\n  margin: 0 !important;\n}\n\n.payment-delivery-single-delivery-address {\n  padding: 10px 15px;\n  /* border: 1px solid #d3d3d3; */\n  border-radius: 6px;\n  /* margin: 12px 0; */\n  /* width: 48%; */\n}\n\n.payment-delivery-single-delivery-address > div {\n  display: flex;\n  /* align-items: flex-end; */\n  justify-content: space-between;\n}\n\n@media (min-width: 576px) and (max-width: 991.98px) {\n  .delivery-address-card-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 14px;\n  }\n}\n\n@media (min-width: 992px) {\n  .delivery-address-card-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 16px;\n  }\n}\n\n.payment-delivery-single-delivery-address > .bottom-payment-delivery-address p {\n  cursor: pointer;\n}\n\n.payment-delivery-single-delivery-address\n  > .bottom-payment-delivery-address\n  > img {\n  object-fit: contain;\n  width: 15px;\n  cursor: pointer;\n}\n\n.payment-delivery-single-delivery-address\n  > .top-payment-delivery-address\n  > img {\n  object-fit: contain;\n  width: 20px;\n}\n\n.payment-delivery-single-delivery-address > .middle-payment-delivery-address {\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin: 10px 0 0 0;\n  /* width: 240px; */\n}\n\n.payment-delivery-single-delivery-address\n  > .middle-payment-delivery-address\n  > span {\n  color: #232323;\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px;\n}\n\n.payment-delivery-single-delivery-address\n  > .middle-payment-delivery-address\n  > p {\n  color: #212121;\n  font-family: QuicksandRegular !important;\n  font-size: 14px;\n}\n\n.payment-delivery-single-delivery-address\n  .bottom-payment-delivery-address\n  > Button {\n  text-transform: capitalize;\n  color: #0a64f9;\n  font-family: QuicksandSemiBold !important;\n  font-size: 13px;\n  border-radius: 4px;\n}\n\n.payment-delivery-single-delivery-address\n  .bottom-payment-delivery-address\n  > span {\n  background: #ff57570f;\n  border: 0.5px solid #ff5757;\n  border-radius: 4px;\n  color: #ff5757;\n  font-size: 10px;\n  /* font-size: clamp(8px, 0.05px + 2.6783vw, 10px) !important; */\n\n  font-family: QuicksandSemiBold !important;\n  padding: 0px 10px;\n}\n\n.billingaddrss-error-on-payment {\n  background: #ff57570f;\n  border: 0.5px solid #ff5757;\n  border-radius: 4px;\n  color: #ff5757;\n  font-size: 11px;\n  font-family: QuicksandSemiBold !important;\n  padding: 6px;\n}\n\n.quickvee-tip-selection-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  /* height: 70px; */\n  /* margin: 15px 0; */\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n@keyframes fadeTipIn {\n  0% {\n    right: -300px;\n    width: 100%;\n  }\n\n  100% {\n    right: 0;\n    width: 100%;\n  }\n}\n\n.quickvee-tip-custom {\n  width: 100%;\n  position: relative;\n  animation: fadeTipIn 0.6s;\n}\n\n.quickvee-tip-percents {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.quickvee-tip-percents span {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff 0 0 no-repeat padding-box;\n  border: 2px solid #dedede;\n  border-radius: 6px;\n  color: #1e1e1e;\n  font-family: QuicksandBold !important;\n  font-size: 14px;\n  padding: 9px 0;\n}\n\n.quickvee-tip-percents span:not(:last-child) {\n  margin: 0 2% 0 0;\n}\n\n.quickvee-tip-percents span p {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.quickvee-tip-percents .custom-tip-with-values {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  box-shadow: 0px 8px 12px #0a64f926;\n  border: 2px solid #0a64f9;\n  border-radius: 6px;\n  padding: 9px 0;\n  /* padding: 2% 3%; */\n}\n\n.payment-add-update-tip {\n  /* visibility: hidden; */\n  position: absolute;\n  right: 3px;\n  top: 8px;\n  background-color: #fff;\n  color: #0a64f9;\n  font-size: 14px;\n  font-family: QuicksandBold !important;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  padding: 10px;\n}\n\n#tip-input:not(:placeholder-shown) ~ .payment-add-update-tip {\n  visibility: visible !important;\n}\n\n.quickvee-tip-percents .selected-tip {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  box-shadow: 0px 8px 12px #0a64f926;\n  border: 2px solid #0a64f9;\n  border-radius: 6px;\n}\n\n.payment-delivery-payment-info-section {\n  /* height: 400px; */\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.payment-delivery-payment-info-section > span {\n  color: #212121;\n  text-transform: capitalize;\n  font-size: 20px;\n  font-family: QuicksandBold !important;\n  margin-bottom: 5px;\n}\n\n.payment-delivery-payment-info-section > p {\n  margin: 10px 0;\n  color: #202020;\n  font-size: 13px;\n  font-family: QuicksandMedium !important;\n}\n\n.payment-delivery-payment-info-section > .quickvee-payment-cards-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.div-for-payment-header-and-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.quickvee-single-payment-card {\n  background-color: #ffff;\n  z-index: 2;\n}\n\n.payment-delivery-payment-info-section\n  > .quickvee-payment-cards-section\n  > .quickvee-single-payment-card {\n  padding: 10px 15px;\n  border: 1px solid #d3d3d3;\n  border-radius: 6px;\n  margin: 2% 0;\n  width: 48%;\n  height: 110px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.single-payment-icon-edit {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.single-payment-detail-select {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n\n.payment-delivery-payment-info-section\n  .quickvee-payment-cards-section\n  .quickvee-single-payment-card\n  .single-payment-detail {\n  margin: 5px 0;\n}\n\n.css-i4bv87-MuiSvgIcon-root {\n  font-size: 20px !important;\n}\n\n.quickvee-payment-cards-section\n  .quickvee-single-payment-card\n  .single-payment-detail\n  > span {\n  font-size: 14px;\n  font-family: QuicksandSemibold !important;\n}\n\n.single-payment-detail > p {\n  font-size: 12px;\n  text-align: start;\n  font-family: QuicksandRegular !important;\n}\n\n.payment-delivery-payment-info-section\n  .quickvee-payment-cards-section\n  .quickvee-single-payment-card\n  .single-payment-select {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.quickvee-payment-cards-section\n  .quickvee-single-payment-card\n  .single-payment-select\n  > * {\n  color: #0a64f9;\n  font-family: QuicksandSemiBold !important;\n  text-transform: capitalize !important;\n  font-size: 15px;\n  padding: 0;\n  margin: 0px;\n}\n\n.payment-card-details-add-section {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-between !important;\n  width: 100%;\n}\n\n.payment-card-details-add-section > div {\n  width: 49.5% !important;\n}\n\n.quickvee-old-card-detail {\n  display: none;\n}\n\n.quickvee-new-add-card-detail {\n  display: none;\n  border-bottom: 1px solid #e2e8ed;\n  padding-bottom: 16px !important;\n  margin-bottom: 10px;\n}\n\n.addoldpayment {\n  display: flex;\n  animation: fadeInPayment 0.6s !important;\n}\n\n.removeoldpayment {\n  display: flex;\n  animation: fadeOutPayment 0.6s !important;\n  width: 0px;\n  height: 0px;\n  opacity: 0;\n  z-index: 0;\n}\n\n@keyframes fadeInPayment {\n  0% {\n    opacity: 0;\n    height: 0px;\n  }\n\n  100% {\n    opacity: 1;\n    height: 50px;\n  }\n}\n\n@keyframes fadeOutPayment {\n  0% {\n    opacity: 1;\n    height: 50px;\n    width: 100%;\n  }\n\n  10% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n    height: 0px;\n    width: 0px;\n  }\n}\n\n.addnewpayment {\n  display: flex;\n  flex-direction: column;\n  animation: fadeInPaymentNew 0.6s !important;\n}\n\n.removenewpayment {\n  display: flex;\n  animation: fadeOutPaymentNew 0.6s !important;\n  width: 0px;\n  height: 0px;\n  opacity: 0;\n  z-index: 0;\n  display: none;\n}\n@keyframes fadeInPaymentNew {\n  0% {\n    opacity: 0;\n    height: 0px;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n    height: 120px;\n  }\n}\n\n@media (max-width: 768px) {\n  @keyframes fadeInPaymentNew {\n    0% {\n      opacity: 0;\n      height: 0px;\n    }\n\n    50% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n      height: 200px;\n    }\n  }\n}\n\n@keyframes fadeOutPaymentNew {\n  0% {\n    opacity: 1;\n    height: 80px;\n    width: 100%;\n  }\n\n  20% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n    height: 0px;\n    width: 0px;\n  }\n}\n\n.payment-old-radio-select {\n  border-radius: 4px !important;\n}\n\n.payment-old-radio-select > span:nth-child(1) {\n  display: none;\n}\n\n.payment-old-radio-select > span:nth-child(2) {\n  color: #0a64f9 !important;\n  font-size: 14px !important;\n  font-family: QuicksandSemiBold !important;\n}\n\n.payment-old-radio-select.selected > span:nth-child(2) {\n  padding: 5px 10px;\n}\n\n/* .payment-card-details-add-section-single-item {\n  margin: 5px 10px 5px 0px;\n  } */\n\n/* .payment-card-details-card-num {\n  width: 275px !important;\n} */\n\n/* .payment-card-details-expiredate>div>div {\n  width: 130px !important;\n  min-width: auto !important;\n\n} */\n.payment-card-details-expiredate\n  .css-1xhypcz-MuiStack-root\n  > .MuiTextField-root {\n  min-width: 134px;\n}\n\n/* .payment-card-details-cvv {\n  width: 130px !important;\n\n} */\n\n.payment-card-details-add-section-single-item {\n  overflow: hidden;\n}\n\n.payment-card-detail-single-item-date-cvv {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.payment-card-detail-single-item-date-cvv > div {\n  width: 49% !important;\n}\n\n.payment-card-details-expiredate .css-1gtlbg0 > .MuiTextField-root {\n  min-width: 100px !important;\n}\n\n.quickvee-new-payment-card {\n  width: 100%;\n  margin: 10px 0;\n}\n\n.payment-card-detail-save-checkbox > span:nth-child(2) {\n  color: #222222 !important;\n  font-size: 12px !important;\n  font-family: QuicksandMedium !important;\n}\n\n.payment-radio-heading span:nth-child(2) {\n  cursor: pointer;\n  font-size: 16px !important;\n  /* font-family: QuicksandBold !important; */\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n  appearance: none;\n  -moz-appearance: textfield;\n}\n\n.the-state-input-in-cart\n  > .css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {\n  color: #0a64f9 !important;\n}\n\n/* end cart and payment */\n\n/* Start Main Home page Search Bar */\n.home-top-bar-search {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  background: #f6f7f8;\n  border-radius: 6px;\n  margin-bottom: 180px;\n  width: 100%;\n}\n\n.home-top-bar-search > .home-top-bar-search-input {\n  background: #f6f7f8;\n  padding: 3px 20px;\n  width: 100% !important;\n}\n\n.home-top-bar-search > .home-top-bar-search-input,\n.home-top-bar-search > .home-top-bar-search-input:focus,\n.home-top-bar-search > .home-top-bar-search-input:active,\n.home-top-bar-search > .home-top-bar-search-input:focus-within,\n.home-top-bar-search > .home-top-bar-search-input:focus-visible {\n  border: none;\n  border-color: none !important;\n}\n\n.home-top-bar-search > .home-top-bar-search-input::placeholder {\n  font-family: QuicksandRegular, 'Quicksand' !important;\n  font-size: 15px;\n  color: #a8a8a8;\n}\n\n.home-top-bar-search-icon {\n  rotate: 0deg;\n  margin-right: 12px;\n}\n\n.home-top-bar-search-input::after,\n.home-top-bar-search-input::before {\n  border: none !important;\n}\n\n/* End Main Home Page Search Bar */\n\n/* start payment page coupon new ui */\n.quickvee-shop-coupon {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.payment-summary-field {\n  width: 100%;\n  margin-bottom: 5px;\n}\n\n.payment-summary-action-row {\n  display: flex;\n  width: 100%;\n  align-items: stretch;\n  gap: 10px;\n}\n\n.payment-summary-action-row > .MuiFormControl-root {\n  flex: 1 1 0;\n  width: auto;\n  min-width: 0;\n}\n\n.quickvee-shop-coupon .payment-summary-apply-btn {\n  position: static;\n  flex: 0 0 auto;\n  min-width: 112px;\n  height: 51px;\n  padding: 0 18px;\n  border: 1px solid #0a64f9;\n  border-radius: 10px;\n  background: #0a64f9;\n  color: #ffffff;\n  font-family: QuicksandBold, 'Quicksand', sans-serif !important;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  transition:\n    background-color 160ms ease,\n    border-color 160ms ease,\n    box-shadow 160ms ease;\n}\n\n.quickvee-shop-coupon .payment-summary-apply-btn:hover {\n  border-color: #0854d1;\n  background: #0854d1;\n}\n\n/* .quickvee-shop-coupon .payment-remove-coupon{\n  visibility: hidden;\n}\n#coupon-input:not(:placeholder-shown) .quickvee-shop-coupon .payment-remove-coupon{\nvisibility: visible;\n} */\n\n.quickvee-shop-coupon .payment-apply-coupon {\n  visibility: hidden;\n}\n\n#coupon-input:not(:placeholder-shown) ~ .payment-apply-coupon {\n  visibility: visible;\n}\n\n.quickvee-shop-coupon .payment-summary-remove-btn {\n  position: static;\n  flex: 0 0 auto;\n  min-width: 112px;\n  height: 51px;\n  padding: 0 18px;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  background: #fff5f5;\n  color: #d92d20;\n  font-family: QuicksandBold, 'Quicksand', sans-serif !important;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  transition:\n    background-color 160ms ease,\n    border-color 160ms ease,\n    box-shadow 160ms ease;\n}\n\n.quickvee-shop-coupon .payment-summary-remove-btn:hover {\n  border-color: #fda29b;\n  background: #fee4e2;\n}\n\n.quickvee-shop-coupon .payment-summary-apply-btn:focus-visible,\n.quickvee-shop-coupon .payment-summary-remove-btn:focus-visible {\n  outline: 3px solid rgba(10, 100, 249, 0.22);\n  outline-offset: 2px;\n}\n\n.quickvee-shop-coupon-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin: 0px 0px 8px 0px;\n}\n\n.quickvee-shop-coupon-header > span:first-child,\n.quickvee-shop-coupon-title {\n  display: flex;\n  align-items: center;\n  color: #232323;\n  /* font-size: 14px;\n  font-family: QuicksandBold !important; */\n}\n\n.quickvee-shop-coupon-heading {\n  display: flex;\n  min-width: 0;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 3px 6px;\n}\n\n.quickvee-shop-coupon-title {\n  font-family: QuicksandSemiBold, 'Quicksand', sans-serif !important;\n}\n\n.quickvee-shop-coupon-balance {\n  color: #667085;\n  font-size: 14px;\n  font-family: QuicksandSemiBold, 'Quicksand', sans-serif !important;\n}\n\n@media (max-width: 430px) {\n  .payment-summary-action-row {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .quickvee-shop-coupon .payment-summary-apply-btn,\n  .quickvee-shop-coupon .payment-summary-remove-btn {\n    width: 100%;\n    min-width: 0;\n    height: 48px;\n  }\n\n  .quickvee-shop-coupon-balance {\n    flex-basis: 100%;\n  }\n}\n\n.quickvee-shop-coupon .payment-summary-input {\n  width: 100%;\n  outline: none;\n  border: none;\n  background: #ffffff;\n  padding: 12px 10px;\n  border: 1px solid #d3d3d3;\n  border-radius: 6px;\n  color: #000000;\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px;\n}\n\n.quickvee-shop-coupon .payment-summary-input::placeholder {\n  font-family: QuicksandSemiBold !important;\n  color: #595959;\n  font-size: 12px;\n}\n\n.quickvee-shop-coupon .payment-summary-input:not(:placeholder-shown) {\n  border: 1px solid #000000;\n}\n\n.quickvee-shop-coupon .payment-summary-input:focus {\n  border: 1px solid #000000;\n}\n\n.quickvee-shop-coupon .payment-summary-input-error {\n  display: flex;\n  align-items: center;\n  /* width: 27%; */\n  /* justify-content: center; */\n  font-size: 11px !important;\n  color: #f34747 !important;\n  margin: 5px !important;\n  align-self: flex-start;\n  font-family: 'QuicksandSemiBold', 'Quicksand' !important;\n}\n\n.payment-summary-input-tip {\n  width: 100%;\n  outline: none;\n  border: none;\n  background: #ffffff;\n  padding: 12px 10px;\n  border: 1px solid #d3d3d3;\n  border-radius: 6px;\n  color: #000000;\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px;\n}\n\n.payment-summary-input-tip::placeholder {\n  font-family: QuicksandSemiBold !important;\n  color: #595959;\n  font-size: 12px;\n}\n\n.payment-summary-input-tip:not(:placeholder-shown) {\n  border: 1px solid #000000;\n}\n\n.payment-summary-input-tip:focus {\n  border: 1px solid #000000;\n}\n\n.payment-summary-input-tip-error {\n  font-size: 9px !important;\n  color: #f34747 !important;\n  margin: 5px !important;\n  align-self: flex-start;\n  font-family: QuicksandRegular, 'Quicksand' !important;\n}\n\n.quickvee-shop-coupon-header .tip-cancle-btn {\n  color: #f34747;\n  font-family: QuicksandBold !important;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.custom-tip-section .payment-summary-add-tip {\n  position: absolute;\n  background-color: #fff;\n  outline: none;\n  border: none;\n  color: #0a64f9;\n  font-size: 14px;\n  font-family: QuicksandBold !important;\n  top: 67px;\n  right: 9px;\n  cursor: pointer;\n}\n\n.billing-date-time .css-1thjcug {\n  background: #fff !important;\n  border: 1px solid #d3d3d3 !important;\n  border-radius: 6px !important;\n}\n\n.billing-date-time .css-14x1nlk,\n.billing-date-time .css-1rgmeur {\n  color: #595959 !important;\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px !important;\n}\n\n.billing-date-time .css-ftr4jk {\n  color: #000 !important;\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px !important;\n  padding: 22px 0px 6px 12px !important;\n  /* font-family: QuicksandBold !important; */\n}\n\n.billing-date-time .css-17gq4vl {\n  font-family: QuicksandSemiBold !important;\n  font-size: 14px !important;\n  /* padding: 22px 0px 10px 9px; */\n}\n\n.css-1rgmeur {\n  font-family: QuicksandMedium, Quicksand !important;\n}\n\n.select-varient-cart .css-17gq4vl.MuiSelect-select {\n  color: #0a64f9 !important;\n}\n\n/* end payment page coupon new ui */\n\n.css-10botns-MuiInputBase-input-MuiFilledInput-input {\n  height: 0px !important;\n  padding-bottom: 16px !important;\n}\n\n/* dropdown loyalty point  */\n\n.loyalty-customSelect {\n  background-image: url('../Assets/Payment/dropdown.svg');\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n}\n\n.loyalty-customSelect {\n  border-radius: 8px;\n  padding: 8px 40px 8px 15px;\n  font-family: QuicksandMedium !important;\n  /* margin-right: 8px; */\n  background-color: white;\n  color: #2e2e2e;\n  font-size: 16px;\n}\n\n.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper {\n  /* max-height: calc(50% - 96px) !important; */\n}\n\n#menu-state {\n  height: 300px;\n}\n\n.custom-select {\n  position: relative;\n  /* padding: 8px 15px 8px 15px; */\n  font-family: QuicksandMedium !important;\n  /* margin-right: 8px; */\n  background-color: white;\n  color: #2e2e2e;\n  font-size: 16px;\n  /* width: 200px;  */\n  /* border: 1px solid #000; */\n  /* border-radius: 8px; */\n}\n\n.default-option {\n  cursor: pointer;\n  padding: 5px 0px 5px 5px;\n  width: 100%;\n  border-radius: 5px;\n  display: flex;\n  align-items: center; /* Align items vertically */\n  /* justify-content: space-between; */\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  width: 100% !important;\n}\n\n.select-ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  width: 200px;\n  position: absolute;\n  background-color: #ffffff;\n  border: 1px solid #fff;\n  border-radius: 5px;\n  box-shadow: 0px 6px 15px #0a64f94d;\n  border-bottom: 1px solid #e1e1e1;\n  margin-top: 5%;\n  margin-left: -100px;\n}\n\n.select-ul li:not(:last-child) {\n  border-bottom: 1px solid #e1e1e1;\n}\n.select-ul li {\n  cursor: pointer;\n  padding: 12px;\n}\n\n.select-ul li:hover {\n  background-color: #f0f0f0;\n}\n.option .filter {\n  width: 100% !important;\n}\n\n.lablePickup span {\n  /* font-family: 'QuicksandSemiBold' !important; */\n}\n\n.payment-error-msg {\n  font-family: QuicksandBold !important;\n  padding: 0px 25px;\n}\n\n.load-more-btn {\n  /* padding: 6px 16px; */\n  font-weight: 500;\n  font-size: 15px;\n  border-radius: 4px;\n  border: 1px solid #0a64f9;\n  background-color: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 110px;\n  height: 40px;\n}\n\n.load-more-btn span {\n  height: 25px !important;\n  width: 25px !important;\n}\n\n.flex {\n  display: flex;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.mb-6 {\n  margin-bottom: 24px;\n}\n\n.shareImageContainer {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n  margin: 1rem;\n}\n.shareicon {\n  min-width: 0;\n  min-height: 92px;\n  padding: 8px 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  background: transparent;\n}\n.shareicon:hover {\n  border-color: #d7e5f7;\n  background: #f5f9ff;\n}\n.shareicon:focus-visible {\n  outline: 3px solid rgba(10, 100, 249, 0.24);\n  outline-offset: 2px;\n}\n.shareicon img {\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n}\n.shareicon span {\n  max-width: 100%;\n  overflow: hidden;\n  color: #1d2939;\n  font-size: 13px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.shareicon p,\n.copyContainer p {\n  font-weight: 500;\n  font-size: 13px;\n}\n.share-modal {\n  border: none !important;\n}\n.copyContainer {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n  border-radius: 12px;\n  margin: 1rem;\n  padding: 10px;\n  border: 1px solid #d9d9d9;\n  align-items: center;\n}\n.copyContainer p {\n  min-width: 0;\n  flex: 1;\n  margin: 0;\n  overflow: hidden;\n  color: #000000;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 560px) {\n  .shareImageContainer {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  .shareicon {\n    min-height: 84px;\n  }\n\n  .shareicon img {\n    width: 52px;\n    height: 52px;\n  }\n}\n\n@media (max-width: 340px) {\n  .shareImageContainer {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .copyContainer {\n    margin: 12px;\n  }\n}\n\n/* Custom Scrollbar */\n.customScrollbar {\n  overflow-y: auto;\n  scrollbar-width: thin; /* Firefox */\n  scrollbar-color: #3e85f8 #eee; /* Firefox */\n}\n\n/* Chrome / Safari / Edge */\n.customScrollbar::-webkit-scrollbar {\n  width: 3px;\n}\n\n.customScrollbar::-webkit-scrollbar-track {\n  background: #eee;\n  border-radius: 10px;\n}\n\n.customScrollbar::-webkit-scrollbar-thumb {\n  background: #3e85f8;\n  border-radius: 10px;\n  transition: background 0.3s ease-in-out;\n}\n\n.customScrollbar::-webkit-scrollbar-thumb:hover {\n  background: #246be0;\n}\n/* New Landing Page */\n\n.hero-address-input { padding-left: 2.5rem !important; }\n\n\n.landing-footer {\n  ul {\n    padding: 0;\n  }\n  a{color: #AEB6C8}\n  a:hover {color: #ffffff; }\n}\n\n/* Uber delivery intro modal */\n/* body.uber-delivery-modal-open #root {\n  filter: blur(5px);\n} */\n\n.uber-delivery-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n}\n\n.uber-delivery-modal {\n  background: #ffffff;\n  border-radius: 16px;\n  /* padding: 32px; */\n  max-width: 520px;\n  /* width: 90%; */\n  box-shadow: 0px 30px 80px rgba(15, 23, 42, 0.3);\n  position: relative;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.uber-delivery-modal-close-wrapper {\n  display: flex;\n  height: 48px;\n  padding: 16px 16px 0 0;\n  justify-content: flex-end;\n  align-items: flex-start;\n  align-self: stretch;\n}\n\n.uber-delivery-modal-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.uber-delivery-modal-logo-description-content-wrapper {\n  display: flex;\n  padding: 0 32px;\n  flex-direction: column;\n  align-items: center;\n  gap: 36px;\n  align-self: stretch;\n}\n.uber-delivery-modal-logo-wrapper {\n  display: flex;\n  padding-top: 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.uber-delivery-modal-logo {\n  height: 46px;\n  width: auto;\n}\n\n.uber-delivery-modal-close {\n  width: 20px;\n  height: 20px;\n}\n\n.uber-delivery-modal-close img {\n  width: 10px;\n  height: 10px;\n}\n\n.uber-delivery-modal-icon-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.uber-delivery-modal-icon-circle {\n  width: 64px;\n  height: 64px;\n  border-radius: 999px;\n  background: #000000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.uber-delivery-modal-icon-circle img {\n  width: 32px;\n  height: 32px;\n}\n\n.uber-delivery-modal-title {\n  display: none;\n}\n\n.uber-delivery-modal-description {\n  margin: 0 auto 36px;\n  max-width: 358px;\n  text-align: center;\n  color: #101828;\n  font-family:\n    'Jost',\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 22.4px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 29.12px; /* 130% */\n  letter-spacing: -0.15px;\n}\n\n.uber-delivery-modal-description-strong {\n  font-weight: 700;\n}\n\n.uber-delivery-modal-primary {\n  display: flex;\n  padding: 12px 134px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 14px;\n  background: #000;\n  color: #fff;\n  text-align: center;\n  font-family: Jost;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px; /* 150% */\n}\n\n.uber-delivery-modal-primary:hover {\n  background: #111111;\n}\n\n.uber-delivery-modal-secondary {\n  background: transparent;\n  border: none;\n  margin-top: 16px;\n  color: #99a1af;\n  font-family:\n    'Jost',\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 13.6px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20.4px; /* 150% */\n  cursor: pointer;\n}\n\n.uber-delivery-modal-secondary:hover {\n  color: #4b5563;\n}\n\n@media (max-width: 767.98px) {\n  .uber-delivery-modal {\n    width: 90%;\n  }\n\n  .uber-delivery-modal-primary {\n    width: 100%;\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .uber-delivery-modal-button-wrapper{\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .uber-delivery-modal {\n    padding: 24px 20px 20px;\n    border-radius: 12px;\n  }\n\n  .uber-delivery-modal-title {\n    font-size: 20px;\n  }\n\n  .uber-delivery-modal-description {\n    font-size: 18px;\n    line-height: 24px;\n  }\n}\n\n.uber-delivery-modal-button-wrapper {\n  display: flex;\n  padding-bottom: 32px;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
